var map_lib =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(26);
	__webpack_require__(11);
	__webpack_require__(7);
	__webpack_require__(12);
	__webpack_require__(10);
	__webpack_require__(14);
	__webpack_require__(13);
	__webpack_require__(9);
	__webpack_require__(8);
	__webpack_require__(24);
	__webpack_require__(15);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  var Action, RouteSnapshot, ActionChain, ActionsManager;
	
	  // undo/executable action
	  Action = function Action(executeFn, undoFn) {
	    this.name = "Default";
	    this.undo = undoFn;
	    this.execute = executeFn;
	    this.next = this.prev = null;
	  };
	
	  // record history point with ability to fully restore route
	  RouteSnapshot = function RouteSnapshot(map, serialized) {
	    this.name = "RouteSnapshot";
	    this.map = map;
	    this.serialized = serialized;
	  };
	  RouteSnapshot.prototype.restore = function () {
	    this.map.clearMap();
	    this.map.routes = [];
	    if (this.serialized.routes) {
	      var map = this.map;
	      _.each(this.serialized.routes, function (routeSerialized) {
	        var route = new rwgps.Route(routeSerialized, this.map, { planning: true });
	        route.routeData = routeSerialized.routeData;
	        route.tripData = routeSerialized.tripData;
	        if (routeSerialized.active) map.addRoute(route, true);else map.addRoute(route);
	      }, this);
	    } else {
	      // support old serialization that supported only one route
	      // once we deploy the multi-route support, we don't want the route planner
	      // to bust for users that have a saved route from prior to release
	      this.map.loadRouteForEdit(this.serialized, true);
	    }
	    this.map.saveSnapshotLocally(this);
	  };
	  RouteSnapshot.prototype.execute = RouteSnapshot.prototype.restore;
	
	  // arguments are a list of actions to compose linearly, and will
	  // undo/execute as a group
	  ActionChain = function ActionChain() {
	    this.actions = _.toArray(arguments);
	    this.next = this.prev = null;
	  };
	  _.extend(ActionChain.prototype, {
	    undo: function undo() {
	      for (var i = this.actions.length - 1; i >= 0; --i) {
	        this.actions[i].undo();
	      }
	    },
	    execute: function execute() {
	      for (var i = 0; i < this.actions.length; ++i) {
	        this.actions[i].execute();
	      }
	    }
	  });
	
	  // implement undo manager as doubly linked list
	  ActionsManager = function ActionsManager() {
	    this.curr = null;
	  };
	  _.extend(ActionsManager.prototype, {
	    printDebug: function printDebug() {
	      var curr = this.curr,
	          lastAction;
	      if (!curr) {
	        console.log("EMPTY ACTIONS"); // eslint-disable-line no-console
	        return;
	      }
	      // find head
	      while (curr.prev) {
	        curr = curr.prev;
	      }
	      // print in order
	      do {
	        lastAction = this.curr === curr;
	        console.log("NAME " + curr.name, "UNDO " + !!curr.undo, "REDO " + !!curr.execute, "NEXT " + !!curr.next, "PREV " + !!curr.prev, "ISLAST? " + lastAction); // eslint-disable-line no-console
	      } while (curr = curr.next); // eslint-disable-line no-cond-assign
	    },
	    execute: function execute(action) {
	      action.execute();
	      this.add(action);
	    },
	    clear: function clear() {
	      this.curr = null;
	    },
	    chain: function chain(action) {
	      if (!this.curr) {
	        this.add(action);
	      } else if (this.curr.restore && action.restore) {
	        // update the snapshot
	        this.curr.serialized = action.serialized;
	      } else {
	        console.warn("Need to implement use of ActionChain for non-snapshot chaining"); // eslint-disable-line no-console
	      }
	    },
	    add: function add(action) {
	      if (action.undo || this.curr && this.curr.restore) {
	        action.prev = this.curr;
	        if (this.curr) this.curr.next = action;
	      }
	      this.curr = action;
	    },
	    manualUndoTo: function manualUndoTo(action) {
	      // assumes we're working with snapshots.
	      // undo functionality was overridden, so inject this snapshot in
	      // and move curr back as if undo took place properly
	      if (this.curr) {
	        if (this.curr.prev) {
	          this.curr.prev.next = action;
	          action.prev = this.curr.prev;
	        }
	        this.curr.prev = action;
	        action.next = this.curr;
	      }
	      this.curr = action;
	    },
	    noopAction: function noopAction(nextAction) {
	      var noopAction = new Action(function () {});
	      noopAction.name = "noop";
	      noopAction.next = nextAction;
	      return noopAction;
	    },
	    canUndo: function canUndo() {
	      return this.curr && (this.curr.prev && this.curr.prev.restore || this.curr.undo);
	    },
	    revert: function revert() {
	      if (this.curr && this.curr.restore) this.curr.restore();
	    },
	    undo: function undo() {
	      if (!this.curr) return;
	      // if last state is a full restore, don't perform undo just
	      // perform restore
	      if (this.curr.prev && this.curr.prev.restore) {
	        this.curr = this.curr.prev;
	        this.curr.restore();
	      } else if (this.curr.undo) {
	        // undo and step back in history
	        this.curr.undo();
	        if (this.curr.prev) {
	          this.curr = this.curr.prev;
	        } else {
	          // we're at the start of history, so inject a noop action
	          this.curr = this.noopAction(this.curr);
	        }
	      }
	    },
	    redo: function redo() {
	      if (!this.curr || !this.curr.next) return;
	      // step forward and execute
	      this.curr = this.curr.next;
	      this.curr.execute();
	    }
	  });
	
	  module.exports = {
	    Action: Action,
	    RouteSnapshot: RouteSnapshot,
	    ActionChain: ActionChain,
	    ActionsManager: ActionsManager
	  };
	})();

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	rwgps = window.rwgps || {};
	
	rwgps.BaseMap = function () {};
	rwgps.BaseMap.prototype = {
	  setProvider: function setProvider(provider, map) {
	    this.provider = provider;
	    this.map = map;
	    rwgps.Events.trigger("maps:provider:changed", provider, map);
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	rwgps = window.rwgps || {};
	
	rwgps.Bitmask = function () {};
	rwgps.Bitmask.prototype = {
	  //this is naive and assumes only one option in the group is set
	  //which is how it should be...
	  getSetGroupOption: function getSetGroupOption(group) {
	    var set;
	    _.each(this.stuff, function (obj, key) {
	      if (obj.group == group && obj.val > 0) {
	        set = key;
	      }
	    });
	    return set;
	  },
	  setOptions: function setOptions(opts) {
	    _.each(this.stuff, function (obj) {
	      obj.val = opts & obj.mask;
	    });
	  },
	  getOptions: function getOptions() {
	    var val = 0;
	    _.each(this.stuff, function (obj) {
	      val = val | obj.val;
	    });
	    return val;
	  },
	  setOption: function setOption(opt, val) {
	    var entry = this.stuff[opt];
	    if (entry) {
	      if (entry.group) {
	        _.each(this.stuff, function (obj) {
	          //deselect all entries in the same group
	          if (obj.group == entry.group) obj.val = 0;
	        });
	      }
	      entry.val = val ? entry.mask : 0;
	    }
	  },
	  getOption: function getOption(opt) {
	    //no sanity check, since i want an exception if this is misused
	    return this.stuff[opt].val & this.stuff[opt].mask;
	  }
	};
	rwgps.Bitmask.Planner = function (opts) {
	  //if entries share the same group, they act as radio buttons - meaning
	  //setting one will automatically deselect any others in the same group.
	  this.stuff = {
	    //google basemaps
	    roadmap: { mask: 1, val: 1, group: "basemaps" }, //default to gmaps, so val is 1
	    terrain: { mask: 2, val: 0, group: "basemaps" },
	    satellite: { mask: 4, val: 0, group: "basemaps" },
	    hybrid: { mask: 8, val: 0, group: "basemaps" },
	    //custom basemaps
	    rwgps: { mask: 16, val: 0, group: "basemaps" },
	    osm: { mask: 32, val: 0, group: "basemaps" },
	    osmCycle: { mask: 64, val: 0, group: "basemaps" },
	    esriTopo: { mask: 128, val: 0, group: "basemaps" },
	    usgsTopo: { mask: 256, val: 0, group: "basemaps" },
	    giTopo: { mask: 512, val: 0, group: "basemaps" },
	    osmOutdoor: { mask: 1024, val: 0, group: "basemaps" },
	    usgsTopoLegacy: { mask: 2048, val: 0, group: "basemaps" },
	    //4096 is baselayer placeholder
	    //layers now
	    gmapsBikeOverlay: { mask: 8192, val: 0 },
	    giSkiOverlay: { mask: 16384, val: 0 },
	    overrideUnits: { mask: 32768, val: 0 },
	    metricUnits: { mask: 65536, val: 0 }
	  };
	  if (opts) this.setOptions(opts);
	};
	rwgps.Bitmask.Planner.prototype = new rwgps.Bitmask();
	
	rwgps.ClickOptions = function (opts) {
	  this.CYCLING_MODE_MASK = 1;
	  this.WALKING_MODE_MASK = 2;
	  this.DRIVING_MODE_MASK = 4;
	  this.AVOID_HIGHWAYS_MASK = 8;
	  this.FOLLOW_ROADS_MASK = 16;
	  this.AVOID_TUNNELS_MASK = 32;
	  this.GMAPS_MASK = 64;
	  this.OSM_MASK = 128;
	  this.ARCGIS_MASK = 256;
	  this.GI_MASK = 512;
	  this.AVOID_CARS_ONLY_MASK = 1024;
	  this.AVOID_FERRIES_MASK = 2048;
	  this.AVOID_ONEWAYS_MASK = 4096;
	  this.AVOID_DIRT_ROADS_MASK = 8192;
	  this.AVOID_TRAILS_MASK = 16384;
	  this.AVOID_WATER_MASK = 32768;
	  this.CYCLING_EXPERIMENT_MODE_MASK = 65536;
	
	  this._cyclingMode = this.CYCLING_MODE_MASK; //default
	  this._cyclingExperimentMode = 0;
	  this._walkingMode = 0;
	  this._drivingMode = 0;
	  this._avoidHighways = 0;
	  this._avoidTunnels = 0;
	  this._avoidCarsOnly = 0;
	  this._avoidFerries = 0;
	  this._avoidOneWays = 0;
	  this._avoidTrails = 0;
	  this._avoidDirtRoads = 0;
	  this._avoidWater = 0;
	  this._followRoads = this.FOLLOW_ROADS_MASK; //default
	  this._gmaps = this.GMAPS_MASK;
	  this._osm = 0;
	  this._arcgis = 0;
	  this._gi = 0;
	
	  if (opts !== undefined) this.setOptions(opts);
	};
	
	rwgps.ClickOptions.prototype = {
	  setOptions: function setOptions(opts) {
	    this._cyclingMode = opts & this.CYCLING_MODE_MASK;
	    this._cyclingExperimentMode = opts & this.CYCLING_EXPERIMENT_MODE_MASK;
	    this._walkingMode = opts & this.WALKING_MODE_MASK;
	    this._drivingMode = opts & this.DRIVING_MODE_MASK;
	    this._avoidOneWays = opts & this.AVOID_ONEWAYS_MASK;
	    this._avoidHighways = opts & this.AVOID_HIGHWAYS_MASK;
	    this._avoidTunnels = opts & this.AVOID_TUNNELS_MASK;
	    this._avoidFerries = opts & this.AVOID_FERRIES_MASK;
	    this._avoidDirtRoads = opts & this.AVOID_DIRT_ROADS_MASK;
	    this._avoidTrails = opts & this.AVOID_TRAILS_MASK;
	    this._avoidCarsOnly = opts & this.AVOID_CARS_ONLY_MASK;
	    this._avoidWater = opts & this.AVOID_WATER_MASK;
	    this._followRoads = opts & this.FOLLOW_ROADS_MASK;
	    this._gmaps = opts & this.GMAPS_MASK;
	    this._osm = opts & this.OSM_MASK;
	    this._arcgis = opts & this.ARCGIS_MASK;
	    this._gi = opts & this.GI_MASK;
	
	    //ensure we always have some mode for direction requests,
	    //just in case we have a bum options field
	    if ((this._cyclingMode | this._cyclingExperimentMode | this._walkingMode | this._drivingMode) == 0) this._drivingMode = 1;
	    if ((this._gi | this._arcgis | this._osm | this._gmaps) == 0) this._gmaps = this.GMAPS_MASK;
	  },
	  setPartialOptions: function setPartialOptions(opts) {
	    if (opts & this.CYCLING_MODE_MASK) this._cyclingMode = opts & this.CYCLING_MODE_MASK;
	    if (opts & this.CYCLING_EXPERIMENT_MODE_MASK) this._cyclingExperimentMode = opts & this.CYCLING_EXPERIMENT_MODE_MASK;
	    if (opts & this.WALKING_MODE_MASK) this._walkingMode = opts & this.WALKING_MODE_MASK;
	    if (opts & this.DRIVING_MODE_MASK) this._drivingMode = opts & this.DRIVING_MODE_MASK;
	    if (opts & this.AVOID_ONEWAYS_MASK) this._avoidOneWays = opts & this.AVOID_ONEWAYS_MASK;
	    if (opts & this.AVOID_HIGHWAYS_MASK) this._avoidHighways = opts & this.AVOID_HIGHWAYS_MASK;
	    if (opts & this.AVOID_TUNNELS_MASK) this._avoidTunnels = opts & this.AVOID_TUNNELS_MASK;
	    if (opts & this.AVOID_FERRIES_MASK) this._avoidFerries = opts & this.AVOID_FERRIES_MASK;
	    if (opts & this.AVOID_DIRT_ROADS_MASK) this._avoidDirtRoads = opts & this.AVOID_DIRT_ROADS_MASK;
	    if (opts & this.AVOID_TRAILS_MASK) this._avoidTrails = opts & this.AVOID_TRAILS_MASK;
	    if (opts & this.AVOID_CARS_ONLY_MASK) this._avoidCarsOnly = opts & this.AVOID_CARS_ONLY_MASK;
	    if (opts & this.AVOID_WATER_MASK) this._avoidWater = opts & this.AVOID_WATER_MASK;
	    if (opts & this.FOLLOW_ROADS_MASK) this._followRoads = opts & this.FOLLOW_ROADS_MASK;
	    if (opts & this.GMAPS_MASK) this._gmaps = opts & this.GMAPS_MASK;
	    if (opts & this.OSM_MASK) this._osm = opts & this.OSM_MASK;
	    if (opts & this.ARCGIS_MASK) this._arcgis = opts & this.ARCGIS_MASK;
	    if (opts & this.GI_MASK) this._gi = opts & this.GI_MASK;
	  },
	  getProviderOptions: function getProviderOptions() {
	    return this._gmaps & this.GMAPS_MASK | this._osm & this.OSM_MASK | this._arcgis & this.ARCGIS_MASK | this._gi & this.GI_MASK;
	  },
	  getRestrictionOptions: function getRestrictionOptions() {
	    return this._avoidOneWays & this.AVOID_ONEWAYS_MASK | this._avoidHighways & this.AVOID_HIGHWAYS_MASK | this._avoidTunnels & this.AVOID_TUNNELS_MASK | this._avoidFerries & this.AVOID_FERRIES_MASK | this._avoidDirtRoads & this.AVOID_DIRT_ROADS_MASK | this._avoidTrails & this.AVOID_TRAILS_MASK | this._avoidCarsOnly & this.AVOID_CARS_ONLY_MASK | this._avoidWater & this.AVOID_WATER_MASK;
	  },
	  getModeOptions: function getModeOptions() {
	    return this._cyclingMode & this.CYCLING_MODE_MASK | this._cyclingExperimentMode & this.CYCLING_EXPERIMENT_MODE_MASK | this._walkingMode & this.WALKING_MODE_MASK | this._drivingMode & this.DRIVING_MODE_MASK | this._followRoads & this.FOLLOW_ROADS_MASK;
	  },
	  getOptions: function getOptions() {
	    return this.getModeOptions() | this.getRestrictionOptions() | this.getProviderOptions();
	  },
	  getOption: function getOption(opt) {
	    switch (opt) {
	      case "avoidHighways":
	        return this._avoidHighways & this.AVOID_HIGHWAYS_MASK;
	      case "avoidTunnels":
	        return this._avoidTunnels & this.AVOID_TUNNELS_MASK;
	      case "avoidOneWays":
	        return this._avoidOneWays & this.AVOID_ONEWAYS_MASK;
	      case "avoidFerries":
	        return this._avoidFerries & this.AVOID_FERRIES_MASK;
	      case "avoidDirtRoads":
	        return this._avoidDirtRoads & this.AVOID_DIRT_ROADS_MASK;
	      case "avoidTrails":
	        return this._avoidTrails & this.AVOID_TRAILS_MASK;
	      case "avoidCarsOnly":
	        return this._avoidCarsOnly & this.AVOID_CARS_ONLY_MASK;
	      case "avoidWater":
	        return this._avoidWater & this.AVOID_WATER_MASK;
	    }
	    return false;
	  },
	  setOption: function setOption(opt, val) {
	    switch (opt) {
	      case "avoidHighways":
	        this._avoidHighways = val ? this.AVOID_HIGHWAYS_MASK : 0;break;
	      case "avoidTunnels":
	        this._avoidTunnels = val ? this.AVOID_TUNNELS_MASK : 0;break;
	      case "avoidOneWays":
	        this._avoidOneWays = val ? this.AVOID_ONEWAYS_MASK : 0;break;
	      case "avoidFerries":
	        this._avoidFerries = val ? this.AVOID_FERRIES_MASK : 0;break;
	      case "avoidDirtRoads":
	        this._avoidDirtRoads = val ? this.AVOID_DIRT_ROADS : 0;break;
	      case "avoidTrails":
	        this._avoidTrails = val ? this.AVOID_TRAILS_MASK : 0;break;
	      case "avoidCarsOnly":
	        this._avoidCarsOnly = val ? this.AVOID_CARS_ONLY_MASK : 0;break;
	      case "avoidWater":
	        this._avoidWater = val ? this.AVOID_WATER_MASK : 0;break;
	    }
	  },
	  getEnabledRestrictions: function getEnabledRestrictions() {
	    var res = [];
	    if (this._avoidHighways) res.push("avoidHighways");
	    if (this._avoidTunnels) res.push("avoidTunnels");
	    if (this._avoidOneWays) res.push("avoidTunnels");
	    if (this._avoidFerries) res.push("avoidFerries");
	    if (this._avoidDirtRoads) res.push("avoidDirtRoads");
	    if (this._avoidTrails) res.push("avoidTrails");
	    if (this._avoidCarsOnly) res.push("avoidCarsOnly");
	    if (this._avoidWater) res.push("avoidWater");
	    return res;
	  },
	  avoidWater: function avoidWater(val) {
	    if (val === undefined) return this._avoidWater > 0;
	    this._avoidWater = val ? this.AVOID_WATER_MASK : 0;
	  },
	  avoidOneWays: function avoidOneWays(val) {
	    if (val === undefined) return this._avoidOneWays > 0;
	    this._avoidOneWays = val ? this.AVOID_ONEWAYS_MASK : 0;
	  },
	  avoidHighways: function avoidHighways(val) {
	    if (val === undefined) return this._avoidHighways > 0;
	    this._avoidHighways = val ? this.AVOID_HIGHWAYS_MASK : 0;
	  },
	  avoidTunnels: function avoidTunnels(val) {
	    if (val === undefined) return this._avoidTunnels > 0;
	    this._avoidTunnels = val ? this.AVOID_TUNNELS_MASK : 0;
	  },
	  avoidFerries: function avoidFerries(val) {
	    if (val === undefined) return this._avoidFerries > 0;
	    this._avoidFerries = val ? this.AVOID_FERRIES_MASK : 0;
	  },
	  avoidDirtRoads: function avoidDirtRoads(val) {
	    if (val === undefined) return this._avoidDirtRoads > 0;
	    this._avoidDirtRoads = val ? this.AVOID_DIRT_ROADS_MASK : 0;
	  },
	  avoidTrails: function avoidTrails(val) {
	    if (val === undefined) return this._avoidTrails > 0;
	    this._avoidTrails = val ? this.AVOID_TRAILS_MASK : 0;
	  },
	  avoidCarsOnly: function avoidCarsOnly(val) {
	    if (val === undefined) return this._avoidCarsOnly > 0;
	    this._avoidCarsOnly = val ? this.AVOID_CARS_ONLY_MASK : 0;
	  },
	  followRoads: function followRoads(val) {
	    if (val === undefined) return this._followRoads > 0;
	    this._followRoads = val ? this.FOLLOW_ROADS_MASK : 0;
	  },
	  walkingMode: function walkingMode(val) {
	    if (val === undefined) return this._walkingMode > 0;
	    if (val) {
	      this._walkingMode = this.WALKING_MODE_MASK;
	      this._cyclingExperimentMode = 0;
	      this._cyclingMode = 0;
	      this._drivingMode = 0;
	    }
	  },
	  cyclingMode: function cyclingMode(val) {
	    if (val === undefined) return this._cyclingMode > 0;
	    if (val) {
	      this._walkingMode = 0;
	      this._cyclingExperimentMode = 0;
	      this._cyclingMode = this.CYCLING_MODE_MASK;
	      this._drivingMode = 0;
	    }
	  },
	  cyclingExperimentMode: function cyclingExperimentMode(val) {
	    if (val === undefined) return this._cyclingExperimentMode > 0;
	    if (val) {
	      this._walkingMode = 0;
	      this._cyclingExperimentMode = this.CYCLING_EXPERIMENT_MODE_MASK;
	      this._cyclingMode = 0;
	      this._drivingMode = 0;
	    }
	  },
	  drivingMode: function drivingMode(val) {
	    if (val === undefined) return this._drivingMode > 0;
	    if (val) {
	      this._walkingMode = 0;
	      this._cyclingMode = 0;
	      this._cyclingExperimentMode = 0;
	      this._drivingMode = this.DRIVING_MODE_MASK;
	    }
	  },
	  googleRouting: function googleRouting(val) {
	    if (val === undefined) return this._gmaps > 0;
	    this._gmaps = this.GMAPS_MASK;
	    this._osm = 0;
	    this._gi = 0;
	    this._arcgis = 0;
	  },
	  osmRouting: function osmRouting(val) {
	    if (val === undefined) return this._osm > 0;
	    this._gmaps = 0;
	    this._osm = this.OSM_MASK;
	    this._gi = 0;
	    this._arcgis = 0;
	  },
	  arcgisRouting: function arcgisRouting(val) {
	    if (val === undefined) return this._arcgis > 0;
	    this._gmaps = 0;
	    this._osm = 0;
	    this._gi = 0;
	    this._arcgis = this.ARCGIS_MASK;
	  },
	  giRouting: function giRouting(val) {
	    if (val === undefined) return this._gi > 0;
	    this._gmaps = 0;
	    this._osm = 0;
	    this._gi = this.GI_MASK;
	    this._arcgis = 0;
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	rwgps = window.rwgps || {};
	
	rwgps.Router = function (opts) {
	  this.opts = opts;
	  if (opts) {
	    switch (opts.type) {
	      case "google":
	        if (!window.rwgps.config.labs.always_graph_hopper) {
	          return new rwgps.Router.Google(opts);
	        } // otherwise fall through to rwgps routing below
	      case "rwgps":
	        return new rwgps.Router.RWGPSCombined(opts);
	      case "arcgis":
	        return new rwgps.Router.ArcGIS(opts);
	    }
	  }
	};
	rwgps.Router.euclideanDistance = function (a, b) {
	  return Math.pow(Math.pow(a.lat - b.lat, 2) + Math.pow(a.lng - b.lng, 2), 0.5);
	};
	rwgps.Router.prototype = {
	  cleanupNotes: function cleanupNotes(notes) {
	    //we want to toss out any directions that are duplicates or frivolous
	    var divKill = /<div.*?>(.*?)<\/div>/gi;
	    var bKill = /<\/?b>/gi;
	    var orderKill = /take the (.*?) (right|left)/gi;
	    var wbrKill = /<wbr\/>/g;
	    notes = notes.replace(divKill, '').replace(bKill, '').replace(orderKill, 'Turn $2').replace(wbrKill, "\u200B");
	    return notes;
	  },
	  extractTypeFromNotes: function extractTypeFromNotes(notes) {
	    var tokens = notes.split(' ');
	    var type = null;
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var token = _step.value;
	
	        //special case second regex is because gmaps doesn't space japenese characters, so can't split on space and use ^$ in regex.
	        if (token.match(/^(left|venstre|vänster|vasemmalle|linksaf|links|αριστερά|izquierda|esquerda|gauche|sinistra|лево|налево|leve|levo|lewo|左)[\.,]?$/i) || token.match(/左/i)) {
	          type = 'Left';
	          break;
	        } else if (token.match(/^(right|høyre|højre|höger|oikealle|rechtsaf|rechts|δεξιά|derecha|direita|droite|destra|прво|направо|десно|desno|desne|prawo|右)[\.,]?$/i) || token.match(/右/i)) {
	          type = 'Right';
	          break;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (type == null) type = "Straight";
	
	    return type;
	  },
	  removeDuplicates: function removeDuplicates(points) {
	    var pts = [];
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	      var prev = points[i - 1];
	      if (prev && prev.point.lat == pt.point.lat && prev.point.lng == pt.point.lng) {
	        continue;
	      }
	      pts.push(pt);
	    }
	    return pts;
	  },
	  decodePath: function decodePath(encoded) {
	    // var start = new Date().getTime();
	    var len = encoded.length;
	    var index = 0;
	    var array = [];
	    var lat = 0;
	    var lng = 0;
	    var surface = 0;
	    var rc = 0;
	    var re = 0;
	
	    while (index < len) {
	      var b;
	      var shift = 0;
	      var result = 0;
	      do {
	        b = encoded.charCodeAt(index++) - 63;
	        result |= (b & 0x1f) << shift;
	        shift += 5;
	      } while (b >= 0x20);
	      var deltaLat = result & 1 ? ~(result >> 1) : result >> 1;
	      lat += deltaLat;
	
	      shift = 0;
	      result = 0;
	      do {
	        b = encoded.charCodeAt(index++) - 63;
	        result |= (b & 0x1f) << shift;
	        shift += 5;
	      } while (b >= 0x20);
	      var deltaLon = result & 1 ? ~(result >> 1) : result >> 1;
	      lng += deltaLon;
	
	      shift = 0;
	      result = 0;
	      do {
	        b = encoded.charCodeAt(index++) - 63;
	        result |= (b & 0x1f) << shift;
	        shift += 5;
	      } while (b >= 0x20);
	      var deltaSurface = result & 1 ? ~(result >> 1) : result >> 1;
	      surface += deltaSurface;
	
	      shift = 0;
	      result = 0;
	      do {
	        b = encoded.charCodeAt(index++) - 63;
	        result |= (b & 0x1f) << shift;
	        shift += 5;
	      } while (b >= 0x20);
	      var deltaRC = result & 1 ? ~(result >> 1) : result >> 1;
	      rc += deltaRC;
	
	      shift = 0;
	      result = 0;
	      do {
	        b = encoded.charCodeAt(index++) - 63;
	        result |= (b & 0x1f) << shift;
	        shift += 5;
	      } while (b >= 0x20);
	      var deltaRE = result & 1 ? ~(result >> 1) : result >> 1;
	      re += deltaRE;
	
	      var pt = [lat * 1e-5, lng * 1e-5, surface * 1e-1, rc * 1e-1, re];
	
	      array.push(pt);
	    }
	    // var end = new Date().getTime();
	    //trace("decoded " + len + " coordinates in " + ((end - start) / 1000) + "s");
	    return array;
	  }
	};
	
	rwgps.Router.ArcGIS = function (opts) {
	  this.opts = opts;
	  this.routingUrl = opts.url;
	  this.language = opts.language;
	  this.token = opts.token;
	  this.attributes = opts.attributes;
	};
	rwgps.Router.ArcGIS.prototype = new rwgps.Router();
	rwgps.Router.ArcGIS.prototype.getDirections = function (points, opts, lineColor, _success, _error) {
	  var features = [],
	      self = this,
	      impedance;
	  var restrictions = "";
	  var language = this.language || "en_US";
	  for (var z = 0; z < points.length; z++) {
	    features.push({
	      geometry: { x: points[z].lng, y: points[z].lat, spatialReference: { wkid: 4326 } }
	    });
	  }
	
	  var r = opts.getEnabledRestrictions();
	  for (var xxx = 0; xxx < r.length; xxx++) {
	    var res = this.attributes[r[xxx]];
	    if (res) {
	      if (restrictions.length > 0 && restrictions[restrictions.length - 1] != ',') restrictions += ",";
	      restrictions += res;
	    }
	  }
	  if (opts.walkingMode()) impedance = this.opts.modes.walking.cost;else if (opts.cyclingMode()) impedance = this.opts.modes.cycling.cost;else impedance = this.opts.modes.driving.cost;
	
	  $.ajax({
	    url: this.routingUrl + "/solve",
	    data: {
	      stops: JSON.stringify({ type: "features", features: features }),
	      returnRoutes: true,
	      returnDirections: true,
	      directionsLengthUnits: "esriNAUMeters",
	      returnBarriers: false,
	      returnStops: false,
	      preserveFirstStop: false,
	      preserveLastStop: false,
	      outputGeometryPrecision: 3,
	      outputGeometryPrecisionUnits: "esriMeters",
	      outputLines: "esriNAOutputLineTrueShape",
	      restrictionAttributeNames: restrictions,
	      impedanceAttributeName: impedance,
	      outSR: 4326, //return coords in wgs84 lat/lng, not default of map!!
	      directionsLanguage: language,
	      token: this.token ? this.token : '',
	      f: "json"
	    },
	    dataType: "jsonp",
	    type: "get",
	    success: function success(results) {
	      if (results.routes) {
	        var mps = [],
	            cps = [],
	            feat,
	            path,
	            dir,
	            point,
	            i,
	            j,
	            k;
	        //first get all the points to draw the route
	        for (i = 0; i < results.routes.features.length; i++) {
	          feat = results.routes.features[i];
	          for (j = 0; j < feat.geometry.paths.length; j++) {
	            path = feat.geometry.paths[j];
	            for (k = 0; k < path.length; k++) {
	              var pt = path[k],
	                  prev = path[k - 1];
	              //ignore duplicate points
	              if (prev && prev[0] == pt[0] && prev[1] == pt[1]) continue;
	              mps.push(new rwgps.TrackPoint({ point: { lat: pt[1], lng: pt[0] } }));
	            }
	          }
	        }
	
	        //now get all the direction points and match them to their corresponding map point.
	        //since arcgis doesn't tell us where along the path the direction is, we have to
	        //guess.  Even worse is their compression algorithm for storing points is lossy,
	        //so we lose between 2-5 meters of accuracy...
	        var eps = 0.00003;
	        var lastK = 0;
	        for (i = 0; i < results.directions.length; i++) {
	          dir = results.directions[i];
	          for (j = 0; j < dir.features.length; j++) {
	            var closestDist = 999999;
	            var closestIdx;
	            feat = dir.features[j];
	            point = self.parseCompressedGeometry(feat.compressedGeometry)[0];
	            //trace("\t" + feat.attributes.text)
	            for (k = lastK; k < mps.length; k++) {
	              var dist = rwgps.Router.euclideanDistance(mps[k].point, point);
	              //trace([dist, closestDist, closestIdx])
	              if (dist < closestDist) {
	                closestDist = dist;
	                closestIdx = k;
	                if (dist < eps) break;
	              }
	            }
	            //ignore start/end instructions as well as any that don't match our epsilon
	            if (closestDist < eps && closestIdx > 0 && closestIdx < mps.length - 1) {
	              //trace([dist, closestDist, closestIdx])
	              var notes = self.cleanupNotes(feat.attributes.text);
	              cps.push(new rwgps.CoursePoint({
	                point: point,
	                trackPoint: mps[closestIdx],
	                notes: notes,
	                type: self.extractTypeFromNotes(notes),
	                duration: feat.attributes.time
	              }));
	              //trace([k, mps.length, feat.attributes.text, cps[cps.length-1]])
	              lastK = closestIdx;
	            } else {
	              //trace(["didn't find any matches", closestDist, closestIdx, mps.length, feat.attributes.text]);
	            }
	          }
	        }
	
	        _success(mps, cps, opts, lineColor);
	      } else {
	        _error("No routes found");
	      }
	    },
	    error: function error(err) {
	      _error(err);
	    }
	  });
	  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B';
	  trackEvent('Google Maps', "Direction Request (" + group + ")", this.opts.type);
	  trackEvent('Google Maps', 'Direction Request', this.opts.type);
	};
	rwgps.Router.ArcGIS.prototype.parseCompressedGeometry = function (str) {
	  var a = 0,
	      b = 0,
	      points = [],
	      x,
	      y;
	  //var parsedStr = str.replace(/(\+)|(\-)/g," $&").split(" ");
	  var parsedStr = str.replace(/(\+[0-9])*(\+)/, '$2').replace(/\|.*/, '').replace(/(\+)|(\-)/g, " $&").split(" ");
	  var coef = parseInt(parsedStr[1], 32);
	
	  for (var j = 2, jl = parsedStr.length; j < jl; j += 2) {
	    a = x = parseInt(parsedStr[j], 32) + a;
	    b = y = parseInt(parsedStr[j + 1], 32) + b;
	    points.push({ lat: y / coef, lng: x / coef });
	  }
	  return points;
	};
	
	rwgps.Router.Google = function (opts) {
	  this.opts = opts;
	};
	rwgps.Router.Google.prototype = new rwgps.Router();
	rwgps.Router.Google.prototype.getDirections = function (points, opts, lineColor, success, error) {
	  var googleLatLngs = points.map(function (x) {
	    return new google.maps.LatLng(x.lat, x.lng);
	  });
	  var self = this;
	  var args = arguments;
	  var service = new google.maps.DirectionsService();
	  var mode = null;
	  var waypoints = googleLatLngs.length > 2 ? googleLatLngs.slice(1, googleLatLngs.length - 1) : [];
	  if (opts.cyclingMode()) {
	    mode = google.maps.DirectionsTravelMode.BICYCLING;
	  } else if (opts.walkingMode()) {
	    mode = google.maps.DirectionsTravelMode.WALKING;
	  } else {
	    mode = google.maps.DirectionsTravelMode.DRIVING;
	  }
	  var request = {
	    origin: googleLatLngs[0],
	    destination: googleLatLngs[googleLatLngs.length - 1],
	    waypoints: _.map(waypoints, function (pt) {
	      return { location: pt, stopover: false };
	    }),
	    provideRouteAlternatives: false,
	    unitSystem: google.maps.DirectionsUnitSystem.METRIC,
	    travelMode: mode,
	    avoidHighways: opts.avoidHighways()
	  };
	
	  function callback(result, status) {
	    if (status == google.maps.DirectionsStatus.OK) {
	      var mps = [],
	          cps = [];
	      for (var i = 0; i < result.routes.length; i++) {
	        for (var j = 0; j < result.routes[i].legs.length; j++) {
	          for (var k = 0; k < result.routes[i].legs[j].steps.length; k++) {
	            var step = result.routes[i].legs[j].steps[k];
	            //there is a step for each drivign direction.  the step
	            //has latlng points leading up to the instruction.  We
	            //also might want to toss this direction if it's superfluous
	            if (mps.length > 0) {
	              //if the first point is a direction...we can toss it
	              //mps.push(new rwgps.TrackPoint({point: step.start_point}));
	              var notes = self.cleanupNotes(step.instructions);
	              cps.push(new rwgps.CoursePoint({
	                point: { lat: step.path[0].lat(), lng: step.path[0].lng() },
	                trackPoint: mps[mps.length - 1],
	                notes: notes,
	                type: self.extractTypeFromNotes(notes),
	                duration: step.duration.value
	              }));
	            }
	            for (var l = 0; l < step.path.length; l++) {
	              var prev = step.path[l - 1],
	                  pt = step.path[l];
	              //skip duplicate points
	              if (prev && prev.lat() == pt.lat() && prev.lng() == pt.lng()) continue;
	              mps.push(new rwgps.TrackPoint({ point: { lat: pt.lat(), lng: pt.lng() } }));
	            }
	          }
	        }
	      }
	
	      // temporarily cast surface type to paved because rendering it as unknown for a few hundred ms causes an unsightly flash
	      mps.forEach(function (tp) {
	        tp.ghSurface = tp.surface = 0; // paved
	        tp.roadClass = 2; // primary
	      });
	      if (!window.Routes.activeMap.draggingMarker) {
	        // if the user is actively dragging, don't fetch surfaces. the drag end handler will fetch surfaces when they finish dragging.
	        window.Routes.activeMap.injectSurfaces(mps, error);
	      }
	      // call success immediately without surface type (or elevation) so the polyline is rendered as soon as it's available
	      success(mps, cps, opts, lineColor);
	    } else {
	      var retry = error(status);
	      if (retry) {
	        setTimeout(function () {
	          self.getDirections.apply(self, args);
	        }, 3000);
	      }
	    }
	  }
	  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B';
	  trackEvent('Google Maps', "Direction Request (" + group + ")", this.opts.type);
	  trackEvent('Google Maps', 'Direction Request', this.opts.type);
	  service.route(request, callback);
	};
	
	rwgps.Router.RWGPSCombined = function (opts) {
	  this.opts = opts;
	  this.language = opts.language;
	  this.url = "/mrp_route";
	};
	rwgps.Router.RWGPSCombined.prototype = new rwgps.Router();
	rwgps.Router.RWGPSCombined.prototype.extractType = function (sign) {
	  var mappings = {
	    '-98': 'Uturn', //u turn unknown
	    '-8': 'Uturn', //u turn left
	    '-7': 'Slight Left', //keep left
	    '-3': 'Sharp Left', //sharp left
	    '-2': 'Left',
	    '-1': 'Slight Left', //slight left
	    '0': 'Straight', //continue
	    '1': 'Slight Right', //slight right
	    '2': 'Right', //right
	    '3': 'Sharp Right', //sharp right
	    '4': 'Generic', //finish
	    '5': 'Generic', //midpoint/via reached
	    '6': 'Straight', //roundabout
	    '7': 'Slight Right', //keep right
	    '8': 'Uturn' //u turn
	  };
	
	  return mappings[sign] || 'Generic';
	};
	
	rwgps.Router.RWGPSCombined.prototype.getDirections = function (points, opts, lineColor, _success2, _error2) {
	  var self = this,
	      mode,
	      weighting;
	  var url = self.url;
	
	  if (opts.cyclingMode()) {
	    mode = "rwgpsbike";
	    weighting = "rwgps";
	  } else if (opts.cyclingExperimentMode()) {
	    mode = "rwgpsbike";
	    weighting = "rwgps";
	    url = "https://directions-test.ridewithgps.com/route";
	  } else if (opts.walkingMode()) {
	    mode = "foot";
	    weighting = "fastest";
	  } else {
	    mode = "car";
	    weighting = "fastest";
	  }
	  var params = "?vehicle=" + mode + "&weighting=" + weighting;
	  params += "&points=";
	  points.map(function (p) {
	    params += p.lat + "," + p.lng + ";";
	  });
	  params += "&locale=" + window.navigator.language;
	  params += "&type=json";
	  params += "&point_attrs=surface,re";
	
	  $.ajaxSettings.stopCSRF = true;
	  $.ajax({
	    url: url + params,
	    dataType: "json",
	    type: "get",
	    success: function success(data) {
	      if (data.segments) {
	        if (data.segments.length == 0) {
	          _error2("No route found");
	          return;
	        }
	
	        var i,
	            j,
	            k = 0,
	            mps = [],
	            cps = [];
	        for (i = 0; i < data.segments.length; i++) {
	          var path = data.segments[i];
	          var decoded = self.decodePath(path.points);
	          for (j = 0; j < decoded.length; j++) {
	            var pt = decoded[j];
	            mps.push(new rwgps.TrackPoint({
	              point: { lat: pt[0], lng: pt[1] },
	              ghSurface: pt[2],
	              roadClass: pt[3],
	              surface: rwgps.TrackPoint.inferSurface(pt[2], pt[3], pt[0], pt[1]),
	              roadEnv: pt[4]
	            }));
	          }
	
	          for (j = 0; j < path.instructions.length; j++) {
	            var inst = path.instructions[j];
	            var mp = mps[k + inst.i];
	            cps.push(new rwgps.CoursePoint({
	              point: mp.point,
	              trackPoint: mp,
	              notes: inst.n,
	              type: inst.t
	            }));
	          }
	          k = mps.length;
	        }
	
	        if (mps.length > 0) _success2(mps, cps, opts, lineColor);else _error2("No route found");
	      } else {
	        _error2("No route found");
	      }
	    },
	    error: function error(obj, status) {
	      _error2(status);
	    }
	  });
	  var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B';
	  trackEvent('Google Maps', "Direction Request (" + group + ")", this.opts.type);
	  trackEvent('Google Maps', 'Direction Request', this.opts.type);
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	rwgps = window.rwgps || {};
	
	rwgps.BikeLaneControl = function (map) {
	  this.map = map;
	  this.controlDiv = document.createElement("DIV");
	  this.controlDiv.className = 'rwgps-BikeLaneControl';
	  this.controlDiv.index = 1;
	  var mapType = map.gmap.getMapTypeId();
	  if (!(mapType === 'roadmap' || mapType === 'satellite' || mapType === 'hybrid' || mapType === 'terrain')) {
	    this.controlDiv.style.display = 'none';
	  }
	  var controlDiv = this.controlDiv;
	
	  // Set CSS styles for the DIV containing the control
	  // Setting padding to 5 px will offset the control
	  // from the edge of the map
	  controlDiv.style['padding-top'] = '6px';
	
	  //control border
	  var controlUI = document.createElement('DIV');
	  controlUI.style.background = '#fff';
	  controlUI.style.borderRadius = '2px';
	  controlUI.style.boxShadow = '1px 1px 5px 0 rgba(0,0,0,0.25)';
	  controlUI.style.cursor = 'pointer';
	  controlUI.title = T.t('bike_paths_desc');
	  controlUI.className = 'rwgps-controlUI';
	  controlDiv.appendChild(controlUI);
	
	  //control interior
	  var controlText = document.createElement('DIV');
	  controlText.style.fontFamily = '"aktiv-grotesk", "Aktiv Grotesk", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial, sans-serif';
	  controlText.style.fontSize = '13px';
	  controlText.style.fontSize = '13px';
	  controlText.style.fontWeight = '500';
	  controlText.style.padding = '7px 10px 0 10px';
	  controlText.style.height = '30px';
	  controlText.style.boxSizing = 'border-box';
	  controlText.style.color = '#424242';
	  controlText.style.userSelect = 'none';
	  controlText.innerHTML = T.t('bike_paths');
	  controlUI.appendChild(controlText);
	
	  var isSet = false;
	  var bikeLayer = new google.maps.BicyclingLayer();
	  google.maps.event.addDomListener(controlUI, 'click', function () {
	    if (isSet) {
	      bikeLayer.setMap(null);
	      controlUI.style.backgroundColor = "white";
	    } else {
	      bikeLayer.setMap(map.gmap);
	      controlUI.style.backgroundColor = "#E7E7E7";
	    }
	    isSet = !isSet;
	    map.plannerOptions.setOption("gmapsBikeOverlay", isSet);
	  });
	};
	rwgps.BikeLaneControl.prototype.getContainingDiv = function () {
	  return this.controlDiv;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	rwgps = window.rwgps || {};
	
	rwgps.actions = rwgpsG_js_maps_actions;
	rwgps.actionsManager = new rwgps.actions.ActionsManager();
	
	rwgps.Map = function (opts) {
	  //http://spreadsheets.google.com/pub?key=0Ah0xU81penP1cDlwZHdzYWkyaERNc0xrWHNvTTA1S1E&gid=1
	  this.language = opts.language || rwgps.config.language || "en";
	  //http://code.google.com/apis/maps/documentation/geocoding/#RegionCodes
	  //"no" for norway, "co.uk" for GB
	  if (opts.region) this.region = opts.region;else this.region = 'en-us';
	
	  this.opts = opts;
	  this.mode = opts["mode"];
	  this.surfaceTypesDebug = opts['surfaceTypesDebug'];
	  this.prevClick = null;
	  this.routes = [];
	  this.setActiveRoute(new rwgps.Route(null, this));
	  this.pointsOfInterest = [];
	  this.poisById = {}; // data structure of convenience - not guaranteed to have all pois known about so dont rely on it unless you know it is populated with what you want
	  this.gmap = null;
	  this.nearestMousePoint1 = null;
	  this.nearestInterpolatedMousePoint = null;
	  this.nearestPointMarker = null;
	  this.routePoints = null;
	  this.coursePointPopup = new rwgps.CoursePointPopup(this);
	  this.distanceMarkers = [[], [], [], []];
	  this.nearestRouteSearchOpts = {};
	  this.clicks = [];
	  this.showCoursePointIcons = false;
	  this.routers = {};
	  this.overlays = {};
	  this.activeOverlays = [];
	  this.clickOptions = new rwgps.ClickOptions();
	  this.clickOptions.followRoads(opts["followRoads"]);
	  this.plannerOptions = new rwgps.Bitmask.Planner();
	  this.lineColor = 0xff0000;
	
	  _.bindAll(this, 'addControlPointAtIndex', 'addCoursePointAtIndex');
	
	  //used for bringing markers to the front.  set arbitrarily high and
	  //when we want a marker to front, we increment this by one and set
	  //that marker to the new number.
	  this.topZIndex = 1000;
	
	  //used to place layers properly above the basemap, which is also
	  //important for prioritizing routing engines between layers
	  this.nextAvailableOverlayIndex = 0;
	
	  this.routingOpts = {
	    allRestrictions: ["avoidHighways"],
	    services: [{ id: "rwgps",
	      enabled: true,
	      defaultColor: 0xFF0000,
	      type: "rwgps",
	      text: T.t('routes.follow_roads'),
	      defaultMode: "cycling",
	      checkboxes: { avoidHighways: false },
	      language: this.language,
	      modes: {
	        walking: { text: "walking", attributes: {} },
	        cycling: { text: "cycling", attributes: {} },
	        driving: { text: "driving", attributes: {} },
	        experiment: { text: "experiment", attributes: {} }
	      }
	    }, { id: "google",
	      type: "google",
	      enabled: true,
	      defaultColor: 0xFF0000,
	      text: T.t('routes.follow_roads'),
	      defaultMode: "cycling",
	      checkboxes: { avoidHighways: true },
	      modes: {
	        walking: { text: "walking", attributes: { avoidHighways: true } },
	        cycling: { text: "cycling", attributes: { avoidHighways: true } },
	        driving: { text: "driving", attributes: { avoidHighways: true } }
	      }
	    }, { id: "esriTopo",
	      type: "arcgis",
	      text: "Follow Roads",
	      enabled: true,
	      defaultColor: 0xFF0000,
	      url: "http://tasks.arcgisonline.com/ArcGIS/rest/services/NetworkAnalysis/ESRI_Route_NA/NAServer/Route",
	      defaultMode: "cycling",
	      attributes: {
	        weightedCost: "",
	        distanceCost: "Length",
	        avoidOneWays: "OneWay",
	        avoidFerries: "Avoid Ferries",
	        avoidDirtRoads: "Avoid Unpaved Roads"
	      },
	      checkboxes: {
	        avoidFerries: true,
	        avoidOneWays: true,
	        avoidDirtRoads: true
	      },
	      modes: {
	        walking: { text: "walking", attributes: { avoidHighways: false } },
	        cycling: { text: "cycling", attributes: { avoidHighways: true } },
	        driving: { text: "driving", attributes: { avoidHighways: true } }
	      }
	    }]
	  };
	  this.overlayOpts = {
	    services: [{ id: "roadmap", enabled: true, routingService: "google", type: "google" }, { id: "terrain", enabled: true, routingService: "google", type: "google" }, { id: "satellite", enabled: true, routingService: "google", type: "google" }, { id: "hybrid", enabled: true, routingService: "google", type: "google" }, { id: "rwgps_cycle",
	      name: "RWGPS Cycle",
	      maxZoom: 18,
	      minZoom: 3,
	      enabled: true,
	      type: "osm",
	      url: "//vector.ridewithgps.com/styles/rwgpscycle/",
	      routingService: "rwgps",
	      attribution: "© OpenStreetMap contributors"
	    }, { id: "osm",
	      name: "OSM",
	      maxZoom: 18,
	      minZoom: 3,
	      enabled: true,
	      type: "osm",
	      url: "//{s}.tile.openstreetmap.org/",
	      routingService: "rwgps",
	      attribution: "© OpenStreetMap contributors"
	    }, { id: "osmCycle",
	      name: 'OSM Cycle',
	      key: "a1f31ce03c41486894ffd9ed393ec1ea",
	      maxZoom: 18,
	      minZoom: 3,
	      enabled: true,
	      type: "osm",
	      url: "//{s}.tile.thunderforest.com/cycle/",
	      routingService: "rwgps",
	      attribution: "© OpenStreetMap contributors"
	    }, { id: "osmOutdoor",
	      name: 'OSM Outdoors',
	      key: "a1f31ce03c41486894ffd9ed393ec1ea",
	      maxZoom: 18,
	      minZoom: 3,
	      enabled: true,
	      type: "osm",
	      url: "//{s}.tile.thunderforest.com/outdoors/",
	      routingService: "rwgps",
	      attribution: "© OpenStreetMap contributors"
	    }, { id: "esriTopo",
	      name: 'Esri Topo',
	      maxZoom: 17,
	      minZoom: 3,
	      enabled: true,
	      type: "arcgis",
	      token: "AAPKb6d4ab91f6e249cda7f327bd40bc7a96xleixXTS5WctfNhsnl1TBpAX_vWdHu70IhznPJaqzUsjvRzBJvhmorfduBFxNhch",
	      url: "//server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer",
	      routingService: "rwgps"
	    }, { id: "usgsTopo",
	      name: 'USGS Topo',
	      maxZoom: 15,
	      minZoom: 3,
	      enabled: true,
	      type: "arcgis",
	      url: "//basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer",
	      routingService: "rwgps"
	    }, { id: "usgsTopoLegacy",
	      name: 'USGS Scans',
	      maxZoom: 15,
	      minZoom: 3,
	      enabled: true,
	      type: "wms",
	      token: "AAPKb6d4ab91f6e249cda7f327bd40bc7a96xleixXTS5WctfNhsnl1TBpAX_vWdHu70IhznPJaqzUsjvRzBJvhmorfduBFxNhch",
	      url: "//services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/export",
	      routingService: "rwgps"
	    }],
	    modes: {
	      walking: {
	        avoidCarsOnly: true,
	        avoidHighways: true,
	        avoidTunnels: true
	      },
	      cycling: {
	        avoidCarsOnly: true,
	        avoidHighways: true,
	        avoidTunnels: true,
	        avoidTrails: true
	      },
	      driving: {}
	    }
	  };
	
	  var self = this;
	  _.each(this.routingOpts.services, function (service) {
	    if (opts.modePreference && service.modes[opts.modePreference]) service.defaultMode = opts.modePreference;
	    if (service.enabled == true) self.routers[service.id] = new rwgps.Router(service);
	  });
	
	  _.each(this.overlayOpts.services, function (service) {
	    if (service.enabled == true) // && service.type != "google")
	      self.overlays[service.id] = new rwgps.Overlay(service);
	  });
	
	  this.initmap();
	}
	
	// Spur correction. See https://github.com/ridewithgps/RWGPS-Android/pull/1874 for original implementation
	// This version does not include the following:
	// - Spur correction on drag/drop (only happens on clicking to add to route)
	// - Mixed routing types. Will not correct spurs in between cycling/walking/driving/draw-lines modes.
	// - Recursive spur correction. The app implementation will repeat the spur correction a few times if necessary. This version only runs once.
	;(function () {
	  // eslint-disable-line
	  var reversePointAt = function reversePointAt(seg, i) {
	    var tp = void 0;
	    if (i === 0) {
	      tp = seg.nextControlPoint;
	    } else if (i === seg.trackPoints.length + 1) {
	      tp = seg.prevControlPoint;
	    } else {
	      tp = seg.trackPoints[seg.trackPoints.length - i];
	    }
	    return tp ? { point: tp.point, distance: seg.nextControlPoint.distance - tp.distance } : null;
	  };
	
	  var pointAt = function pointAt(seg, i) {
	    var tp = void 0;
	    if (i === 0) {
	      tp = seg.prevControlPoint;
	    } else if (i === seg.trackPoints.length + 1) {
	      tp = seg.nextControlPoint;
	    } else {
	      tp = seg.trackPoints[i - 1];
	    }
	    return tp ? { point: tp.point, distance: tp.distance - seg.prevControlPoint.distance } : null;
	  };
	
	  var spurStepper = function spurStepper(seg, reverse) {
	    var getPoint = function getPoint(i) {
	      return (reverse ? reversePointAt : pointAt)(seg, i);
	    };
	    return {
	      index: 0, distance: 0, prevPoint: getPoint(0), nextPoint: getPoint(1), getPoint: getPoint
	    };
	  };
	
	  var advanceTo = function advanceTo(_ref, newDistance) {
	    var index = _ref.index,
	        distance = _ref.distance,
	        prevPoint = _ref.prevPoint,
	        nextPoint = _ref.nextPoint,
	        getPoint = _ref.getPoint;
	
	    if (newDistance < distance) {
	      return;
	    }
	
	    var idx = index;
	    var newNextPoint = nextPoint;
	    var newPrevPoint = prevPoint;
	    while (newNextPoint.distance < newDistance || newNextPoint.distance <= distance) {
	      idx++;
	      newPrevPoint = newNextPoint;
	      newNextPoint = getPoint(idx + 1);
	      if (!newNextPoint) return;
	    }
	
	    return {
	      index: idx, distance: newDistance, prevPoint: newPrevPoint, nextPoint: newNextPoint, getPoint: getPoint
	    };
	  };
	
	  var angleBetweenPoints = function angleBetweenPoints(pointA, pointB) {
	    var lat1 = pointA.lat * Math.PI / 180;
	    var lng1 = pointA.lng * Math.PI / 180;
	    var lat2 = pointB.lat * Math.PI / 180;
	    var lng2 = pointB.lng * Math.PI / 180;
	
	    var dLng = lng2 - lng1;
	    var y = Math.sin(dLng) * Math.cos(lat2);
	    var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
	
	    var theta = Math.atan2(y, x);
	
	    var degrees = (theta * 180 / Math.PI + 360) % 360;
	
	    return degrees;
	  };
	
	  var currPoint = function currPoint(_ref2) {
	    var prevPoint = _ref2.prevPoint,
	        nextPoint = _ref2.nextPoint,
	        distance = _ref2.distance;
	
	    var delta = nextPoint.distance - prevPoint.distance;
	    var pct = delta > 0 ? (distance - prevPoint.distance) / delta : 0;
	    return {
	      lat: (nextPoint.point.lat - prevPoint.point.lat) * pct + prevPoint.point.lat,
	      lng: (nextPoint.point.lng - prevPoint.point.lng) * pct + prevPoint.point.lng
	    };
	  };
	
	  var SPUR_COINCIDENT_MAX_METERS = 10.0;
	  var SPUR_MAX_METERS = 75.0;
	
	  var findSpurLength = function findSpurLength(prevSeg) {
	    var reverseSeg = spurStepper(prevSeg, true);
	    var forwardSeg = spurStepper(prevSeg.nextSegment);
	    var lastCoincidentDist = null;
	
	    while (true) {
	      // eslint-disable-line
	      // Find the closest next "real" point on either segment, and advance both to that point
	      if (!reverseSeg.nextPoint || !forwardSeg.nextPoint) break;
	      var nextDist0 = reverseSeg.nextPoint.distance;
	      var nextDist1 = forwardSeg.nextPoint.distance;
	      var nextDist = Math.min(nextDist0, nextDist1);
	      reverseSeg = advanceTo(reverseSeg, nextDist);
	      forwardSeg = advanceTo(forwardSeg, nextDist);
	      if (!reverseSeg || !forwardSeg) {
	        // An entire segment is overlapping. There is a good chance this is deliberate (double-backing on a route and clicking close together) - don't detect a spur
	        lastCoincidentDist = null;
	        break;
	      }
	
	      // If our current endpoints have diverged, return the current result.
	      var delta = rwgps.TrackPoint.prototype.distanceFromLatLng.call({ point: currPoint(forwardSeg) }, currPoint(reverseSeg));
	
	      // If we don't have an acute angle at the control point (vast majority of spurs are 0deg, total overlap)
	      // there is a good chance we're just detecting dense trackpoints near the control point, not a spur.
	      if (!lastCoincidentDist) {
	        var angleA = angleBetweenPoints(prevSeg.nextControlPoint.point, currPoint(reverseSeg));
	        var angleB = angleBetweenPoints(prevSeg.nextControlPoint.point, currPoint(forwardSeg));
	        var angleBetween = Math.abs(angleA - angleB);
	        if (angleBetween > 180) {
	          angleBetween = Math.abs(angleBetween - 360);
	        }
	        if (angleBetween > 70) {
	          break;
	        }
	      }
	
	      if (delta > SPUR_COINCIDENT_MAX_METERS) {
	        break;
	      }
	
	      // If our endpoints are outside our max spur distance, this isn't a spur.
	      if (reverseSeg.distance > SPUR_MAX_METERS) {
	        lastCoincidentDist = null;
	        break;
	      }
	
	      lastCoincidentDist = reverseSeg.distance;
	    }
	
	    return lastCoincidentDist;
	  };
	
	  var pointAtDistance = function pointAtDistance(segment, distance) {
	    var left = segment.prevControlPoint;
	    var right = segment.trackPoints.length > 0 ? segment.trackPoints[0] : segment.nextControlPoint;
	    for (var i = 1; distance > right.distance && i < segment.trackPoints.length; i++) {
	      left = right;
	      right = segment.trackPoints[i];
	    }
	    if (distance > right.distance) {
	      left = right;
	      right = segment.nextControlPoint;
	    }
	    var pct = (distance - left.distance) / (right.distance - left.distance);
	    return {
	      lat: (right.point.lat - left.point.lat) * pct + left.point.lat,
	      lng: (right.point.lng - left.point.lng) * pct + left.point.lng
	    };
	  };
	
	  var FIX_BUFFER_METERS = 10.0; // How far to rewind before the spur started
	  var spurReroutePoints = function spurReroutePoints(prevSeg, spurLength) {
	    var fixPoint = pointAtDistance(prevSeg, prevSeg.nextControlPoint.distance - spurLength - FIX_BUFFER_METERS);
	    return [prevSeg.prevControlPoint.point, fixPoint, prevSeg.nextSegment.nextControlPoint.point];
	  };
	
	  var requestRoute = function requestRoute(prevSeg, path, opts, color, silent, onComplete) {
	    var map = Routes.activeMap;
	    var service = map.activeRoutingService;
	    service.getDirections(path, opts, color, function (tps, cps) {
	      if (tps == null || tps.length == 0) return;
	      if (!map.opts.generateCues) cps = null;
	      var closestIdx = 0;
	      var closestDist = Infinity;
	      for (var i = 0; i < tps.length; i++) {
	        var dist = rwgps.TrackPoint.prototype.distanceFromLatLng.call({ point: path[1] }, tps[i].point);
	        if (dist < closestDist) {
	          closestDist = dist;
	          closestIdx = i;
	        }
	      }
	      prevSeg.removeFromMap();
	      prevSeg.nextSegment.removeFromMap();
	      var newFirstSeg = new rwgps.Segment(map.activeRoute, prevSeg.prevControlPoint, prevSeg.nextSegment.nextControlPoint, tps, cps, prevSeg.color);
	      newFirstSeg.clickOptions.setOptions(prevSeg.clickOptions.getOptions());
	      newFirstSeg.splitAfter(closestIdx - 1);
	
	      var trackPoints = newFirstSeg.route.trackPoints();
	      var ptsToFetch = [];
	      for (var _i = 0; _i < trackPoints.length; _i++) {
	        if (trackPoints[_i].ele == undefined || trackPoints[_i].ele == null) ptsToFetch.push(trackPoints[_i]);
	      }
	      if (ptsToFetch.length > 0 && !silent) {
	        map.fetchElevations(ptsToFetch, function () {
	          map.loadElevationProfile();
	          map.relabel();
	          map.activeRoute.calculateMetrics();
	          map.activeRoute.rebuildBounds();
	          map.activeRoute.flattenBridgesAndTunnels();
	          map.drawRouteDistanceMarkers(map.activeRoute);
	          map.drawCoursePointIcons(map.activeRoute.coursePoints());
	          map.populateCuesheet(map.activeRoute.coursePoints());
	          map.snapshot();
	          $.jGrowl(T.t('routes.new.spur_corrected'));
	          onComplete && onComplete(newFirstSeg);
	        });
	      } else {
	        map.activeRoute.calculateMetrics();
	        onComplete && onComplete(newFirstSeg);
	      }
	    }, function () {
	      onComplete && onComplete();
	    });
	  };
	
	  var checkSpur = function checkSpur(prevSeg, silent, callback) {
	    // require existence of a next segment
	    if (!prevSeg.nextSegment) {
	      callback && callback();
	      return;
	    }
	    // require same routing options
	    if (!prevSeg.clickOptions.followRoads() || prevSeg.clickOptions.getOptions() !== prevSeg.nextSegment.clickOptions.getOptions()) {
	      callback && callback();
	      return;
	    }
	    var spurLength = findSpurLength(prevSeg);
	    if (spurLength) {
	      var requestPoints = spurReroutePoints(prevSeg, spurLength);
	      requestRoute(prevSeg, requestPoints, prevSeg.clickOptions, prevSeg.color, silent, function (newPrevSeg) {
	        // sometimes the returned route still has a spur (it rewinds right into an intersection)
	        // running this one more time fixes it.
	        var spurLength = newPrevSeg ? findSpurLength(newPrevSeg) : null;
	        if (spurLength) {
	          var _requestPoints = spurReroutePoints(newPrevSeg, spurLength);
	          requestRoute(newPrevSeg, _requestPoints, newPrevSeg.clickOptions, newPrevSeg.color, silent, callback);
	        } else {
	          callback && callback();
	        }
	      });
	    } else {
	      callback && callback();
	    }
	  };
	
	  rwgps.checkSpur = checkSpur;
	})();
	
	rwgps.Map.prototype = {
	  routes: [],
	  drawGrid: function drawGrid() {
	    var bounds = this.gmap.getBounds(),
	        i;
	    var tr = bounds.getNorthEast(),
	        bl = bounds.getSouthWest();
	    var latDiff = tr.lat() - bl.lat(),
	        lngDiff = tr.lng() - bl.lng(),
	        cut;
	    for (i = 0; i < latDiff; i++) {
	      cut = Math.ceil(bl.lat() + i);
	      if (cut <= tr.lat()) {
	        //trace("drawing lat cut: " + cut)
	        new google.maps.Polyline({
	          map: this.gmap,
	          path: [new google.maps.LatLng(cut, bl.lng()), new google.maps.LatLng(cut, tr.lng())],
	          strokeColor: "#0000FF",
	          strokeOpacity: 1,
	          strokeWeight: 1,
	          clickable: false
	        });
	      }
	    }
	    for (i = 0; i < lngDiff; i++) {
	      cut = Math.ceil(bl.lng() + i);
	      if (cut <= tr.lng()) {
	        //trace("drawing lng cut: " + cut)
	        new google.maps.Polyline({
	          map: this.gmap,
	          path: [new google.maps.LatLng(bl.lat(), cut), new google.maps.LatLng(tr.lat(), cut)],
	          strokeColor: "#0000FF",
	          strokeOpacity: 1,
	          strokeWeight: 1,
	          clickable: false
	        });
	      }
	    }
	  },
	  inPlanningMode: function inPlanningMode() {
	    return this.mode == 'plan' || this.mode == 'edit';
	  },
	  setRoutingMode: function setRoutingMode(mode) {
	    var m = this.activeRoutingService.opts.modes[mode];
	    this.routingMode = mode;
	    if (mode == "walking") {
	      this.clickOptions.walkingMode(true);
	    } else if (mode == "cycling") {
	      this.clickOptions.cyclingMode(true);
	    } else if (mode == "experiment") {
	      this.clickOptions.cyclingExperimentMode(true);
	    } else {
	      this.clickOptions.drivingMode(true);
	    }
	    //TODO: should be an event and handled external from map.js, like routes/new.html.haml
	    $("input.restrictions:checkbox").attr("checked", false);
	    for (var i = 0; i < this.routingOpts.allRestrictions.length; i++) {
	      this.clickOptions.setOption(this.routingOpts.allRestrictions[i], false);
	    }for (var key in m.attributes) {
	      var val = m.attributes[key];
	      $("#" + key).attr("checked", val);
	      this.clickOptions.setOption(key, val);
	    }
	    var $walking = $(".walking"),
	        $cycling = $(".cycling"),
	        $driving = $(".driving");
	    $walking.removeClass('active');
	    $cycling.removeClass('active');
	    $driving.removeClass('active');
	    $('.' + mode).addClass('active');
	    rwgps.Events.trigger('map:routing_mode_change', mode);
	  },
	
	  //TODO: should not be in map.js, map.js should broadcast an event on
	  //activeRoutingService being set, and new.js should handle this.
	  setupInterfaceForRoutingService: function setupInterfaceForRoutingService() {
	    var modes = this.activeRoutingService.opts.modes;
	    var $walking = $(".walking"),
	        $cycling = $(".cycling"),
	        $driving = $(".driving");
	    if (modes.walking) {
	      $walking.val(modes.walking.text).show();
	    } else {
	      $walking.hide();
	    }
	    if (modes.cycling) {
	      $cycling.val(modes.cycling.text).show();
	    } else {
	      $cycling.hide();
	    }
	    if (modes.driving) {
	      $driving.val(modes.driving.text).show();
	    } else {
	      $driving.hide();
	    }
	    $("#followRoadsButton").text(this.activeRoutingService.opts.text);
	  },
	
	  inactiveRoutes: function inactiveRoutes() {
	    var routes = _.clone(this.routes);
	    if (this.activeRoute) routes.splice(_.indexOf(routes, this.activeRoute), 1);
	    return routes;
	  },
	
	  // setter for activeRoute that handles rendering, updating associated views, and cleaning things up
	  setActiveRoute: function setActiveRoute(r) {
	    if (r === this.activeRoute) {
	      return;
	    }
	    this.zoomOut();
	    if (_.indexOf(this.routes, r) === -1) this.routes.push(r);
	    var lastActiveRoute = this.activeRoute;
	    this.activeRoute = r;
	    // make active
	    r.setActive();
	    // clear the active route points cache (for nearest point marker)
	    delete this.routePoints;
	    // set "previous click" appropriately
	    var tps = r.trackPoints();
	    this.prevClick = tps.length > 0 ? tps[tps.length - 1].point : null;
	    if (lastActiveRoute) {
	      if (lastActiveRoute.trackPoints().length > 0) {
	        lastActiveRoute.setInactive();
	      } else {
	        // nothing on this route, get rid of it.
	        var idx = _.indexOf(this.routes, lastActiveRoute);
	        if (idx !== -1) {
	          lastActiveRoute.clearStartMarker();
	          this.routes.splice(idx, 1);
	        }
	      }
	    }
	
	    // update everything to reflect new active route
	    this.populateCuesheet(r.coursePoints());
	    this.drawCoursePointIcons(r.coursePoints());
	    this.loadElevationProfile();
	    if (Routes.sampleGraph) {
	      // regardless of previous selection, if we're activating a route with st info, enable it
	      var nextShowSurface = r.showSurface && (tps.length === 0 || _.some(tps, function (p) {
	        return p.surface;
	      }));
	      var enabled = Routes.sampleGraph.metricsEnabled();
	      if (nextShowSurface) {
	        Routes.sampleGraph.metricsEnabled(enabled.push('surfaces'));
	      } else if (enabled.indexOf('surfaces') !== -1) {
	        Routes.sampleGraph.metricsEnabled(enabled.remove(enabled.indexOf('surfaces'), 0));
	      }
	      Routes.sampleGraph.showSurface(nextShowSurface);
	    }
	    this.onMetricsChange();
	    this.drawRouteDistanceMarkers(this.activeRoute);
	
	    // swap global POIs
	    this.loadPois(r.pois);
	
	    // we should stop listening to the previous active route events - but we dont have a nice event system yet
	    r.metricsChange($.proxy(this.onMetricsChange, this));
	    rwgps.Events.trigger('map:routes_changed', this);
	  },
	
	  showAllRoutes: function showAllRoutes(routeModels) {
	    var colors = ['#FF0000', '#0000FF', '#229922', '#FFFF00', '#FF00FF', '#802A2A'];
	    var extraColor = '#0077FF';
	    this.clearMap();
	    if (this.activeRoute) {
	      this.activeRoute.setInactive();
	    }
	
	    function drawRoutes(routes) {
	      // start by sorting by distance desc (long ones can completely cover short ones, so draw short ones last)
	      routes = _.sortBy(routes, function (x) {
	        return -x.get('distance');
	      });
	
	      // if there are contiguous routes, get them in-order so they don't get the same color
	      // this assumes there is only 1 contiguous path and the first route is included
	      var contiguousThreshold = 500,
	          minRouteDistance = 2000,
	          toRad = Math.PI / 180;
	      function isAdjacent(r1, r2, dir) {
	        var prefix1 = 'last',
	            prefix2 = 'first';
	        if (dir < 0) {
	          var tmp = prefix1;
	          prefix1 = prefix2;
	          prefix2 = tmp;
	        }
	        var lat = r1.get(prefix1 + '_lat'),
	            lng = r1.get(prefix1 + '_lng');
	        if (!lat || !lng) return false;
	
	        var lat2 = r2.get(prefix2 + '_lat');
	        var lng2 = r2.get(prefix2 + '_lng');
	        if (!lat2 || !lng2) return false;
	
	        var dist = rwgps.TrackPoint.haversine(lat * toRad, lng * toRad, lat2 * toRad, lng2 * toRad);
	        return dist < contiguousThreshold && r1.get('mappingRoute').metrics.distance > minRouteDistance;
	      }
	      function getAdjacentRoute(r, dir) {
	        for (var i = 0; i < routes.length; i++) {
	          if (isAdjacent(r, routes[i], dir)) return routes[i];
	        }
	      }
	      var contiguous = [routes.shift()];
	      var prev, next;
	      do {
	        prev = getAdjacentRoute(contiguous[0], -1);
	        if (prev) {
	          var i = _.indexOf(routes, prev);
	          routes.splice(i, 1);
	          contiguous.splice(0, 0, prev);
	        }
	      } while (prev);
	      do {
	        next = getAdjacentRoute(contiguous[contiguous.length - 1], 1);
	        if (next) {
	          i = _.indexOf(routes, next);
	          routes.splice(i, 1);
	          contiguous.push(next);
	        }
	      } while (next);
	      if (contiguous.length % colors.length == 1 && isAdjacent(contiguous[0], contiguous[contiguous.length - 1], -1)) {
	        // what a situation
	        // all the routes form a loop, and we're going to end up making 2 contiguous routes the same color.
	        // pull a new color out of our back pocket to fix this
	        colors.push(extraColor);
	      }
	
	      // and bring our partitioned routes back together
	      // contiguous routes are appended because we are more convinced that they got the colors right, so show them above the others.
	      routes = routes.concat(contiguous);
	
	      // and draw
	      routes.forEach(function (route) {
	        var mappingRoute = route.get('mappingRoute');
	        mappingRoute.inactiveStyle = {
	          strokeOpacity: 1,
	          strokeWeight: 4,
	          strokeColor: colors[0]
	        };
	        mappingRoute.previewStyle = {
	          strokeOpacity: 1,
	          strokeWeight: 4,
	          strokeColor: '#000000',
	          zIndex: 1000
	        };
	        mappingRoute.setMap(this);
	        mappingRoute.active = false;
	        this.addRoute(mappingRoute);
	        colors.push(colors.shift());
	      }, this);
	      this.recenterMap();
	    }
	
	    var _drawRoutes = drawRoutes.bind(this);
	
	    async.mapLimit(routeModels, 3, function (r, cb) {
	      r.full().done(function (route) {
	        cb(null, route);
	      });
	    }, function (e, routes) {
	      _drawRoutes(routes);
	    });
	  },
	  /*
	  * this.activeOverlays will contain an ordered list of the active
	  * overlays.  index at 0 will always be the basemap, and anything
	  * above 0 will be a layer on top of the basemap.  The top most
	  * layer *with a routing service* will be the routing service we
	  * use when drawing.  Some layers may not have a routing service,
	  * so we look down the layer stack to find the routing service,
	  * which will always at least default to the basemap's router.
	  *
	  * Changing basemaps is handled in the event handler mapTypeChanged,
	  * which just swaps out the activeOverlay at index 0.  This is still
	  * called on basemap change, as a way to reset routing options if
	  * necessary.
	  */
	  onOverlayChanged: function onOverlayChanged() {
	    var inInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    //we want to loop through all to set our plannerOptions, but only
	    //want to find the topmost routing service, so must track state
	    var alreadyFound = false;
	
	    //deselect all overlays, we will re-enable active ones next
	    for (var key in this.overlays) {
	      this.plannerOptions.setOption(this.overlays[key].opts.id, false);
	    }
	
	    for (var i = this.activeOverlays.length - 1; i >= 0; i--) {
	      var overlay = this.activeOverlays[i];
	
	      if (!alreadyFound && overlay.opts.routingService) {
	        var router = this.routers[overlay.opts.routingService];
	        if (router) {
	          if (router.opts && router.opts.checkboxes) {
	            var opts = router.opts.checkboxes;
	            for (var j = 0; j < this.routingOpts.allRestrictions.length; j++) {
	              this.clickOptions.setOption(this.routingOpts.allRestrictions[j], false);
	              $("#" + key).parent().toggle(false);
	            }
	
	            //TODO: should be an event and handled external from map.js, like routes/new.html.haml
	            $("input.restrictions:checkbox").parent().toggle(false);
	            for (key in opts) {
	              //trace([key, opts[key]]);
	              $("#" + key).parent().toggle(opts[key]);
	            }
	          }
	          this.activeRoutingService = router;
	          this.setupInterfaceForRoutingService();
	          alreadyFound = true;
	        }
	      }
	      //make sure we have our plannerOptions properly set
	      this.plannerOptions.setOption(overlay.opts.id, true);
	      // don't change the routing mode if the new router supports it
	      if (!this.activeRoutingService.opts.modes[this.routingMode]) {
	        this.setRoutingMode(this.activeRoutingService.opts.defaultMode);
	      } else {
	        //reset all checkboxes with new overlay's routing defaults
	        this.setRoutingMode(this.routingMode);
	      }
	      //removed defaultColor for now, seems confusing and we only want red ATM
	      //this.setColor(this.activeRoutingService.opts.defaultColor);
	    }
	    var mapType = this.gmap.getMapTypeId();
	    var path = window.location.pathname;
	    var planner_edit = /^\/routes\/\d+\/edit/.test(path) && "Edit";
	    var planner_new = /^\/routes\/new/.test(path) && "New";
	    var planner_type = planner_edit || planner_new;
	    var category = planner_type ? "Route Planner - " + planner_type : "Route/Trip Viewer";
	    var action = inInit ? "Map Style - Initial" : "Map Style - Change";
	    trackEvent(category, action, mapType);
	    this.drawMapAttribution(this.overlays[mapType].opts.attribution);
	    if (mapType === 'roadmap' || mapType === 'satellite' || mapType === 'hybrid' || mapType === 'terrain') {
	      $('.rwgps-BikeLaneControl').show();
	    } else {
	      $('.rwgps-BikeLaneControl').hide();
	    }
	    this.opts.onOverlayChanged && this.opts.onOverlayChanged(overlay);
	  },
	
	  //TODO: Note: gmaps bike overlay isn't handled in here, it's being
	  //manually toggled in the layer controls class...
	  toggleOverlay: function toggleOverlay(overlay) {
	    var toggled;
	    if (overlay.active == true) {
	      //turn off the overlay
	      this.gmap.overlayMapTypes.setAt(overlay.index, null);
	      this.nextAvailableOverlayIndex -= 1;
	      overlay.active = false;
	      overlay.index = null;
	      toggled = false;
	      //remove the overlay from the active overlays
	      this.activeOverlays.splice(_.indexOf(this.activeOverlays, overlay), 1);
	    } else {
	      overlay.active = true;
	      overlay.index = this.nextAvailableOverlayIndex;
	      this.nextAvailableOverlayIndex += 1;
	      this.gmap.overlayMapTypes.setAt(overlay.index, overlay.getOverlayObj());
	      toggled = true;
	      //place overlay as the topmost active overlay (routing engine precedence etc)
	      this.activeOverlays.push(overlay);
	    }
	    this.onOverlayChanged(); //resets our planner state (UI and options), caches router
	    rwgps.Events.trigger("map:overlay:toggled", overlay, toggled);
	    return toggled;
	  },
	
	  initmap: function initmap() {
	    var _this = this;
	
	    var self = this,
	        maptypes = [];
	    _.each(this.overlays, function (overlay) {
	      if (overlay.opts.isLayer != true) {
	        if (self.opts.hideGoogleTiles && overlay.opts.type == "google") return;
	        maptypes.push(overlay.opts.id);
	      }
	    });
	
	    var streetViewOptions = {
	      addressControlOptions: { position: google.maps.ControlPosition.BOTTOM_CENTER },
	      enableCloseButton: true,
	      visible: false //set to false so streetview is not triggered on the initial map load
	    };
	
	    var opts = {
	      zoom: 15,
	      gestureHandling: 'greedy',
	      scrollwheel: this.opts.hasOwnProperty("scrollwheel") && this.opts["scrollwheel"] != true ? false : true,
	      draggableCursor: "crosshair",
	      fullscreenControl: this.opts.fullscreenControl !== false,
	      fullscreenControlOptions: {
	        position: google.maps.ControlPosition.TOP_LEFT
	      },
	      mapTypeControl: this.opts.hasOwnProperty("showOverlayPicker") ? !!this.opts.showOverlayPicker : true,
	      mapTypeControlOptions: {
	        mapTypeIds: maptypes,
	        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
	        position: google.maps.ControlPosition.TOP_RIGHT
	      },
	      controlSize: 25,
	      streetView: new google.maps.StreetViewPanorama(document.getElementById(this.opts.targetDiv), streetViewOptions),
	      mapTypeId: this.opts.overlay || google.maps.MapTypeId.ROADMAP
	    };
	
	    if (this.opts["bounds"]) {
	      var sw = new google.maps.LatLng(this.opts.bounds[0].lat, this.opts.bounds[0].lng);
	      var ne = new google.maps.LatLng(this.opts.bounds[1].lat, this.opts.bounds[1].lng);
	      var bounds = new google.maps.LatLngBounds();
	      bounds.extend(ne);
	      bounds.extend(sw);
	      opts["bounds"] = bounds;
	    } else if (this.opts["center"]) {
	      var lat = this.opts["center"]["lat"],
	          lng = this.opts["center"]["lng"];
	      opts["center"] = new google.maps.LatLng(lat, lng);
	    } else {
	      //default on portland
	      opts["center"] = new google.maps.LatLng(45.5773, -122.616);
	    }
	
	    //set our planner option bitmask with the correct overlay
	    if (!this.inPlanningMode()) {
	      //override mapTypeId and set any overlays...
	      if (this.opts.plannerOptions && this.opts.plannerOptions > 0) {
	        this.plannerOptions.setOptions(this.opts.plannerOptions);
	        var set = this.plannerOptions.getSetGroupOption("basemaps");
	        if (set && this.overlays[set]) opts.mapTypeId = set;
	      }
	    }
	
	    opts.styles = [{
	      featureType: 'poi.business',
	      elementType: 'labels',
	      stylers: [{ visibility: 'on' }]
	    }];
	
	    this.gmap = new google.maps.Map(document.getElementById(this.opts["targetDiv"]), opts);
	    if (opts["bounds"]) {
	      this.gmap.fitBounds(bounds);
	    }
	
	    if (this.inPlanningMode()) {
	      this.activeOverlays.push(this.overlays[opts.mapTypeId]);
	    }
	    this.onOverlayChanged(true);
	
	    //TODO: this is ghetto, but necessary for gmap WMS overlays because they require the map's
	    //current projection in order to compute the bounding box of each tile at current zoom
	    _.each(this.overlays, function (overlay) {
	      overlay.setProvider("google", self.gmap);
	    });
	
	    for (var i = 0; i < maptypes.length; i++) {
	      var t = maptypes[i];
	      var base = self.overlays[t];
	      if (base && base.opts.type != "google") {
	        self.gmap.mapTypes.set(t, base.getOverlayObj());
	      }
	    }
	
	    if (rwgps.onRightClick) {
	      google.maps.event.addListener(this.gmap, 'rightclick', function (e) {
	        return rwgps.onRightClick(e, 'map', _this);
	      });
	    }
	
	    google.maps.event.addListenerOnce(this.gmap, 'tilesloaded', function () {
	      if (self.opts.hideElevation) {
	        self.hideElevation();
	      }
	      google.maps.event.trigger(self.gmap, 'resize');
	      rwgps.Events.trigger('map:initialized');
	    });
	    if (window.afterExpandCollapse) {
	      afterExpandCollapse(function () {
	        $(window).resize();
	      });
	    }
	
	    google.maps.event.addListener(this.gmap, 'zoom_changed', $.proxy(this.onMapZoom, this));
	    google.maps.event.addListener(this.gmap, 'dragstart', $.proxy(this.onMapDragStart, this));
	    google.maps.event.addListener(this.gmap, 'dragend', $.proxy(this.onMapDragEnd, this));
	    if (this.mode == "user_edit") {
	      //TODO: plain simple map...this is ugly, aybe we need a base map type that
	      //the planner inherits from or something.  whatever...technical debt.
	    } else if (this.mode == "preview") {// eslint-disable-line no-empty
	    } else if (this.mode == "search") {
	      this.drawCustomControls();
	    } else {
	      //plan or edit
	      this.enableClicks(); //add click listener
	
	      //rwgps.Events.bind("map:overlay:toggled", function(overlay, toggled) { trace([overlay, toggled]); });
	      google.maps.event.addListener(this.gmap, 'maptypeid_changed', $.proxy(this.mapTypeChanged, this));
	      google.maps.event.addListener(this.gmap, 'mousemove', $.proxy(this.onMouseMove, this));
	      // mousemove is throttled and debounced so it might fire up to 100ms late. this screws up our ability to highlight points on the map in some circumstances (move mouse directly from map area to slideshow) so we are ignoring the debounced/throttled mousemove event for the debounce duration (100ms) on mouseout
	      var that = this;
	      google.maps.event.addListener(this.gmap, 'mouseout', function () {
	        that.ignoreMouseMove = true;
	        _.delay(function () {
	          that.ignoreMouseMove = false;
	        }, 100);
	      });
	      // as far as i can tell there is no easy way to determine if the map is totally initialized (including controls loaded) so we'll just wait impatiently to get metrics displayed...
	      // NOTE: there is a way supposedly, not sure if it works with controls, but you wait until map is idle, and there is an idle event you can register for
	      (function tryToShowMetrics() {
	        if ($('.sg-data-summary').length == 0) _.delay(tryToShowMetrics, 50);else {
	          self.activeRoute.metricsChange();
	        }
	      })();
	
	      this.drawCustomControls();
	
	      // handle resize event properly, only matters if ele profile exists
	      if ($('body.full #elevation_profile').length > 0) {
	        $(window).resize(_.debounce(function () {
	          google.maps.event.trigger(self.gmap, 'resize');
	          var trspNudgeHeight = $('#rp_nudge').offset() && $('#rp_nudge').offset().top > 0 ? 62 : 0;
	          var availableHeight = $(window).height() - $('.globalNav,#globalNav').get(0).getClientRects()[0].top - $('.globalNav,#globalNav').outerHeight() - trspNudgeHeight;
	          $('#map').height(availableHeight);
	          if (self.elevationCollapsed) {
	            $('#viewport').height(availableHeight - $('#elevation_profile .sg-bar').outerHeight());
	          } else {
	            $('#viewport').height(availableHeight * 0.8);
	            _.defer(function () {
	              $('#elevation_profile').height(availableHeight * 0.2);
	              if (Routes.sampleGraph) {
	                Routes.sampleGraph.resize($('#elevation_profile').innerWidth(), $('#elevation_profile').innerHeight());
	              }
	            });
	          }
	        }, 100)).resize();
	      }
	
	      //redraw auto-saved route if present and its ok to do so
	      if (this.mode == "plan" && !this.opts.preventLoadingLocallySavedRoute) this.redrawLocallySavedRoute();
	    }
	  },
	
	  drawMapAttribution: function drawMapAttribution(attribution) {
	    this.hideMapAttribution();
	
	    if (!attribution) return;
	
	    var $control = $('<div><span>' + attribution + '</span></div>');
	    $control.find('span').css({
	      opacity: "0.65",
	      padding: "0px 2px",
	      "font-family": "Roboto,Arial,sans-serif",
	      "background-color": 'white',
	      "font-size": "0.9em",
	      "font-weight": "400",
	      color: "#333333"
	    }).end();
	
	    this.mapAttributionLocation = this.gmap.controls[google.maps.ControlPosition.BOTTOM_RIGHT];
	    this.mapAttributionPosition = this.mapAttributionLocation.length;
	    this.mapAttributionLocation.push($control.get(0));
	  },
	  hideMapAttribution: function hideMapAttribution() {
	    if (this.mapAttributionLocation != null && this.mapAttributionPosition != null) {
	      this.mapAttributionLocation.removeAt(this.mapAttributionPosition);
	      this.mapAttributionLocation = null;
	      this.mapAttributionPosition = null;
	    }
	  },
	
	  drawCustomControls: function drawCustomControls() {
	    if (this.opts.noCustomControls) {
	      return;
	    }
	    var bikeLaneControl = new rwgps.BikeLaneControl(this);
	    this.gmap.controls[google.maps.ControlPosition.TOP_RIGHT].push(bikeLaneControl.getContainingDiv());
	  },
	
	  initializeBikeLayer: function initializeBikeLayer() {
	    this.bikeLayer = new google.maps.BicyclingLayer();
	  },
	
	  showBikeLayer: function showBikeLayer() {
	    if (!this.bikeLayer) {
	      this.initializeBikeLayer();
	    }
	    this.bikeLayer.setMap(this.gmap);
	    this.plannerOptions.setOption("gmapsBikeOverlay", true);
	  },
	
	  hideBikeLayer: function hideBikeLayer() {
	    this.bikeLayer && this.bikeLayer.setMap(null);
	    this.plannerOptions.setOption("gmapsBikeOverlay", false);
	  },
	
	  initializeHeatLayer: function initializeHeatLayer() {
	    var opts = {
	      id: "heatMap",
	      name: "Heatmap",
	      maxZoom: 19,
	      minZoom: 3,
	      enabled: true,
	      type: "osm",
	      url: "//heatmap.ridewithgps.com/normalized/"
	    };
	    this.heatLayer = new google.maps.ImageMapType({
	      getTileUrl: function getTileUrl(coord, zoom) {
	        return opts.url + zoom + "/" + coord.x + "/" + coord.y + ".png?start_color=%23bcebf0&end_color=%23e94b65";
	      },
	      tileSize: new google.maps.Size(256, 256),
	      isPng: true,
	      alt: opts.alt,
	      name: opts.name,
	      maxZoom: opts.maxZoom
	    });
	    this.heatLayer.setOpacity(0.7);
	  },
	
	  showHeatLayer: function showHeatLayer() {
	    var _this2 = this;
	
	    if (!this.heatLayer) {
	      this.initializeHeatLayer();
	    }
	    this.gmap.overlayMapTypes.setAt(0, this.heatLayer);
	    // I do not know why this is needed, and isn't needed for distance markers. But they don't re-render if you remove this.
	    _.defer(function () {
	      _this2.drawCoursePointIcons(_this2.activeRoute.coursePoints());
	    });
	  },
	
	  hideHeatLayer: function hideHeatLayer() {
	    var _this3 = this;
	
	    this.gmap.overlayMapTypes.setAt(0, null);
	    _.defer(function () {
	      _this3.drawCoursePointIcons(_this3.activeRoute.coursePoints());
	    });
	  },
	
	  toggleElevation: function toggleElevation() {
	    if (!this.elevationCollapsed) {
	      this.hideElevation();
	    } else {
	      this.showElevation();
	    }
	  },
	
	  showElevation: function showElevation() {
	    var availableHeight = $(window).height() - $('.globalNav,#globalNav').get(0).getClientRects()[0].top - $('.globalNav,#globalNav').outerHeight();
	    if (Routes.sampleGraph.options.displayLightControls) {
	      $('#elevation_profile').show();
	    } else {
	      $('#elevation_profile canvas').show();
	    }
	    Routes.sampleGraph.segmentSelector && Routes.sampleGraph.segmentSelector.show();
	    if (Routes.elevationHeight) {
	      $('#viewport').height(availableHeight - Routes.elevationHeight);
	    } else {
	      $('#viewport').height(availableHeight * 0.8);
	    }
	    google.maps.event.trigger(this.gmap, 'resize');
	    this.loadElevationProfile();
	    this.elevationCollapsed = false;
	    $(window).resize();
	  },
	  hideElevation: function hideElevation() {
	    var val = $('.globalNav,#globalNav').get(0).getClientRects()[0].top;
	    var availableHeight = $(window).height() - val - $('.globalNav,#globalNav').outerHeight();
	
	    if (Routes.sampleGraph.options.displayLightControls) {
	      $('#elevation_profile').hide();
	    } else {
	      $('#elevation_profile canvas').hide();
	    }
	    Routes.sampleGraph.segmentSelector && Routes.sampleGraph.segmentSelector.hide();
	    $('#routeContainer').height('100%');
	    $('#viewport').height(availableHeight - $('#elevation_profile .sg-bar').outerHeight());
	    google.maps.event.trigger(this.gmap, 'resize');
	    this.loadElevationProfile();
	    this.elevationCollapsed = true;
	  },
	  onMetricsChange: function onMetricsChange() {
	    // TODO on the eventing system, let me pass arguments along with the event.. in this case, the route and/or the metrics would be nice
	    var metrics = this.highlightedPoints ? this.highlightedPoints.metrics : this.activeRoute.metrics;
	    $('.sg-data-summary').text(rwgps.LabelMaker.longLabel(metrics.distance || 0, 'short') + ' +' + rwgps.LabelMaker.shortLabel(metrics.ele_gain || 0, 'short') + ' / -' + rwgps.LabelMaker.shortLabel(metrics.ele_loss || 0, 'short') + (this.highlightedPoints && metrics.grade && metrics.grade.avg ? ' (' + metrics.grade.avg.toFixed(1) + '%)' : ''));
	    rwgps.Events.trigger('metrics:changed', metrics, !!this.highlightedPoints);
	  },
	
	  initInfoWindowHandlers: function initInfoWindowHandlers() {
	    var self = this;
	    // course point edit buttons
	    $("#coursePointInfoWindowContent .deleteButton").click(function () {
	      self.deleteCoursePoint();
	      return false;
	    });
	    $("#coursePointInfoWindowContent .saveButton").click(function () {
	      self.saveCoursePoint();
	      return false;
	    });
	    $("#coursePointInfoWindowContent .cancelButton").click(function () {
	      self.closeCoursePoint();
	      return false;
	    });
	
	    $("#poiInfoWindowContent .addToPoiLibrary").click(function () {
	      if ($(this).attr('data-poi_id')) {
	        var saveOrUpdate = $('#saveOrUpdate');
	        saveOrUpdate.css('display', this.checked ? 'inline' : 'none');
	      }
	    });
	    // poi edit buttons
	    $("#poiInfoWindowContent .deleteButton").click(function () {
	      var _this4 = this;
	
	      var doDelete = function doDelete() {
	        var id = $(_this4).attr('data-poi_id'),
	            poi = id ? self.poisById[id] : self.openPoi;
	        self.deletePoi(poi);
	      };
	      customConfirm(T.t('confirm_delete_poi'), doDelete.bind(this));
	      return false;
	    });
	    $("#poiInfoWindowContent .saveButton").click(function () {
	      // gi doesnt want poi with blank names
	      if ($('#poiInfoWindowContent .poiName').val() == '') {
	        customAlert(T.t('poi_name_required'));
	        return false;
	      }
	      self.savePoi();
	      return false;
	    });
	    $("#poiInfoWindowContent .cancelButton").click(function () {
	      self.closeStickyInfoWindow();
	      return false;
	    });
	    $('.poi_add_to_route').click(function () {
	      var id = $(this).attr('data-poi_id'),
	          poi = self.poisById[id];
	      poi.addToRoute();
	      return false;
	    });
	    $('.poi_remove_from_route').click(function () {
	      var id = $(this).attr('data-poi_id'),
	          poi = id ? self.poisById[id] : self.openPoi;
	      poi.removeFromRoute();
	      return false;
	    });
	    $('.poi_make_unique').click(function () {
	      var id = $(this).attr('data-poi_id'),
	          poi = id ? self.poisById[id] : self.openPoi;
	      poi.id = null;
	      poi.library = false;
	      self.openStickyInfoWindow(poi);
	      return false;
	    });
	    $('.poi_route_to').click(function () {
	      var id = $(this).attr('data-poi_id'),
	          poi = id ? self.poisById[id] : self.openPoi;
	      self.onClickAddPoint({ latLng: poi.marker.gmarker.position });
	      poi.addToRoute();
	      return false;
	    });
	  },
	  enableClicks: function enableClicks() {
	    if (this.addPoiEnabled) {
	      this.enableAddPoi();
	      return;
	    } else if (this.addCoursePointEnabled) {
	      return;
	    } else if (this.addControlPointEnabled) {
	      return;
	    } else if (this.routeSplitterEnabled) {
	      return;
	    }
	
	    // just in case, make sure clicks are disabled first so event isnt double added
	    this.disableClicks();
	
	    // also disable mouseover on pois
	    this.preventPoiMouseover = false;
	
	    if (this.inPlanningMode()) google.maps.event.addListener(this.gmap, 'click', $.proxy(this.onClickAddPoint, this));
	  },
	  disableClicks: function disableClicks() {
	    // also disable mouseover on pois
	    this.preventPoiMouseover = true;
	
	    google.maps.event.clearListeners(this.gmap, 'click');
	  },
	
	  // disable click-to-draw-route and make the next click set up a POI
	  enableAddPoi: function enableAddPoi() {
	    this.disableClicks();
	    this.addPoiEnabled = true;
	    google.maps.event.addListener(this.gmap, 'click', $.proxy(this.onClickAddPoi, this));
	  },
	
	  disableAddPoi: function disableAddPoi() {
	    this.addPoiEnabled = false;
	    rwgps.Events.trigger("addpoi:disabled");
	    this.enableClicks(); // get standard behavior back of click-to-route
	  },
	
	  onClickAddPoi: function onClickAddPoi(e) {
	    this.closeStickyInfoWindow();
	
	    var poi = new rwgps.PointOfInterest({ point: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	    poi.marker = new rwgps.PoiIcon(poi, this);
	    poi._new = true;
	    this.pointsOfInterest.push(poi);
	    if (this.activeRoute && this.activeRoute.pois) {
	      this.activeRoute.pois.push(poi);
	    }
	    rwgps.Events.trigger('pois:added', poi);
	
	    this.openStickyInfoWindow(poi);
	  },
	
	  inclusiveBounds: function inclusiveBounds() {
	    if (this.staticBounds) return this.staticBounds;
	    var bounds = new google.maps.LatLngBounds();
	    _.each(this.routes, function (route) {
	      if (route.active || route.drawInactive) bounds.union(route.gBounds);
	    });
	    if (this.poiGBounds) bounds.union(this.poiGBounds);
	    return bounds;
	  },
	
	  // centers on the activeRoute, without considering anything else.
	  recenterMap: function recenterMap() {
	    if (!this.recenterDisabled) {
	      var bounds = this.inclusiveBounds();
	      if (!bounds.isEmpty()) {
	        this.gmap.fitBounds(this.inclusiveBounds());
	      }
	    }
	  },
	
	  // there are some event bindings that cause recentering.  not clear how to restructure it.
	  // if you want it to not recenter, pass your function here and recentering will be temporarily
	  // disabled
	  withRecenterDisabled: function withRecenterDisabled(fn) {
	    this.recenterDisabled = true;
	    fn();
	    this.recenterDisabled = false;
	  },
	
	  handleClick: function handleClick(click) {
	    if (this.opts.autoCenter) this.gmap.panTo(new google.maps.LatLng(click.point.lat, click.point.lng));
	
	    if (this.routingRequestInProgress) {
	      this.clicks.push(click);
	      return;
	    }
	
	    if (this.prevClick) {
	      if (click.points) {
	        // points provided! no need to fetch.
	        this.onRoutingSuccess(click.points, null, click.opts, click.color);
	      } else if (click.opts.followRoads()) {
	        var service = this.activeRoutingService;
	        var directionsFn = _.bind(function () {
	          service.getDirections([this.prevClick, click.point], click.opts, click.color, $.proxy(this.onRoutingSuccess, this), $.proxy(this.onRoutingError, this));
	        }, this);
	        this.routingRequestInProgress = true;
	        if (click.delay) {
	          setTimeout(directionsFn, click.delay);
	        } else {
	          directionsFn();
	        }
	      } else {
	        // draw lines
	        var pts = [new rwgps.TrackPoint({ point: this.prevClick }), new rwgps.TrackPoint({ point: click.point })];
	        if (rwgps.config.labs.route_planner) {
	          // SURFACE: 99 is 'unknown'
	          pts.forEach(function (pt) {
	            pt.surface = 99;
	            pt.ghSurface = 99;
	          });
	        }
	        this.onRoutingSuccess(rwgps.Segment.fillTheCracks(pts), null, click.opts, click.color);
	      }
	    } else {
	      this.prevClick = click.point;
	      this.activeRoute.startMarker = new rwgps.StartIcon(click.point, this);
	      this.snapshot();
	      // we normally handle this on direction request success, but since we
	      // aren't calling that, we have to explicitly handle it here
	      this.dispatchNextClick();
	    }
	  },
	  dispatchNextClick: function dispatchNextClick() {
	    if (this.clicks.length > 0) {
	      this.handleClick(this.clicks.shift());
	    } else {
	      rwgps.Events.trigger("map:clicks_dispatched");
	    }
	  },
	  snapshot: function snapshot(opts) {
	    if (this.snapshotsDisabled || !this.inPlanningMode()) return;
	    if (!opts) opts = {};
	    // pop this off the stack so it doesnt halt ui updates
	    var map = this;
	    var doSnapshot = function doSnapshot() {
	      var serialized = {
	        routes: _.map(map.routes, function (route) {
	          var obj = route.toSaveObj(true);
	          obj.points_of_interest = route.pois.map(function (poi) {
	            return poi.toSaveObj();
	          });
	          if (route.active && route.startMarker) {
	            var latlng = route.startMarker.gmarker.getPosition();
	            obj.start_point = { x: latlng.lng(), y: latlng.lat() };
	          }
	          obj.routeData = route.routeData;
	          obj.tripData = route.tripData;
	          return obj;
	        })
	      };
	      var snapshot = new rwgps.actions.RouteSnapshot(map, serialized);
	
	      if (opts.updateLast) {
	        rwgps.actionsManager.chain(snapshot);
	      } else if (opts.manualUndo) {
	        rwgps.actionsManager.manualUndoTo(snapshot);
	      } else {
	        rwgps.actionsManager.add(snapshot);
	      }
	      map.saveSnapshotLocally(snapshot);
	      // the active route is dirty now =(
	      map.activeRoute.setModified();
	    };
	    if (opts.doSync) doSnapshot();else _.defer(doSnapshot);
	  },
	  saveSnapshotLocally: function saveSnapshotLocally(snapshot) {
	    if (this.mode == "edit") return;
	    if ($.jStorage && $.jStorage.storageAvailable()) {
	      $.jStorage.set("locallySavedRoute", snapshot.serialized);
	    } else {
	      trace("no local storage available?");
	    }
	  },
	  redrawLocallySavedRoute: function redrawLocallySavedRoute() {
	    try {
	      if ($.jStorage === undefined) return;
	      var serializedSnapshot = $.jStorage.get("locallySavedRoute");
	      if (serializedSnapshot) {
	        var snapshot = new rwgps.actions.RouteSnapshot(this, serializedSnapshot);
	        snapshot.restore();
	        this.snapshot();
	        this.recenterMap();
	      }
	    } catch (e) {
	      trace(e.stack);
	      trace("Error redrawing locally saved route, clearing it out");
	      this.clearMap();
	    }
	  },
	
	  onClickAddPoint: function onClickAddPoint(e) {
	    if (this.opts.tripId) {
	      rwgps.Events.trigger("trip:modification_prevented");
	      return;
	    }
	    this.handleClick({
	      point: { lat: e.latLng.lat(), lng: e.latLng.lng() },
	      opts: this.clickOptions,
	      color: this.lineColor,
	      fetchEles: true
	    });
	  },
	  insertPointAfterClick: function insertPointAfterClick() {
	    var gll = this.nearestPointMarker.gmarker.getPosition();
	    var point = { lat: gll.lat(), lng: gll.lng() };
	    var distance = this.nearestMousePointBehind.distance + this.nearestMousePointBehind.distanceFromLatLng(point);
	    var surface = this.nearestMousePointBehind.surface,
	        ghSurface = this.nearestMousePointBehind.ghSurface,
	        roadClass = this.nearestMousePointBehind.roadClass,
	        excludeFromMetrics = this.nearestMousePointBehind.excludeFromMetrics;
	    var tp = new rwgps.TrackPoint({
	      point: point,
	      ele: this.nearestMousePointBehind.ele,
	      surface: surface,
	      ghSurface: ghSurface,
	      roadClass: roadClass,
	      excludeFromMetrics: excludeFromMetrics
	    });
	    tp.distance = distance;
	    var prevSegment = this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment;
	    var idx = _.indexOf(prevSegment.trackPoints, this.nearestMousePointBehind);
	    prevSegment.insertTrackPointAfter(tp, idx);
	    this.fetchElevations([tp], $.proxy(function () {
	      this.loadElevationProfile();
	      this.snapshot({ updateLast: true });
	    }, this), function (msg) {
	      trace(msg);
	    });
	    return { trackPoint: tp, idx: idx };
	  },
	  onClickAddCoursePoint: function onClickAddCoursePoint() {
	    var newTp = this.insertPointAfterClick().trackPoint;
	    this.openCoursePointInfoWindow(new rwgps.CoursePoint({
	      point: newTp.point,
	      trackPoint: newTp,
	      segment: newTp.segment,
	      distance: newTp.distance
	    }));
	  },
	  onClickAddControlPoint: function onClickAddControlPoint() {
	    var ret = this.insertPointAfterClick();
	    ret.trackPoint.segment.splitAfter(ret.idx);
	    this.loadElevationProfile();
	  },
	  onNearestPointMarkerClicked: function onNearestPointMarkerClicked(e) {
	    if (this.activeRoute !== (this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment).route) {
	      // clicked on an inactive route, make active.
	    } else if (this.inPlanningMode()) {
	      if (this.selectionToolHelper) {
	        var res = this.insertPointAfterClick();
	        var closestI = this.activeRoute.trackPoints().indexOf(res.trackPoint);
	        this.selectionToolHelper.selectPoint({ closestI: closestI });
	      } else if (this.routeSplitterEnabled) this.onClickSplitRoute(e);else if (this.addPoiEnabled) this.onClickAddPoi(e);else if (this.addCoursePointEnabled) this.onClickAddCoursePoint(e);else if (this.addControlPointEnabled) this.onClickAddControlPoint(e);else this.onClickAddPoint(e);
	    } else {
	      rwgps.Events.trigger('map:route_click', this.lastNearestPoint);
	    }
	  },
	  onClickSplitRoute: function onClickSplitRoute() {
	    var splitPointResult = this.insertPointAfterClick();
	    this.splitRouteOnTrackPoint(splitPointResult);
	  },
	
	  // Create two new routes on the map that are the divided copies from the current active route
	  splitRouteOnTrackPoint: function splitRouteOnTrackPoint(splitPointResult) {
	    var wholeRoute = this.activeRoute;
	    var splitPoint = splitPointResult.trackPoint;
	    var splitIndex = this.activeRoute.trackPoints().indexOf(splitPoint);
	
	    var routeA = this.activeRoute.toSaveObj();
	    routeA.pois = [];
	    routeA.course_points = _.filter(routeA.course_points, function (c) {
	      return c.d <= splitPoint.distance;
	    });
	    routeA.track_points = routeA.track_points.slice(0, splitIndex);
	    delete routeA.id;
	    delete routeA.name;
	
	    var routeB = this.activeRoute.toSaveObj();
	    routeB.track_points = routeB.track_points.slice(splitIndex);
	    if (routeB.track_points.length > 0) {
	      routeB.course_points = _.filter(routeB.course_points, function (c) {
	        return c.d >= routeB.track_points[0].d;
	      });
	    } else {
	      routeB.course_points = [];
	    }
	    delete routeB.id;
	    delete routeB.name;
	
	    // color is stored on the last tp in a segment, so in the likely case that
	    // the split is in the middle of a segment, color for the new last segment
	    // for routeA will lose its color value
	    routeA.track_points[routeA.track_points.length - 1]['color'] = this.activeRoute.trackPoints()[routeA.track_points.length - 1].segment.color;
	
	    // Reset mileage indicators for the second part of the route
	    if (routeB.track_points.length > 0) {
	      var distanceOffset = routeB.track_points[0].d;
	      routeB.track_points.forEach(function (tp) {
	        tp.d = tp.d - distanceOffset;
	      });
	
	      routeB.course_points.forEach(function (cp) {
	        cp.d = cp.d - distanceOffset;
	        cp.i = cp.i - splitIndex;
	      });
	    }
	
	    var route1 = this.loadRouteForEdit(routeA, true, false);
	    var route2 = this.loadRouteForEdit(routeB, true, false);
	    this.setActiveRoute(route1);
	
	    var THREE_MILES = 4828.032; // This is 3 miles in meters
	    wholeRoute.pois.forEach(function (poi) {
	      var firstDistance = route1.distanceToLatLng(poi.googleLatLng(), this);
	      var secondDistance = route2.distanceToLatLng(poi.googleLatLng(), this);
	
	      if (firstDistance < secondDistance) {
	        route1.pois.push(poi);
	        if (secondDistance < THREE_MILES) {
	          route2.pois.push(poi.copy());
	        }
	      } else {
	        route2.pois.push(poi);
	        if (firstDistance < THREE_MILES) {
	          route1.pois.push(poi.copy());
	        }
	      }
	    }, this);
	
	    if (this.activeRoute.pois.length > 0) {
	      this.loadPois(this.activeRoute.pois, false);
	    }
	
	    // Removing the active on should get rid of the one that split
	    this.removeRoute(wholeRoute);
	
	    this.drawRouteDistanceMarkers();
	    this.loadElevationProfile();
	    this.populateCuesheet(this.activeRoute.coursePoints());
	    this.snapshot();
	    rwgps.Events.trigger('map:routes_changed');
	  },
	
	  onRoutingSuccess: function onRoutingSuccess(trackPoints, coursePoints, clickOptions, lineColor) {
	    this.routingRequestInProgress = false;
	    if (this.routingRequestCancelled) {
	      this.routingRequestCancelled = false;
	      return;
	    }
	    if (!this.opts.generateCues) coursePoints = null;
	    var self = this;
	    //make a function to save for later. call the function so the click
	    //registers, but save it for potentially redoing after an undo
	    var commitClick = function commitClick() {
	      if (trackPoints.length <= 1) {
	        // we need at least 2 track points to build the segment.
	        // we only get one track point back when directions fail, for example a really short
	        // attempt the wrong direction on a 1-way.
	        // this happens in reverse route esp., so let's abort and call it done.
	        rwgps.Events.trigger('map:routing_complete');
	        return;
	      }
	
	      var prevCp;
	      if (self.activeRoute.segments.length > 0) {
	        var lastSeg = self.activeRoute.lastSegment,
	            lastPt = lastSeg.nextControlPoint;
	        prevCp = lastPt;
	
	        var removingDupes = true;
	        do {
	          var dist = lastPt.distanceFromPoint(trackPoints[0]);
	          // Graphhopper frequently doubles back on the path by less than 2 meters, which triggers spur detection
	          // Consider these close enough to be duplicate points and just eliminate them.
	          if (dist < 2) {
	            trackPoints.shift();
	          } else {
	            removingDupes = false;
	          }
	        } while (removingDupes && trackPoints.length > 0);
	      } else {
	        // this is the first segment, so pop off the first point from results and we'll make it our cp
	        prevCp = trackPoints.shift();
	      }
	      // this is easier, we know the segment is getting appended so just make the last point the cp
	      var nextCp = trackPoints.pop();
	
	      var seg = new rwgps.Segment(self.activeRoute, prevCp, nextCp, trackPoints, coursePoints, lineColor);
	      if (seg) {
	        self.prevClick = seg.nextControlPoint.point;
	
	        if (self.activeRoute.startMarker == null) {
	          self.activeRoute.startMarker = new rwgps.StartIcon(seg.prevControlPoint.point, self);
	        } else if (self.activeRoute.segments.length == 1) {
	          // relocate start marker to first point of returned directions
	          self.activeRoute.startMarker.gmarker.setPosition(seg.prevControlPoint.googleLatLng());
	        }
	        seg.clickOptions.setOptions(clickOptions.getOptions());
	        // distances need to be in place for cuesheet and distance markers
	        // need to get distances in place. if we had a "set distances only" method we could use it here
	        self.activeRoute.calculateMetrics();
	        // calculateMetrics just set all our grades to 0 erroneously, need them to be null for the fetchEle call below
	        // to actually set grade properly
	        _.each(trackPoints, function (tp) {
	          tp.grade = null;
	        });
	        if (coursePoints && coursePoints.length > 0) {
	          self.drawCoursePointIcons(coursePoints);
	          self.populateCuesheet(coursePoints, true);
	        }
	
	        if (self.autoCenter) self.gmap.panTo(new google.maps.LatLng(self.prevClick.lat, self.prevClick.lng));
	
	        var updatePlanner = function updatePlanner() {
	          self.loadElevationProfile();
	          self.activeRoute.flattenBridgesAndTunnels();
	          self.relabel();
	          // resetting grade on entire route so we get good numbers across segment boundaries.
	          self.activeRoute.resetGrade();
	          self.activeRoute.calculateMetrics();
	          self.activeRoute.redrawPolylines();
	          self.snapshot();
	          rwgps.Events.trigger('map:routing_complete');
	
	          self.drawSegmentDistanceMarkers(seg);
	        };
	
	        var tpWithoutEle = _.filter(trackPoints.concat([seg.prevControlPoint, seg.nextControlPoint]), function (tp) {
	          return tp.ele == undefined || tp.ele == null;
	        });
	        if (tpWithoutEle.length > 0) {
	          self.fetchElevations(tpWithoutEle, updatePlanner);
	        } else {
	          updatePlanner();
	        }
	      } else {}
	      //TODO: error
	
	
	      // let's detect if the person clicked an intersection
	      // if a modal op is in progress (route reversal/out and back), don't do intersection click detection, these are
	      // automated clicks
	      if (!self.modalOperationInProgress && self.activeRoute.segments.length > 1) {
	        rwgps.checkSpur(self.activeRoute.lastSegment.prevSegment);
	      }
	    };
	    commitClick(); //actually do it
	
	    //handle any other clicks in the queue
	    this.dispatchNextClick();
	  },
	
	  relabel: function relabel() {
	    $(".txtDistance").text(rwgps.LabelMaker.longLabel(this.activeRoute.distance, "full"));
	    $(".txtAscent").text(rwgps.LabelMaker.shortLabel(this.activeRoute.elevationGain()));
	    $(".txtDescent").text(rwgps.LabelMaker.shortLabel(this.activeRoute.elevationLoss(), "full"));
	  },
	
	  onRoutingError: function onRoutingError(err) {
	    this.routingRequestInProgress = false;
	    if (this.routingRequestCancelled) {
	      this.routingRequestCancelled = false;
	      return;
	    }
	    trace(err);
	    if (err == 'OVER_QUERY_LIMIT') {
	      if (this.overQuota) {
	        this.overQuota = false;
	        rwgps.Events.trigger('map:routing_error');
	        return false; // don't retry, reset.
	      } else {
	        var self = this;
	        this.overQuota = true;
	        setTimeout(function () {
	          self.overQuota = false;
	        }, 10000);
	        return true; // retry
	      }
	    }
	    rwgps.Events.trigger('map:routing_error');
	    if (this.clickOptions.googleRouting() && this.clickOptions.cyclingMode()) {
	      customAlert(T.t("no_routes_found_google_cycling"));
	    } else {
	      customAlert(T.t("no_routes_found"));
	    }
	    var tps = this.activeRoute.trackPoints();
	    if (tps.length == 0) {
	      var gll = this.activeRoute.startMarker.gmarker.position;
	      this.prevClick = { lat: gll.lat(), lng: gll.lng() };
	      return false;
	    }
	    this.prevClick = tps[tps.length - 1].point;
	    return false;
	  },
	
	  /* how is this linear search as fast/faster than kdtree?
	  * implementation adapted from http://www.marsrutai.info/directions.htm
	  */
	  onMouseMove: function onMouseMove(event) {
	    if (!this.throttledOnMouseMove) {
	      this.throttledOnMouseMove = _.throttle($.proxy(this.nonthrottledOnMouseMove, this), 40);
	      this.debouncedThrottledOnMouseMove = _.debounce(this.throttledOnMouseMove, 100);
	    }
	    this.throttledOnMouseMove(event);
	    this.debouncedThrottledOnMouseMove(event);
	  },
	
	  findNearestPoint: function findNearestPoint(googleLatLng) {
	    if (this.activeRoute == null || this.activeRoute.segments.length == 0) return;
	    var tps = this.activeRoute.trackPoints();
	
	    // TODO: possibly erase getHighlightTrackPoints or whatever
	
	
	    var mousePoint = this.googleLatLngToPoint(googleLatLng);
	    var mouseX = mousePoint.x;
	    var mouseY = mousePoint.y;
	    this.nearestMousePoint1 = null;
	    this.nearestMousePoint2 = null;
	    this.nearestInterpolatedMousePoint = null;
	    if (!this.routePoints) {
	      //repopulate cache
	      this.routePoints = [];
	      for (var j = 0; j < tps.length; j++) {
	        if (tps[j].point) {
	          var pt = this.googleLatLngToPoint(tps[j].googleLatLng());
	          this.routePoints.push(pt.x);
	          this.routePoints.push(pt.y);
	          this.routePoints.push(tps[j]);
	        } else {
	          this.routePoints.push(null);
	          this.routePoints.push(null);
	          this.routePoints.push(null);
	        }
	      }
	    }
	    var minDist = 99999;
	    var minX = this.routePoints[0];
	    var minY = this.routePoints[1];
	    var x = minX;
	    var y = minY;
	    var i, closestI, lowI, highI;
	    var hasHighlighted = this.activeRoute.hasHighlightedSegment();
	    for (i = 0; i < this.routePoints.length; i += 3) {
	      var x0 = x;
	      var y0 = y;
	      x = this.routePoints[i];
	      y = this.routePoints[i + 1];
	
	      if (x == null || y == null) continue;
	
	      if (x < mouseX - 50 && x0 < mouseX - 50 || x > mouseX + 50 && x0 > mouseX + 50) continue;
	      if (y < mouseY - 50 && y0 < mouseY - 50 || y > mouseY + 50 && y0 > mouseY + 50) continue;
	
	      // If we are in 'Cue Review Mode', there is be a couple of highlighted segments on the route, and we should only interact with the highlighted segments
	      if (hasHighlighted && this.routePoints[i + 2] && (this.routePoints[i + 2].segment && this.routePoints[i + 2].segment.drawInactive || // If we're looking at a regular trackpoint with a segment that is highlighted
	      !this.routePoints[i + 2].segment && this.routePoints[i + 2].prevSegment && !this.routePoints[i + 2].prevSegment.drawInactive // if we are a controlpoint and the previous segment is highlighted
	      || !this.routePoints[i + 2].segment && this.routePoints[i + 2].nextSegment && !this.routePoints[i + 2].nextSegment.drawInactive // if we are a control point and the next segment is highlighted
	      )) {
	        continue;
	      }
	
	      var dx = x - x0;
	      var dy = y - y0;
	      var d = dx * dx + dy * dy;
	
	      var u = ((mouseX - x) * dx + (mouseY - y) * dy) / d;
	      var x2 = x + u * dx;
	      var y2 = y + u * dy;
	      var dist = (mouseX - x2) * (mouseX - x2) + (mouseY - y2) * (mouseY - y2);
	      if (dist < minDist) {
	        var d1 = (mouseX - x0) * (mouseX - x0) + (mouseY - y0) * (mouseY - y0);
	        var d2 = (mouseX - x) * (mouseX - x) + (mouseY - y) * (mouseY - y);
	        if (d1 - dist + (d2 - dist) > d) {
	          if (d1 < d2) {
	            dist = d1;
	            x2 = x0;
	            y2 = y0;
	          } else {
	            dist = d2;
	            x2 = x;
	            y2 = y;
	          }
	        }
	      }
	
	      if (dist < minDist) {
	        minDist = dist;
	        minX = x2;
	        minY = y2;
	        closestI = d1 < d2 ? i - 1 : i + 2;
	        lowI = i - 1;
	        highI = i + 2;
	        this.nearestMousePoint = this.routePoints[closestI];
	        this.nearestMousePointBehind = this.routePoints[lowI];
	        this.nearestMousePointAhead = this.routePoints[highI];
	      }
	    }
	    var nearestPoint = new google.maps.Point(minX, minY),
	        closestTpsI = (closestI - 2) / 3,
	        lowTpsI = (lowI - 2) / 3,
	        highTpsI = (highI - 2) / 3,
	        high = tps[highTpsI],
	        low = tps[lowTpsI];
	
	    if (low && low.point) {
	      var gll = this.pointToGoogleLatLng(nearestPoint);
	      this.nearestInterpolatedMousePoint = { lat: gll.lat(), lng: gll.lng() };
	
	      if (high == null || high.point == null || this.nearestInterpolatedMousePoint == null) return;
	
	      var pct = low.distanceFromLatLng(this.nearestInterpolatedMousePoint) / high.distanceFromPoint(low);
	      return {
	        distance: minDist,
	        point: nearestPoint,
	        closestI: closestTpsI,
	        lowI: lowTpsI,
	        highI: highTpsI,
	        pct: pct
	      };
	    }
	  },
	
	  nonthrottledOnMouseMove: function nonthrottledOnMouseMove(event) {
	    if (this.ignoreMouseMove) {
	      return;
	    }
	    var nearest = this.lastNearestPoint = this.findNearestPoint(event.latLng);
	
	    if (nearest && nearest.distance < 200) {
	      // find nearest controlpoints and if too close abort! (don't perform this check if we're dragging)
	      if (this.inPlanningMode()) {
	        if (!this.draggingMarker) {
	          var segToCheck = this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment || this.nearestMousePointBehind.prevSegment;
	          var nextCpPt = this.googleLatLngToPoint(segToCheck.nextControlPoint.googleLatLng());
	          var prevCpPt = this.googleLatLngToPoint(segToCheck.prevControlPoint.googleLatLng());
	          if (Math.pow(nearest.point.x - nextCpPt.x, 2) + Math.pow(nearest.point.y - nextCpPt.y, 2) < 150 || Math.pow(nearest.point.x - prevCpPt.x, 2) + Math.pow(nearest.point.y - prevCpPt.y, 2) < 150) {
	            if (this.nearestPointMarker && this.nearestPointMarker.gmarker.getMap()) {
	              this.unhighlightNearestPoint();
	            }
	            return; // abort! too close!
	          }
	        }
	      }
	      this.showNearestPointMarkerAt(this.nearestInterpolatedMousePoint);
	      //trace(this.nearestInterpolatedMousePoint + "");
	      // if there are highlighted points, the flash standalone histo is broke when trying to highlight a point so dont bother trying
	      if (this.eleProfile()) {
	        var tps = this.activeRoute.trackPoints();
	        this.updatePlayhead(tps[nearest.closestTpsI], tps);
	        rwgps.Events.trigger('map:highlight_point', nearest);
	      }
	    } else if (this.nearestPointMarker && this.nearestPointMarker.gmarker.getMap()) {
	      this.unhighlightNearestPoint();
	    }
	  },
	
	  showNearestPointMarkerAt: function showNearestPointMarkerAt(latLng) {
	    if (this.nearestPointMarker == null) {
	      this.nearestPointMarker = new rwgps.NearestPointIcon(latLng, this);
	      google.maps.event.addListener(this.nearestPointMarker.gmarker, "click", $.proxy(this.onNearestPointMarkerClicked, this));
	    }
	
	    if (this.nearestPointMarker.gmarker.getMap() == null) this.nearestPointMarker.gmarker.setMap(this.gmap);
	    if (this.nearestPointMarker.gmarker.getVisible() == false) this.nearestPointMarker.gmarker.setVisible(true);
	    this.nearestPointMarker.gmarker.setPosition(new google.maps.LatLng(latLng.lat, latLng.lng));
	    this.nearestPointMarker.gmarker.setZIndex(0); //hack, setPosition seems to reset zindex to top :(
	  },
	
	  unhighlightNearestPoint: function unhighlightNearestPoint() {
	    if (!this._playing && !this._paused && this.nearestPointMarker && this.nearestPointMarker.gmarker.getVisible()) {
	      this.nearestPointMarker.gmarker.setVisible(false);
	      rwgps.Events.trigger('map:unhighlight_nearest_point');
	      // set playback to 0 if its there
	      if ($.ui && $.ui.slider && $("#elapsed_time_slider").data("ui-slider")) {
	        $("#elapsed_time_slider").slider('option', 'value', 0);
	        $('#elapsed_time').html('00:00:00');
	      }
	    }
	  },
	
	  eleProfile: function eleProfile() {
	    var divId = this.opts.eleProfileId || 'elevation_profile';
	    return document.getElementById(divId);
	  },
	
	  mapTypeChanged: function mapTypeChanged() {
	    var mapType = this.gmap.getMapTypeId();
	    //TODO: decouple this...
	    //TODO: move rwgps click options over to the new planner options generic
	    //class...then setup ids for giRouting, etc, so this shit can just turn
	    //into a single call
	    if (mapType == "osmCycle" || mapType == "osm") {
	      this.clickOptions.osmRouting(true);
	    } else if (mapType == "esriTopo") {
	      this.clickOptions.arcgisRouting(true);
	    } else {
	      //google or usgsTopo maps
	      this.clickOptions.googleRouting(true);
	    }
	    //mapTypeChanged is only triggered when basemaps changes from upper right
	    //maptype selection, and we can only have one basemap at a time, which is
	    //the bottom most active overlay
	    this.activeOverlays[0] = this.overlays[mapType];
	    if (this.inPlanningMode()) {
	      Application.setPreference("planner_overlay", mapType, true);
	    }
	    this.onOverlayChanged();
	  },
	
	  onMapZoom: function onMapZoom() {
	    this.routePoints = null; //blow cache for mousing near route
	    //this.drawGrid();
	  },
	  onMapDragStart: function onMapDragStart() {},
	  onMapDragEnd: function onMapDragEnd() {
	    this.routePoints = null; //blow cache for mousing near route
	  },
	
	  revert: function revert() {
	    rwgps.actionsManager.revert();
	  },
	  undo: function undo() {
	    trackEvent('Route Planner', 'Route Ops', 'Undo');
	    this.zoomOut();
	    if (rwgps.actionsManager.canUndo()) {
	      rwgps.actionsManager.undo();
	    } else {
	      // if we're out of stuff to undo, revert to old behavior of
	      // lopping off segments
	      this.undoLastClick();
	      this.snapshot({ manualUndo: true });
	    }
	  },
	  redo: function redo() {
	    trackEvent('Route Planner', 'Route Ops', 'Redo');
	    this.zoomOut();
	    rwgps.actionsManager.redo();
	  },
	
	  zoomOut: function zoomOut() {
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.zoomOut();
	      if (Routes.sampleGraph.segmentSelector) Routes.sampleGraph.segmentSelector.unload();
	    }
	  },
	
	  clearSegment: function clearSegment() {
	    if (Routes.sampleGraph) {
	      if (Routes.sampleGraph.segmentSelector) Routes.sampleGraph.segmentSelector.unload();
	    }
	  },
	
	  undoLastClick: function undoLastClick() {
	    if (this.activeRoute.segments.length === 0) {
	      if (this.activeRoute.startMarker) {
	        // alright kill the start marker and really clear map
	        this.clearAllOverlays();
	        this.prevClick = null;
	        this.routes.slice(_.indexOf(this.routes, this.activeRoute), 1);
	        this.setActiveRoute(new rwgps.Route(null, this));
	        this.routes.push(this.activeRoute);
	      }
	    } else {
	      var segment = this.activeRoute.segments[this.activeRoute.segments.length - 1];
	      this.removeSegmentDistanceMarkers(segment);
	      this.activeRoute.removeSegment(segment);
	      this.prevClick = segment.prevControlPoint.point;
	    }
	
	    if (this.nearestPointMarker) {
	      this.unhighlightNearestPoint();
	    }
	
	    rwgps.Events.trigger("cp:populate", this.activeRoute.coursePoints(), false);
	    this.routePoints = null;
	    this.loadElevationProfile();
	    this.updateDistanceMarkersDisplayed();
	  },
	
	  //TODO: this doesn't remove references to markers from coursepoints...
	  //TODO: this method lies - it doesn't clear ephemerel POI either...
	  //not sure if that should be handleded here or what.
	  clearAllOverlays: function clearAllOverlays() {
	    this.closeStickyInfoWindow();
	    this.closePreviewInfoWindow();
	    var i = 0;
	    for (i = 0; i < this.routes.length; i++) {
	      this.routes[i].clearAllOverlays();
	    }
	    if (this.pointsOfInterest) {
	      for (i = 0; i < this.pointsOfInterest.length; i++) {
	        this.pointsOfInterest[i].marker.gmarker.setMap(null);
	      }
	      this.poiGBounds = null;
	    }
	    if (this.nearestPointMarker) {
	      this.unhighlightNearestPoint();
	    }
	  },
	
	  clearMapWithConfirm: function clearMapWithConfirm() {
	    trackEvent('Route Planner', 'Route Ops', 'Clear map');
	    var that = this;
	    customConfirm(T.t("clear_map_confirm"), function () {
	      that.clearMap();
	      rwgps.actionsManager.clear();
	      that.snapshot();
	    });
	  },
	  clearMapWithHistory: function clearMapWithHistory() {
	    this.clearMap();
	    rwgps.actionsManager.clear();
	    this.snapshot();
	  },
	  addRoute: function addRoute(route, setActive) {
	    this.routes.push(route);
	    if (setActive) {
	      this.setActiveRoute(route);
	    } else {
	      route.redraw();
	    }
	    rwgps.Events.trigger('map:routes_changed');
	  },
	  removeRoute: function removeRoute(route, useNextRoute) {
	    if (this.activeRoute === route) this.zoomOut();
	    route.clearAllOverlays();
	    this.removeRouteDistanceMarkers(route);
	    this.routes.splice(_.indexOf(this.routes, route), 1);
	    if (this.activeRoute === route) {
	      this.zoomOut();
	      // clear routepoints cache
	      delete this.routePoints;
	      this.activeRoute = null;
	      if (useNextRoute && this.routes.length > 0) {
	        this.setActiveRoute(this.routes[0]);
	      } else {
	        this.setActiveRoute(new rwgps.Route(null, this));
	      }
	    } else {
	      rwgps.Events.trigger('map:routes_changed', this);
	      this.snapshot();
	    }
	  },
	  redrawRoutes: function redrawRoutes() {
	    _.each(this.routes, function (route) {
	      route.redraw();
	    });
	  },
	  //for planning, clearing should completely wipe everything out
	  clearMap: function clearMap() {
	    this.zoomOut();
	    this.clearAllOverlays();
	    this.removeRouteDistanceMarkers(this.activeRoute);
	
	    delete this.pointsOfInterest;
	    this.pointsOfInterest = [];
	    this.routes = [];
	    this.activeRoute = null;
	    this.setActiveRoute(new rwgps.Route(null, this));
	    this.prevClick = null;
	    this.activeRoute.calculateMetrics();
	    this.closePreviewInfoWindow();
	    this.closeStickyInfoWindow();
	
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.data([]);
	    }
	
	    //clear auto-saved route
	    if (this.mode == "plan") $.jStorage.deleteKey("locallySavedRoute");
	  },
	
	  reverseRoute: function reverseRoute() {
	    trackEvent('Route Planner', 'Route Ops', 'Reverse');
	    this.replayRouteInReverse(true);
	  },
	  outAndBack: function outAndBack() {
	    trackEvent('Route Planner', 'Route Ops', 'Out and back');
	    this.replayRouteInReverse(false);
	  },
	  replayRouteInReverse: function replayRouteInReverse(replaceRoute) {
	    this.zoomOut();
	    if (this.opts.tripId) {
	      rwgps.Events.trigger("trip:modification_prevented");
	      return;
	    }
	    this.snapshot({ updateLast: true, doSync: true });
	    if (this.activeRoute.firstSegment) {
	      var segs = this.activeRoute.segments;
	      var lastSeg = segs[segs.length - 1];
	      var newSegmentClicks = replaceRoute ? [{
	        point: lastSeg.nextControlPoint.point,
	        opts: lastSeg.clickOptions,
	        color: lastSeg.color,
	        fetchEles: true
	      }] : [];
	      var delay = 0;
	      for (var i = segs.length - 1; i >= 0; --i) {
	        var seg = segs[i];
	        if (segs.length - i == 6) {
	          delay = 1000;
	        }
	        var click = {
	          point: seg.prevControlPoint.point,
	          opts: seg.clickOptions,
	          color: seg.color,
	          fetchEles: true,
	          delay: delay
	        };
	        // if we don't expect any course points, we can just reverse the points in the segment
	        // this allows for recorded data to be properly reversed.
	        // we need points without distance set though, and metrics calculator will set them properly.
	        if (seg.coursePoints.length === 0) {
	          click.points = _.map(seg.trackPoints, function (pt) {
	            return pt.shallowClone();
	          }).reverse();
	        }
	        newSegmentClicks.push(click);
	      }
	
	      if (replaceRoute) {
	        // figure out where the route was in order
	        var idx = _.indexOf(this.routes, this.activeRoute);
	        // remove route, which creates a new one and pushes to end of list.
	        var rData = this.activeRoute.routeData;
	        var pois = this.activeRoute.pois;
	        this.removeRoute(this.activeRoute);
	        // so pop it off and stick it in the right place
	        var r = this.routes.pop();
	        r.routeData = rData; // retain route name and other metadata
	        r.pois = pois;
	        this.routes.splice(idx, 0, r);
	        this.loadPois(r.pois);
	        rwgps.Events.trigger('map:routes_changed');
	      }
	      _.each(newSegmentClicks, function (clickAttrs) {
	        this.clicks.push(clickAttrs);
	      }, this);
	      var onRoutingError,
	          onRoutingComplete,
	          forceCancel,
	          unbindHandlers,
	          totalRoutingOps = _.reduce(newSegmentClicks, function (acc, click) {
	        return acc + (click.opts.followRoads() ? 1 : 0);
	      }, 0),
	          totalClickOps = newSegmentClicks.length - (replaceRoute ? 1 : 0),
	          clickOpsComplete = 0,
	          useModal = totalRoutingOps > 4;
	
	      unbindHandlers = function unbindHandlers() {
	        rwgps.Events.unbind('map:routing_error', onRoutingError);
	        rwgps.Events.unbind('map:routing_complete', onRoutingComplete);
	        rwgps.Events.unbind('map:modal_operation_cancelled', forceCancel);
	      };
	      forceCancel = _.bind(function () {
	        unbindHandlers();
	        this.clicks = [];
	        if (this.routingRequestInProgress) {
	          this.routingRequestCancelled = true;
	        }
	        this.snapshotsDisabled = false;
	        this.revert();
	      }, this);
	      onRoutingComplete = _.bind(function () {
	        clickOpsComplete++;
	        if (useModal) rwgps.Events.trigger('map:modal_operation_progress', clickOpsComplete, totalClickOps);
	        if (clickOpsComplete == totalClickOps) {
	          unbindHandlers();
	          if (useModal) {
	            rwgps.Events.trigger('map:modal_operation_complete');
	            this.modalOperationInProgress = false;
	          }
	          this.snapshotsDisabled = false;
	          this.snapshot();
	        }
	      }, this);
	      onRoutingError = _.bind(function () {
	        unbindHandlers();
	        this.clicks = [];
	        this.snapshotsDisabled = false;
	        rwgps.Events.trigger('map:reverted_due_to_error');
	        this.revert();
	      }, this);
	      this.snapshotsDisabled = true;
	      rwgps.Events.bind('map:routing_complete', onRoutingComplete);
	      rwgps.Events.bind('map:routing_error', onRoutingError);
	      rwgps.Events.bind('map:modal_operation_cancelled', forceCancel);
	      if (useModal) {
	        this.modalOperationInProgress = true;
	        rwgps.Events.trigger('map:modal_operation_started');
	      }
	      this.dispatchNextClick();
	    }
	  },
	
	  removeAllNonActiveRoutes: function removeAllNonActiveRoutes() {
	    //TODO: this doesn't take into account partial route segments on the map...should preview
	    //routes be in a separate collection than just the map routes array?
	    _.map(this.routes, function (rt) {
	      if (rt != this.activeRoute) rt.removeFromMap();
	    });
	    if (this.previewInfoWindow) this.previewInfoWindow.close();
	    if (this.stickyInfoWindow) this.stickyInfoWindow.close();
	  },
	
	  loadRoute: function loadRoute(route, drawEndMarker) {
	    var drawEnd = drawEndMarker === undefined ? true : drawEndMarker == true;
	    var seg = route.segments[0],
	        i = 0;
	    route.map = this;
	
	    if (route.segments.length > 0) {
	      var pt = seg.prevControlPoint.point;
	      if (!pt) {
	        // it's a trip without location on the first n points, try to find a point w/ location
	        for (i = 0; i < seg.trackPoints.length; i++) {
	          if (seg.trackPoints[i].point) {
	            pt = seg.trackPoints[i].point;
	            break;
	          }
	        }
	      }
	      route.startMarker = new rwgps.StartIcon(pt, this);
	      seg = route.segments[route.segments.length - 1];
	      if (drawEnd) route.endMarker = new rwgps.EndIcon(seg.nextControlPoint.point, this);
	      for (i = 0; i < route.segments.length; i++) {
	        route.segments[i].addToMap(this);
	      }
	    }
	
	    this.routes.push(route);
	  },
	
	  loadRouteForEdit: function loadRouteForEdit(routeObj, leaveViewportAlone, initialLoad) {
	    //this.clearAllOverlays();
	    var route, tps;
	    if (routeObj.track_points) {
	      route = new rwgps.Route(routeObj, this, { planning: true });
	      this.loadRoute(route, false);
	    } else if (_.isFunction(routeObj.trackPoints)) {
	      route = routeObj;
	      this.loadRoute(route, false);
	    } else if (routeObj.start_point) {
	      route = new rwgps.Route(null, this);
	      this.prevClick = { lat: routeObj.start_point.y, lng: routeObj.start_point.x };
	      this.setActiveRoute(route);
	      this.activeRoute.startMarker = new rwgps.StartIcon(this.prevClick, this);
	    } else {
	      route = new rwgps.Route(null, this);
	    }
	
	    tps = route.trackPoints();
	    if (tps.length > 0) {
	      this.prevClick = tps[tps.length - 1].point;
	    }
	
	    this.setActiveRoute(route);
	    rwgps.Events.trigger('pois:populate', this.activePointsOfInterest());
	    route.drawControlPoints(this);
	
	    if (!leaveViewportAlone) {
	      this.recenterMap();
	    }
	
	    if (initialLoad) this.snapshot();
	
	    return route;
	  },
	
	  loadRouteForView: function loadRouteForView(route, afterEleCb) {
	    this.clearAllOverlays(); //TODO: should I call this? or make it an option?
	    this.loadRoute(route, true);
	    this.gmap.fitBounds(route.gBounds);
	
	    //rethink this...loading route doesn't always mean we want to make it active and load its cuesheet
	    this.setActiveRoute(route);
	
	    if (afterEleCb) this.afterLoadElevationProfileFn = afterEleCb;
	  },
	  loadPois: function loadPois(raw, readOnly) {
	    //pois being loaded for editing (editing a route) need to be flagged.
	    if (readOnly === undefined) readOnly = true;
	    if (this.pointsOfInterest) {
	      _.each(this.pointsOfInterest, function (poi) {
	        poi.marker.gmarker.setMap(null);
	      });
	    }
	
	    // if we're handed instantiated poi, just use the reference, otherwise instantiate
	    // this is important to ensure route planner poi editing doesn't revert changes due
	    // to having multiple copies of a poi (between route.pois and map.pointsOfInterest)
	    var pois = _.map(raw, function (poi) {
	      if (_.isFunction(poi.toSaveObj)) {
	        return poi;
	      } else {
	        return rwgps.PointOfInterest.fromJSON([poi], readOnly)[0];
	      }
	    });
	
	    this.pointsOfInterest = pois;
	    this.poiGBounds = new google.maps.LatLngBounds();
	    var self = this;
	    _.each(this.pointsOfInterest, function (poi) {
	      self.poisById[poi.id] = poi;
	      poi.marker = new rwgps.PoiIcon(poi, self);
	      self.poiGBounds.extend(poi.googleLatLng());
	    });
	    if (!this.opts.poiEnabled) {
	      pois.forEach(function (_ref3) {
	        var gmarker = _ref3.marker.gmarker;
	        return gmarker.setMap(null);
	      });
	    }
	  },
	
	  // the below POI editing/viewing functions are copied and modified from coursepoint
	  // functions doing similar things. if you refactor this, make sure to refactor coursepoint stuff too
	  openPreviewInfoWindow: function openPreviewInfoWindow(poi, pan) {
	    pan = pan == undefined ? true : pan;
	    if (this.previewInfoWindow) {
	      this.previewInfoWindow.close();
	      this.previewInfoWindow = null;
	    }
	    this.previewInfoWindow = new InfoBox({
	      position: poi.googleLatLng(),
	      content: this.contentForPoiInfoWindow(poi, true),
	      disableAutoPan: !pan,
	      maxWidth: 0,
	      pixelOffset: new google.maps.Size(-140, -40),
	      alignBottom: true,
	      zIndex: null,
	      closeBoxURL: "",
	      boxStyle: {
	        opacity: 0.90,
	        minWidth: "200px",
	        maxWidth: "260px",
	        padding: "10px",
	        border: "1px solid black",
	        background: "white"
	      },
	      closeBoxMargin: "2px 2px 2px 2px",
	      infoBoxClearance: new google.maps.Size(1, 1),
	      isHidden: false,
	      pane: "floatPane",
	      enableEventPropagation: false
	    });
	    google.maps.event.addListener(this.previewInfoWindow, "closeclick", $.proxy(this.closePreviewInfoWindow, this));
	    google.maps.event.clearListeners(this.previewInfoWindow, "domready");
	    google.maps.event.addListener(this.previewInfoWindow, "domready", $.proxy(function () {
	      this.initInfoWindowHandlers();
	    }, this));
	    this.disableClicks(); // disable map interaction while infowindow is open
	    this.previewInfoWindow.open(this.gmap); //, (poi.marker ? poi.marker.gmarker : null));
	  },
	  openStickyInfoWindow: function openStickyInfoWindow(poi, pan) {
	    if (this.openPoi && this.openPoi.marker) this.openPoi.marker.enableMouseOverOut();
	    if (poi.marker) poi.marker.disableMouseOverOut();
	
	    this.openGenericStickyInfoWindow(poi.point, this.contentForPoiInfoWindow(poi), pan);
	
	    google.maps.event.addListener(this.stickyInfoWindow, "domready", $.proxy(function () {
	      tb_init("a.thickbox");
	      this.initPoiInfoWindowHandlers(poi);
	      this.initPointPhotoWidget(poi);
	    }, this));
	
	    this.openPoi = poi;
	  },
	  openGenericStickyInfoWindow: function openGenericStickyInfoWindow(point, content, pan) {
	    pan = pan == undefined ? true : pan;
	    this.closePreviewInfoWindow(); //close any preview windows open from mouseover
	    if (this.stickyInfoWindow) {
	      this.stickyInfoWindow.close();
	      this.stickyInfoWindow = null;
	    }
	    this.stickyInfoWindow = new InfoBox({
	      position: new google.maps.LatLng(point.lat, point.lng),
	      content: content,
	      disableAutoPan: !pan,
	      maxWidth: 0,
	      pixelOffset: new google.maps.Size(-140, -40),
	      alignBottom: true,
	      zIndex: null,
	      boxStyle: {
	        opacity: 1.0,
	        zIndex: 1000,
	        minWidth: "240px",
	        maxWidth: "400px",
	        overflow: "auto",
	        maxHeight: "500px",
	        padding: "20px",
	        background: '#FFFFFF',
	        border: '1px solid #E8E8E8',
	        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.20)'
	      },
	      closeBoxMargin: "2px 2px 2px 2px",
	      infoBoxClearance: new google.maps.Size(10, 10),
	      isHidden: false,
	      pane: "floatPane",
	      enableEventPropagation: false
	    });
	    google.maps.event.addListener(this.stickyInfoWindow, "closeclick", $.proxy(this.closeStickyInfoWindow, this));
	    google.maps.event.clearListeners(this.stickyInfoWindow, "domready");
	    google.maps.event.addListener(this.stickyInfoWindow, "domready", $.proxy(function () {
	      this.initInfoWindowHandlers();
	    }, this));
	    this.disableClicks(); // disable map interaction while infowindow is open
	    this.stickyInfoWindow.open(this.gmap);
	  },
	  //TODO: this doesn't belong in map.js
	  initPointPhotoWidget: function initPointPhotoWidget(point) {
	    if (!point || !window.rwgpsG_views_photos) return;
	
	    var photos = _.map(point.photoIds, function (id) {
	      return { id: id };
	    });
	    var PhotosView = rwgpsG_views_photos;
	    if (!PhotosView) return;
	    var photosView = new PhotosView({
	      container: '#poiInfoWindowContent .photos_view, #coursePointInfoWindowContent .photos_view',
	      photos: photos,
	      canEdit: true,
	      photosetDisabled: true
	    });
	
	    photosView.bind('photo:added', function (photo) {
	      point.photoIds.push(photo.id);
	    });
	    photosView.bind('photo:deleted', function (photo) {
	      point.photoIds = _.without(point.photoIds, photo.id);
	    });
	  },
	  initPoiInfoWindowHandlers: function initPoiInfoWindowHandlers(poi) {
	    if (this.inPlanningMode() && poi.isEditable()) {
	      $('#poiInfoWindowContent select.poiType').msDropDown();
	    }
	  },
	  contentForPoiInfoWindow: function contentForPoiInfoWindow(poi, preview) {
	    if (preview == undefined) preview = false;
	    if (this.inPlanningMode() && poi.isEditable() && rwgps.config.privileges['advanced_planning']) {
	      return poi.editHtml();
	    } else {
	      //just show it
	      if (preview) return poi.previewHtml();
	      return poi.showHtml();
	    }
	  },
	  deletePoi: function deletePoi(poi) {
	    poi = poi || this.openPoi;
	    if (!poi) return;
	
	    poi.marker.gmarker.setMap(null); // remove from the map
	    this.pointsOfInterest.splice(_.indexOf(this.pointsOfInterest, poi), 1);
	    this.activeRoute.pois.splice(_.indexOf(this.activeRoute.pois, poi), 1);
	    if (poi.id) {
	      delete this.poisById[poi.id];
	      rwgps.Events.trigger("pois:deleted", [poi]);
	    }
	
	    this.closePreviewInfoWindow();
	    this.closeStickyInfoWindow();
	    this.snapshot();
	
	    rwgps.Events.trigger("pois:populate", this.activePointsOfInterest());
	  },
	  closeStickyInfoWindow: function closeStickyInfoWindow() {
	    if (this.openPoi) {
	      if (this.openPoi.marker) this.openPoi.marker.enableMouseOverOut();
	
	      if (this.openPoi._new) {
	        var poi = this.openPoi;
	        poi.marker.gmarker.setMap(null); // remove from the map
	        var idx = _.indexOf(this.pointsOfInterest, poi);
	        this.pointsOfInterest.splice(idx, 1);
	        if (poi.id) delete this.poisById[poi.id];
	        rwgps.Events.trigger("pois:populate", this.activePointsOfInterest());
	      }
	      this.openPoi = null;
	    }
	    if (this.stickyInfoWindow) this.stickyInfoWindow.close();
	    this.enableClicks(); //re-enable map interaction since infowindow is closed...
	  },
	  closePreviewInfoWindow: function closePreviewInfoWindow() {
	    this.openPoi = null;
	    if (this.previewInfoWindow) this.previewInfoWindow.close();
	    this.enableClicks(); //re-enable map interaction since infowindow is closed...
	  },
	  savePoi: function savePoi(poi) {
	    poi = poi || this.openPoi;
	    if (!poi) return;
	    if (poi._new) delete poi._new;
	    this.poisById[poi.id] = poi;
	    poi.poiType = $("#poiInfoWindowContent select.poiType").val();
	    poi.name = $("#poiInfoWindowContent .poiName").val();
	    poi.description = $("#poiInfoWindowContent textarea.poiDescription").val();
	    poi.attribution = $("#poiInfoWindowContent .poiAttribution").val();
	    poi.url = $("#poiInfoWindowContent .poiUrl").val();
	    poi.addToPoiLibrary = $("#poiInfoWindowContent .addToPoiLibrary").prop("checked");
	    poi.saveOrUpdate = $("#poiInfoWindowContent input:radio[name='saveOrUpdate']:checked").val();
	    if (poi.marker) poi.marker.gmarker.setMap(null);
	    poi.marker = new rwgps.PoiIcon(poi, this);
	
	    this.closeStickyInfoWindow();
	    rwgps.Events.trigger('pois:populate', this.activePointsOfInterest());
	    this.snapshot();
	  },
	  // pois excluding ghosted ones
	  activePointsOfInterest: function activePointsOfInterest() {
	    return _.select(this.pointsOfInterest, function (poi) {
	      return !poi.ghosted;
	    });
	  },
	  pointsOfInterestObjs: function pointsOfInterestObjs() {
	    return _.map(this.pointsOfInterest, function (poi) {
	      return poi.toSaveObj();
	    });
	  },
	
	  gotoLatLng: function gotoLatLng(lat, lng, showMarker) {
	    return this.gotoPoint({ lat: lat, lng: lng }, showMarker);
	  },
	  gotoPoint: function gotoPoint(point, showMarker) {
	    var _this5 = this;
	
	    if (isNaN(point.lat) || isNaN(point.lng)) return;
	    var googleLatLng = new google.maps.LatLng(point.lat, point.lng);
	    this.gmap.setCenter(googleLatLng);
	    if (showMarker) {
	      var opts = {
	        position: googleLatLng,
	        clickable: true
	      };
	      if (this._gotoMarker) this._gotoMarker.setMap(null);
	      var marker = new google.maps.Marker(opts);
	      this._gotoMarker = marker;
	      var self = this;
	      var clickFn = function clickFn() {
	        var content = '<div style="height:60px;margin-top:15px;text-align:center;padding-top:10px">' + ("<div style='display:flex;justify-content:space-around'><a href=\"javascript:;\" class=\"route_to_point btn btn-primary\">" + (!self.prevClick ? 'Start route here' : 'Route to here') + "</a>") + '<a href="javascript:;" class="remove_marker btn btn-secondary" style="border:1px solid #f60;margin-left:10px">Remove marker</a></div>' + '</div>';
	        self.openGenericStickyInfoWindow(point, content, true);
	        google.maps.event.addListener(self.stickyInfoWindow, "domready", function () {
	          $(".route_to_point").click(function () {
	            rwgps.Events.trigger("map:route_to_point", point);
	            if (_this5._gotoMarker) _this5._gotoMarker.setMap(null);
	            return false;
	          });
	          $(".remove_marker").click(function () {
	            Routes.activeMap.closeStickyInfoWindow();
	            if (_this5._gotoMarker) _this5._gotoMarker.setMap(null);
	            return false;
	          });
	        });
	      };
	      google.maps.event.addListener(marker, 'click', clickFn);
	      marker.setMap(this.gmap);
	      setTimeout(clickFn, 0);
	      return marker;
	    }
	  },
	
	  gotoLocation: function gotoLocation(str, showMarker) {
	    var self = this;
	    // just realized we arent using jquery 1.5 so doing this manually
	    // instead of using $.Deferred
	    var dfd = new function () {
	      var self = this;
	      this.done = function (fn) {
	        self.doneCb = fn;return this;
	      };
	      this.fail = function (fn) {
	        self.failCb = fn;return this;
	      };
	      this.resolve = function () {
	        self.doneCb.apply(self, arguments);
	      };
	    }();
	    // first try our cache from /places/search autocompleter
	    var latLngMatch = str.match(/^[ ]*(-?[0-9]+\.[0-9]+)[ ]*,?[ ]*(-?[0-9]+\.[0-9]+)[ ]*$/),
	        marker;
	    if (rwgps.places[str]) {
	      marker = this.gotoLatLng(rwgps.places[str].y, rwgps.places[str].x, showMarker);
	      return { done: function done(fn) {
	          fn.call(self, marker);
	        } };
	    } else if (latLngMatch) {
	      marker = this.gotoLatLng(latLngMatch[1], latLngMatch[2], showMarker);
	      _.defer(function () {
	        dfd.resolve(marker);
	      }); // needs to happen async so the doneCb can get assigned first.
	      return dfd;
	    }
	    var gc = new google.maps.Geocoder();
	    var opts = {
	      address: str,
	      location: this.gmap.getCenter(),
	      bounds: this.gmap.getBounds(),
	      language: this.language, //set on map initialization
	      region: this.region //set on map initialization
	    };
	    gc.geocode(opts, function (results, status) {
	      if (status == google.maps.GeocoderStatus.OK) {
	        //TODO: iterate through results and find best?
	        //not sure if they are returned in order of accuracy
	        if (results.length > 0 && results[0].geometry) {
	          var gll = results[0].geometry.location;
	          dfd.resolve(self.gotoPoint({ lat: gll.lat(), lng: gll.lng() }, showMarker));
	        } else {
	          dfd.failCb();
	        }
	      } else {
	        dfd.failCb();
	      }
	    });
	    return dfd;
	  },
	
	  geocode: function geocode(addr, success, error) {
	    var self = this;
	    var gc = new google.maps.Geocoder();
	    var opts = {
	      address: addr,
	      location: this.gmap.getCenter(),
	      bounds: this.gmap.getBounds(),
	      language: this.language, //set on map initialization
	      region: this.region //set on map initialization
	    };
	    gc.geocode(opts, function (results, status) {
	      self.geocodingResponse(results, status, success, error);
	    });
	  },
	  reverseGeocode: function reverseGeocode(latLng, success, error) {
	    var self = this;
	    var gc = new google.maps.Geocoder();
	    var opts = {
	      latLng: latLng,
	      language: this.language, //set on map initialization
	      region: this.region //set on map initialization
	    };
	    gc.geocode(opts, function (results, status) {
	      self.geocodingResponse(results, status, success, error);
	    });
	  },
	  geocodingResponse: function geocodingResponse(results, status, success, error) {
	    if (status == google.maps.GeocoderStatus.OK) {
	      var location = {};
	      var aa2, aa3; //if no first level AA, we might default to lower level ones (county)
	      //first result is the most specific
	      if (results.length > 0 && results[0].address_components) {
	        if (results[0].geometry && results[0].geometry.location) {
	          location["lat"] = results[0].geometry.location.lat();
	          location["lng"] = results[0].geometry.location.lng();
	        }
	        _.each(results[0].address_components, function (com) {
	          _.each(com.types, function (type) {
	            if (type == "country") location["country_code"] = com.short_name;
	            if (type == "administrative_area_level_1") location["administrative_area"] = com.long_name;
	            if (type == "locality") location["locality"] = com.long_name;
	            if (type == "postal_code") location["postal_code"] = com.long_name;
	            if (type == "administrative_area_level_2") aa2 = com.long_name;
	            if (type == "administrative_area_level_3") aa3 = com.long_name;
	          });
	        });
	        if (!location["administrative_area"]) {
	          if (aa2) location["administrative_area"] = aa2;else location["administrative_area"] = aa3;
	        }
	        success(location);
	      } else {
	        //TODO: no results
	        success({});
	      }
	    } else if (status === 'ZERO_RESULTS') {
	      // no results, nothing to assign but no need to throw error
	      success({});
	    } else {
	      error(status);
	    }
	  },
	
	  drawCoursePointIcons: function drawCoursePointIcons(points) {
	    var self = this,
	        showAll = this.showCoursePointIcons;
	    if (showAll || this.inPlanningMode()) {
	      _.map(points, function (pt) {
	        if (showAll) {
	          if (pt.marker) {
	            pt.marker.gmarker.setMap(self.gmap);
	          } else {
	            var marker = new rwgps.CoursePointIcon(pt, self);
	            pt.marker = marker;
	          }
	        }
	      });
	    }
	  },
	  removeCoursePointIcons: function removeCoursePointIcons(points) {
	    _.map(points, function (pt) {
	      if (pt.marker && pt.marker.gmarker) pt.marker.gmarker.setMap(null);
	    });
	  },
	
	  populateCuesheet: function populateCuesheet(points, append) {
	    if (append === undefined) append = false;
	    rwgps.Events.trigger("cp:populate", points, append);
	  },
	
	  resize: function resize() {
	    if (this.activeRoute || this.staticBounds) {
	      google.maps.event.trigger(this.gmap, 'resize');
	      var bounds = this.inclusiveBounds();
	      if (!bounds.isEmpty()) this.gmap.fitBounds(bounds);
	    }
	  },
	
	  setColor: function setColor(color, suppressEvent) {
	    //color is either a hex string or an int...handle both!
	    this.lineColor = parseInt(color);
	    if (!suppressEvent) rwgps.Events.trigger("map:colorChanged", rwgps.Segment.cssColor(this.lineColor));
	  },
	
	  showCoursePointMarker: function showCoursePointMarker(cp) {
	    this.coursePointPopup.setCoursePoint(cp);
	    this.coursePointPopup.show();
	  },
	  hideCoursePointMarker: function hideCoursePointMarker() {
	    this.coursePointPopup.hide();
	  },
	
	  //swap the draw route click handler for the add
	  //coursepoint click handler
	  enableAddCoursePoint: function enableAddCoursePoint() {
	    this.addCoursePointEnabled = true;
	    this.disableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.bind('pointselected', this.addCoursePointAtIndex);
	    }
	  },
	  disableAddCoursePoint: function disableAddCoursePoint() {
	    this.addCoursePointEnabled = false;
	    this.enableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.unbind('pointselected', this.addCoursePointAtIndex);
	    }
	  },
	  addControlPointAtIndex: function addControlPointAtIndex(pointsAround) {
	    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];
	    if (!pt.isControlPoint) {
	      var segmentI = _.indexOf(pt.segment.trackPoints, pt);
	      pt.segment.splitAfter(segmentI);
	    }
	  },
	  addCoursePointAtIndex: function addCoursePointAtIndex(pointsAround) {
	    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];
	    this.openCoursePointInfoWindow(new rwgps.CoursePoint({
	      point: pt.point,
	      trackPoint: pt,
	      segment: pt.segment,
	      distance: pt.distance
	    }));
	  },
	  enableAddControlPoint: function enableAddControlPoint() {
	    this.addControlPointEnabled = true;
	    this.disableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.bind('pointselected', this.addControlPointAtIndex);
	    }
	    rwgps.Events.bind('map:control_point_clicked', this.onControlPointClickRemove);
	  },
	  onControlPointClickRemove: function onControlPointClickRemove(cp) {
	    // removing control points has a different behavior in cue review mode
	    if (cp.trackPoint.nextSegment && cp.trackPoint.prevSegment && (cp.trackPoint.prevSegment.drawInactive === true && cp.trackPoint.nextSegment.drawInactive === false || cp.trackPoint.prevSegment.drawInactive === false && cp.trackPoint.nextSegment.drawInactive === true)) {
	      return;
	    }
	
	    var seg = cp.trackPoint.prevSegment;
	    seg.slurpNext();
	    // slurpNext removes course point icons and mile markers
	    cp.map.drawCoursePointIcons(seg.coursePoints);
	    cp.map.drawRouteDistanceMarkers(cp.map.activeRoute);
	    cp.map.snapshot({ updateLast: true });
	  },
	  disableAddControlPoint: function disableAddControlPoint() {
	    this.addControlPointEnabled = false;
	    this.enableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.unbind('pointselected', this.addControlPointAtIndex);
	    }
	    rwgps.Events.unbind('map:control_point_clicked', this.onControlPointClickRemove);
	  },
	
	  enableRouteSplitter: function enableRouteSplitter() {
	    this.routeSplitterEnabled = true;
	    this.disableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.bind('pointselected', this.splitRouteAtIndex, this);
	    }
	  },
	  disableRouteSplitter: function disableRouteSplitter() {
	    this.routeSplitterEnabled = false;
	    this.enableClicks();
	    if (Routes.sampleGraph) {
	      Routes.sampleGraph.unbind('pointselected', this.splitRouteAtIndex);
	    }
	  },
	  splitRouteAtIndex: function splitRouteAtIndex(pointsAround) {
	    this.addControlPointAtIndex(pointsAround);
	    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];
	
	    return this.splitRouteOnTrackPoint({ trackPoint: pt, idx: pointsAround.closestI });
	  },
	
	  openCoursePointInfoWindow: function openCoursePointInfoWindow(cp, sticky) {
	    if (sticky === undefined) sticky = true;
	    var window, pan;
	
	    if (sticky) {
	      pan = true;
	    } else {
	      // stickyInfoWindow doesn't get nulled out on close, but the dom element goes away
	      // it does get nulled out when a preview window is shown on hover though
	      if (this.stickyInfoWindow && $('#coursePointInfoWindowContent').get(0)) {
	        // no previews when a stick window is open, user must close first
	        return;
	      }
	      pan = false;
	    }
	
	    if (this.stickyInfoWindow) this.stickyInfoWindow.close();
	    if (this.previewInfoWindow) this.previewInfoWindow.close();
	
	    window = new google.maps.InfoWindow({
	      position: cp.googleLatLng(),
	      maxWidth: 220,
	      disableAutoPan: !pan,
	      content: this.contentForCoursePointInfoWindow(cp)
	    });
	    google.maps.event.addListener(window, "closeclick", $.proxy(this.closeCoursePoint, this));
	    if (sticky) {
	      google.maps.event.addListener(window, "domready", $.proxy(function () {
	        this.initPointPhotoWidget(cp);
	        this.initInfoWindowHandlers();
	      }, this));
	      this.disableClicks(); //disable map interaction while infowindow is open
	      this.openCoursePoint = cp;
	    }
	    window.open(this.gmap);
	    if (sticky) {
	      this.stickyInfoWindow = window;
	      this.previewInfoWindow = null;
	    } else {
	      this.stickyInfoWindow = null;
	      this.previewInfoWindow = window;
	    }
	  },
	
	  contentForCoursePointInfoWindow: function contentForCoursePointInfoWindow(cp) {
	    if (this.inPlanningMode() && rwgps.config.privileges['advanced_planning']) {
	      return cp.editHtml();
	    } else {
	      //just show it
	      return cp.showHtml();
	    }
	  },
	  deleteCoursePoint: function deleteCoursePoint(cp) {
	    cp = cp || this.openCoursePoint;
	    if (!cp) return;
	    cp.segment.removeCoursePoint(cp);
	    this.closeCoursePoint();
	    this.snapshot();
	  },
	  closeCoursePoint: function closeCoursePoint() {
	    this.openCoursePoint = null;
	    if (this.stickyInfoWindow) {
	      this.stickyInfoWindow.close();
	      this.enableClicks(); //re-enable map interaction since infowindow is closed...
	    }
	  },
	  saveCoursePoint: function saveCoursePoint(cp) {
	    cp = cp || this.openCoursePoint;
	    if (!cp) return;
	    var oldRow = cp.row;
	    cp.type = $("#coursePointInfoWindowContent select.coursePointType").val();
	    cp.notes = $("#coursePointInfoWindowContent textarea.coursePointDescription").val();
	    cp.description = $("#coursePointInfoWindowContent textarea.coursePointLongDescription").val();
	    cp.edited = true; // always display cp markers for edited cps
	    if (Routes && Routes.Common) cp.row = Routes.Common.createCoursePointRow(cp);
	    if (!cp.marker) cp.marker = new rwgps.CoursePointIcon(cp, this);
	
	    if (oldRow) {
	      //editing, not adding a new one
	      oldRow.after(cp.row).remove();
	    } else {
	      //new point, let's be lazy and just redraw the whole thing instead
	      //of figuring out where to insert the point
	      cp.segment.insertCoursePoint(cp);
	      rwgps.Events.trigger("cp:populate", cp.segment.route.coursePoints(), false);
	    }
	    this.closeCoursePoint();
	    this.snapshot();
	  },
	
	  initializeLocallySavedRoute: function initializeLocallySavedRoute() {
	    if (this.mode == "plan") $.jStorage.deleteKey("locallySavedRoute");
	  },
	
	  callWhenReady: function callWhenReady(fn) {
	    var _this6 = this;
	
	    if (this._mapIsReady) {
	      fn();
	    } else if (this.gmap && this.gmap.getMapTypeId() != null) {
	      _.defer(function () {
	        _this6._mapIsReady = true;
	        fn();
	      });
	    } else {
	      var self = this;
	      setTimeout(function () {
	        self.callWhenReady(fn);
	      }, 100);
	    }
	  },
	
	  setOption: function setOption(opt, val) {
	    var _this7 = this;
	
	    if (opt.match("avoid")) this.clickOptions.setOption(opt, val);
	    switch (opt) {
	      case "show_coursepoint_icons":
	        this.showCoursePointIcons = val;
	        if (val) {
	          this.drawCoursePointIcons(this.activeRoute.coursePoints());
	        } else {
	          this.removeCoursePointIcons(this.activeRoute.coursePoints());
	        }
	        break;
	      case "show_control_point_icons":
	        this.showControlPointIcons = val;
	        if (val) {
	          this.activeRoute.drawControlPoints(this);
	        } else {
	          this.activeRoute.clearControlPoints();
	        }
	        break;
	      case "auto_center":
	        this.opts.autoCenter = val;
	        break;
	      case "show_distance_markers":
	        this.distanceMarkersEnabled(val);
	        break;
	      case "generate_cues":
	        this.generateCues(val);
	        break;
	      case 'show_pois':
	        this.opts.poiEnabled = val;
	        if (val) {
	          for (var i = 0; i < this.pointsOfInterest.length; i++) {
	            this.pointsOfInterest[i].marker.gmarker.setMap(this.gmap);
	          }
	        } else {
	          for (var x = 0; x < this.pointsOfInterest.length; x++) {
	            this.pointsOfInterest[x].marker.gmarker.setMap(null);
	          }
	        }
	        break;
	      case "enable_scrollwheel_zoom":
	        this.gmap.set('scrollwheel', val ? true : false);
	        this.opts.scrollwheel = val;
	        break;
	      case 'show_surface':
	        this.opts.showSurface = val;
	        if (val) {
	          this.activeRoute.segments.forEach(function (seg) {
	            return seg.sPolylines.forEach(function (pl) {
	              return pl.setMap(_this7.gmap);
	            });
	          });
	        } else {
	          // map over and remove only surface gPolylines
	          this.activeRoute.segments.forEach(function (seg) {
	            return seg.sPolylines.forEach(function (pl) {
	              return pl.setMap(null);
	            });
	          });
	        }
	    }
	  },
	
	  loadElevationProfile: function loadElevationProfile() {
	    if (!this.debouncedLoadElevationProfile) {
	      this.debouncedLoadElevationProfile = _.debounce(this.realLoadElevationProfile, 100);
	    }
	    this.debouncedLoadElevationProfile();
	  },
	  realLoadElevationProfile: function realLoadElevationProfile() {
	    if ($('#elevation_profile').length == 0) return;
	    var points = this.activeRoute.trackPoints();
	    if (Routes.sampleGraph) {
	      // if we're not already loading elevation, check for nulls and load them up while we're here
	      // this should happen on-load for a bad route, and after the rare case where the null eles get
	      // set. that means it shouldn't happen often, so use badEleLoadSemaphore to throttle it heavily
	      if (this.inPlanningMode() && !this.badEleLoadSemaphore) {
	        // we fetch ele from latlng, so filter out points missings those values too
	        var pointsWithoutEle = _.filter(points, function (pt) {
	          return !pt.fetchingEle && pt.lat && pt.lng && (pt.ele === undefined || pt.ele === null);
	        });
	        if (pointsWithoutEle.length > 0) {
	          this.badEleLoadSemaphore = true;
	          var that = this;
	          setTimeout(function () {
	            delete that.badEleLoadSemaphore;
	          }, 5000);
	          this.fetchElevations(pointsWithoutEle, $.proxy(function () {
	            this.loadElevationProfile();
	            this.snapshot({ updateLast: true });
	          }, this), function (msg) {
	            trace(msg);
	          });
	        }
	      }
	
	      Routes.sampleGraph.data(points);
	      Routes.sampleGraph.render();
	      if (this.afterLoadElevationProfileFn) this.afterLoadElevationProfileFn();
	    } else {
	      // try again, not loaded yet
	      var self = this;
	      setTimeout(function () {
	        self.loadElevationProfile();
	      }, 100);
	    }
	  },
	
	  /* playback features */
	  setPlaybackSpeed: function setPlaybackSpeed(val) {
	    try {
	      Routes.sampleGraph.setPlaybackSpeed(val);
	    } catch (e) {} // eslint-disable-line no-empty
	  },
	  setPlaybackPercentage: function setPlaybackPercentage(val) {
	    try {
	      Routes.sampleGraph.setPlaybackPercentage(val);
	    } catch (e) {} // eslint-disable-line no-empty
	  },
	  startPlayback: function startPlayback() {
	    try {
	      Routes.sampleGraph.play();
	      this._playing = true;
	      this._paused = false;
	      google.maps.event.clearListeners(this.gmap, 'mousemove');
	    } catch (e) {} // eslint-disable-line no-empty
	  },
	  pause: function pause() {
	    try {
	      Routes.sampleGraph.pause();
	      this._playing = false;
	      this._paused = true;
	    } catch (e) {} // eslint-disable-line no-empty
	  },
	  stopPlayback: function stopPlayback() {
	    try {
	      Routes.sampleGraph.stopPlayback();
	      this._playing = false;
	      this._paused = false;
	      this.unhighlightNearestPoint();
	      // sometimes the flash movie fires an extra updatePlayhead call after we have told it to stop, so keep a flag set for 250 ms to prevent it
	      this.keepPlayheadStopped = true;
	      var self = this;
	      setTimeout(function () {
	        self.keepPlayheadStopped = false;
	      }, 250);
	      google.maps.event.clearListeners(this.gmap, 'mousemove');
	      google.maps.event.addListener(this.gmap, 'mousemove', $.proxy(this.onMouseMove, this));
	    } catch (e) {} // eslint-disable-line no-empty
	  },
	  updatePlayhead: function updatePlayhead(pt, tps) {
	    // update elapsed time if the points have time attrs
	    if (pt && pt.time && !this.keepPlayheadStopped) {
	      if (!tps) tps = this.activeRoute.trackPoints();
	
	      var time = pt.time,
	          min_time = tps[0].time,
	          max_time = tps[tps.length - 1].time;
	      if (!max_time) max_time = tps[tps.length - 2].time;
	      var seconds = time - min_time;
	      var pct = Math.round(100 * seconds / (max_time - min_time));
	      if ($.ui && $.ui.slider && $("#elapsed_time_slider").data("ui-slider")) {
	        $("#elapsed_time_slider").slider('option', 'value', pct);
	        $('#elapsed_time').html(rwgps.LabelMaker.durationLabel(seconds));
	      }
	    }
	  },
	
	  /**
	  * @param {google.maps.Map} map
	  * @param {google.maps.LatLng} latlng
	  * @param {int} z
	  * @return {google.maps.Point}
	  *
	  * http://qfox.nl/notes/116
	  */
	  googleLatLngToPoint: function googleLatLngToPoint(latlng) {
	    var z = this.gmap.getZoom();
	    var normalizedPoint = this.gmap.getProjection().fromLatLngToPoint(latlng); // returns x,y normalized to 0~255
	    var scale = Math.pow(2, z); //each zoom level ^2 tile size
	    var pixelCoordinate = new google.maps.Point(normalizedPoint.x * scale, normalizedPoint.y * scale);
	    return pixelCoordinate;
	  },
	  /**
	  * @param {google.maps.Map} map
	  * @param {google.maps.Point} point
	  * @param {int} z
	  * @return {google.maps.LatLng}
	  *
	  * http://qfox.nl/notes/116
	  */
	  pointToGoogleLatLng: function pointToGoogleLatLng(point) {
	    var z = this.gmap.getZoom();
	    var scale = Math.pow(2, z);
	    var normalizedPoint = new google.maps.Point(point.x / scale, point.y / scale);
	    var latlng = this.gmap.getProjection().fromPointToLatLng(normalizedPoint);
	    return latlng;
	  },
	  googleLatLngToContainerPoint: function googleLatLngToContainerPoint(latLng) {
	    var proj = this.gmap.getProjection();
	    var bounds = this.gmap.getBounds();
	    var tr = proj.fromLatLngToPoint(bounds.getNorthEast());
	    var bl = proj.fromLatLngToPoint(bounds.getSouthWest());
	    var scale = Math.pow(2, this.gmap.getZoom());
	    var wp = proj.fromLatLngToPoint(latLng);
	    return new google.maps.Point((wp.x - bl.x) * scale, (wp.y - tr.y) * scale);
	  },
	  gBoundsToObj: function gBoundsToObj(b) {
	    var ne = b.getNorthEast(),
	        sw = b.getSouthWest();
	    return {
	      ne: { lat: ne.lat(), lng: ne.lng() },
	      sw: { lat: sw.lat(), lng: sw.lng() }
	    };
	  },
	  getBounds: function getBounds() {
	    var bounds = this.gmap.getBounds();
	    var ne = bounds.getNorthEast();
	    var sw = bounds.getSouthWest();
	    return {
	      ne: { lat: ne.lat(), lng: ne.lng() },
	      sw: { lat: sw.lat(), lng: sw.lng() }
	    };
	  },
	
	  // Eliminate sections of surface that are < 0.1 miles in length. This happens a lot when intersecting with a road with a different surface type
	  eliminateLoneSurfaces: function eliminateLoneSurfaces(trackPoints) {
	    var surfaceGroups = rwgps.surfaces.surfaceGroups;
	    var MAX_WINDOW_SIZE = 161; // 0.1 miles
	    var surfaceWindow = [];
	    var i = void 0,
	        tp = void 0;
	    var windowDistance = function windowDistance() {
	      return surfaceWindow.length < 4 ? 0 : trackPoints[i - 1].distance - trackPoints[i - (surfaceWindow.length - 2)].distance;
	    };
	    for (i = 0; i < trackPoints.length; i++) {
	      tp = trackPoints[i];
	      surfaceWindow.push(surfaceGroups[tp.surface]);
	      // remove points from the front of the window until the window meets our distance constraint
	      while (windowDistance() > MAX_WINDOW_SIZE) {
	        surfaceWindow.shift();
	      }
	      if (surfaceWindow.length > 2) {
	        // need at least 3 points to find a lone surface to eliminate
	        var len = surfaceWindow.length;
	        // check to see if the first and last surfaces are the same, but the second to last is different
	        if (surfaceWindow[0] !== surfaceWindow[len - 2] && surfaceWindow[0] === surfaceWindow[len - 1]) {
	          for (var counter = 1; counter < len - 1; counter++) {
	            var pointToCoerce = trackPoints[i - counter];
	            pointToCoerce.roadClass = tp.roadClass;
	            pointToCoerce.ghSurface = tp.ghSurface;
	            pointToCoerce.surface = tp.surface;
	            surfaceWindow[len - counter - 1] = surfaceGroups[tp.surface]; // keep cached value in our window updated
	          }
	        }
	      }
	    }
	  },
	
	  injectSurfaces: function injectSurfaces(trackPoints, error) {
	    var _this8 = this;
	
	    trackPoints.forEach(function (tp) {
	      tp.fetchingSurface = true;
	    });
	    var batches = [],
	        offset = 0,
	        count = 70;
	    while (offset <= trackPoints.length) {
	      batches.push(trackPoints.slice(offset, offset + count));
	      offset += count;
	    }
	
	    var surfaceBatch = function surfaceBatch(tps) {
	      return function (cb) {
	        var data = JSON.stringify({
	          track_points: tps.map(function (tp) {
	            return tp.point ? { y: tp.point.lat, x: tp.point.lng } : { y: 0, x: 0 // {0,0} is in the middle of the ocean -> unknown
	            };
	          })
	        });
	        $.ajaxSettings.stopCSRF = true;
	        $.ajax({
	          url: 'https://directions.ridewithgps.com/surfaceinjector',
	          dataType: "json",
	          contentType: 'application/json',
	          type: 'POST',
	          data: data,
	          success: function success(response) {
	            var roadClass, ghSurface, surface;
	            response.track_points.forEach(function (r, k) {
	              roadClass = rwgps.surfaces.roadClassToInt[r['R']];
	              ghSurface = rwgps.surfaces.surfaceToInt[r['S']];
	              surface = rwgps.TrackPoint.inferSurface(ghSurface, roadClass, r.y, r.x);
	              if (surface === undefined) {
	                // 99 is UNKOWN
	                ghSurface = 99;
	                surface = 99;
	              }
	              tps[k].roadClass = roadClass;
	              tps[k].ghSurface = ghSurface;
	              tps[k].surface = surface;
	              tps[k].roadEnv = ['bridge', 'tunnel'].includes(r['RE']) ? 1 : 0;
	            });
	            cb(null, tps);
	          },
	          error: function error(err) {
	            return cb(err, null);
	          }
	        });
	      };
	    };
	
	    async.parallelLimit(batches.map(surfaceBatch), 6, function (err) {
	      if (err) {
	        error("No routes found");
	        return;
	      }
	
	      trackPoints.forEach(function (tp) {
	        delete tp.fetchingSurface;
	      });
	
	      var prevSeg = trackPoints[0].segment && trackPoints[0].segment.prevControlPoint.prevSegment;
	      if (prevSeg) {
	        // the right move here would be to walk backward the window of 0.1 miles that we look at to eliminate lone surfaces
	        // this simpler approach has two flaws:
	        // 1. overridden surface types within the previous segment that last less than 0.1 miles will get eliminated
	        // 2. if the previous segment is less than 0.1 miles and the previous-previous segment has a problem at control point boundary, it won't be fixed
	        // not solving these problems right now because the solution is enough more complex that it's not worth it unless we see these issues more often than almost-never
	        _this8.eliminateLoneSurfaces(prevSeg.trackPoints.concat(trackPoints));
	      } else {
	        _this8.eliminateLoneSurfaces(trackPoints);
	      }
	
	      var map = window.Routes.activeMap;
	      if (!map.activeRoute.showSurface && rwgps.config.labs.surface_types && rwgps.config.labs.route_planner) {
	        map.activeRoute.showSurface = true;
	        Routes.sampleGraph.showSurface(true);
	      }
	      map.activeRoute.recalculatePolylines();
	      window.rwgps.Events.trigger('surfacesChanged');
	      // surfaces are fetched concurrently with elevation data, and once the elevation is fetched it will update the profile and perform a snapshot.
	      // if elevations are already fetched, we need to update the snapshot and redraw the profile again.
	      // if elevations are still being fetched, we can let the success handler for fetchElevations take the snapshot and redraw the profile.
	      if (!_.find(trackPoints, function (tp) {
	        return tp.fetchingEle;
	      })) {
	        map.activeRoute.flattenBridgesAndTunnels();
	        map.loadElevationProfile();
	        map.snapshot({ updateLast: true });
	      }
	    });
	  },
	
	  /*
	   * We are splitting up elevation requests into chunks of 70 points at a time
	   * since this is GET and some browsers (IE) have a limit on URL string
	   * lengths.
	   */
	  fetchElevations: function fetchElevations(trackPoints, _success) {
	    // store fetch state on the trackPoint
	    for (var i = 0, len = trackPoints.length; i < len; i++) {
	      trackPoints[i].fetchingEle = true;
	    }
	    var batches = [],
	        offset = 0,
	        count = 70;
	    while (offset <= trackPoints.length) {
	      batches.push(trackPoints.slice(offset, offset + count));
	      offset += count;
	    }
	    // keep track of how many requests we're processing, and the last
	    // request that comes back can fire the success callback
	    var numToComplete = 0;
	    for (var j = 0; j < batches.length; j++) {
	      numToComplete += 1;
	      //use an anonymous function for a new scope, so callbacks don't share
	      //a points array and get all confused
	      (function (idx) {
	        var lats = "",
	            lngs = "";
	        var points = batches[idx];
	        for (var i = 0; i < points.length; i++) {
	          lats += Math.round(points[i].point.lat * 1000000) / 1000000 + ",";
	          lngs += Math.round(points[i].point.lng * 1000000) / 1000000 + ",";
	        }
	        lats = lats.slice(0, lats.length - 1);
	        lngs = lngs.slice(0, lngs.length - 1);
	
	        $.ajax({
	          url: "https://gis.ridewithgps.com/get_eles",
	          data: { lats: lats, lngs: lngs },
	          dataType: "jsonp",
	          type: "get",
	          success: function success(response) {
	            for (i = 0; i < points.length; i++) {
	              points[i].ele = response[i];
	              delete points[i].fetchingEle;
	              // if this point as been flattened by flattenBridgesAndTunnels,
	              // fetchElevations will revert that. update point as such
	              delete points[i].flattened;
	            }
	            numToComplete -= 1;
	            if (numToComplete == 0) {
	              _success();
	            }
	          },
	          error: function error(request, txt, _error) {
	            // eslint-disable-line no-unused-vars
	            for (i = 0; i < points.length; i++) {
	              delete points[i].fetchingEle;
	            }
	            //trace("Something broke: " + txt + ", " + error);
	          }
	        });
	      })(j);
	    }
	  }
	};
	
	rwgps.CoursePointPopup = function (map) {
	  this.map = map;
	  this.div = $("<div/>");
	  this.div.css({
	    position: "absolute",
	    background: "#FFF",
	    "z-index": 10,
	    padding: 3,
	    border: "1px solid black"
	  });
	  //this.setCoursePoint(cp);
	};
	rwgps.CoursePointPopup.prototype = {
	  setCoursePoint: function setCoursePoint(cp) {
	    if (!cp) return null;
	    var pt = this.map.googleLatLngToContainerPoint(cp.googleLatLng());
	    var margin = $('#' + this.map.opts.targetDiv).offset().left;
	    var x = pt.x + 20 + margin;
	
	    this.div.html("");
	
	    if (cp.photoIds.length > 0) {
	      this.div.css({ width: 150, height: 65 });
	      //this.div.append("<br/>");
	      var cont = $("<div style='float:left;border:1px solid #CCC;padding:2px;width:60px;height:60px;margin-right:3px;'/>");
	      cont.append("<img class='left' src='/photos/micro/" + cp.photoIds[0] + ".jpg' />");
	      this.div.append(cont);
	    } else {
	      this.div.css({ width: 120, height: 30 });
	    }
	    this.div.append("<span class='left'><b>" + cp.type + "</b></span>");
	    //this.div.append("<span style='margin-left:5px'>" + cp.notes + "</span>");
	
	    this.div.css({ left: x, top: pt.y + 20 });
	  },
	  show: function show() {
	    $("body").append(this.div);
	  },
	  hide: function hide() {
	    this.div.remove();
	  }
	};
	
	rwgps.MouseSpeedometer = function () {
	  this.speed = this.x = this.y = this.t = 0;
	};
	rwgps.MouseSpeedometer.ZERO_TIMEOUT = 100;
	rwgps.MouseSpeedometer.UPDATE_THROTTLE = 50;
	rwgps.MouseSpeedometer.prototype.update = function (x, y) {
	  var _this9 = this;
	
	  var t = new Date().getTime();
	  var updateState = false;
	  if (this.t > 0) {
	    var xD = x - this.x,
	        yD = y - this.y,
	        tD = t - this.t;
	    if (tD > rwgps.MouseSpeedometer.UPDATE_THROTTLE) {
	      var instSpeed = Math.sqrt(xD * xD + yD * yD) / tD;
	      // ease speed updates to smooth out jerkiness
	      this.speed = this.speed * 0.8 + instSpeed * 0.2;
	      updateState = true;
	
	      // drop speed to zero if we don't get an update for too long
	      if (this.zeroTimeout) {
	        clearTimeout(this.zeroTimeout);
	      }
	      this.zeroTimeout = setTimeout(function () {
	        _this9.speed = 0;
	      }, rwgps.MouseSpeedometer.ZERO_TIMEOUT);
	    }
	  } else {
	    updateState = true;
	  }
	  if (updateState) {
	    this.x = x;
	    this.y = y;
	    this.t = t;
	  }
	};
	
	rwgps.Icon = function () {};
	rwgps.Icon.prototype = {
	  map: null,
	  icon: null,
	  shadow: null,
	  gmarker: null,
	
	  init: function init(latlng, opts) {
	    if (!opts) opts = {};
	    if (!latlng) latlng = {};
	    var iconObj = this.icon;
	    if (this.size) {
	      iconObj = { scaledSize: this.size, url: this.icon };
	    }
	    opts = $.extend({
	      position: new google.maps.LatLng(latlng.lat, latlng.lng),
	      clickable: true,
	      icon: iconObj,
	      shadow: this.shadow
	    }, opts);
	
	    this.gmarker = new google.maps.Marker(opts);
	    if (this.map) this.gmarker.setMap(this.map.gmap);
	
	    var self = this;
	    //debounced, because if we don't, we get flutter as the lower zindex icon moves up
	    //and kicks off another mouseover/leave event, which causes the previous icon
	    //to have this kicked off.  Thus, it just cycles back and forth.
	    google.maps.event.addListener(this.gmarker, 'mouseover', _.debounce(function () {
	      self.map.topZIndex += 1;
	      self.gmarker.setZIndex(self.map.topZIndex);
	    }));
	  },
	
	  enableDragEdit: function enableDragEdit() {
	    var firstSeg,
	        lastSeg,
	        startMarker,
	        firstPoint,
	        lastPoint,
	        service,
	        directionsRequestFn,
	        mouseSpeedometer,
	        finalTps,
	        finalCps,
	        lastDragEvent,
	        isControlPoint,
	        controlPoint,
	        isFirst,
	        isLast,
	        isMiddle,
	        useMapClickOpts,
	        isFirstSegFollowRoads,
	        isLastSegFollowRoads,
	        afterDirectionsFn,
	        // called when awaitingDirections == 0, used to defer dragend
	    awaitingDirections = 0; // new directions req will +1, and when returned, -1
	
	    var dragEndFn = $.proxy(function (e) {
	      this.map.draggingMarker = false;
	
	      //remove the temporary polylines from the map
	      if (this.dragPolyline1) {
	        this.dragPolyline1.setMap(null);this.dragPolyline1.setPath([]);this.dragPolyline1 = null;
	      }
	      if (this.dragPolyline2) {
	        this.dragPolyline2.setMap(null);this.dragPolyline2.setPath([]);this.dragPolyline2 = null;
	      }
	
	      //completely remove our old segments, we are drawing new ones from scratch
	      if (firstSeg) firstSeg.removeFromMap();
	      if (lastSeg) lastSeg.removeFromMap();
	
	      var points, coursePoints;
	      var newPoint = new rwgps.TrackPoint({ point: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	      var newFirstSeg, newLastSeg;
	
	      // construct first segment, if splitting directions this seg will have all the points until we split it upon constructing the latter segment in the block that follows
	      var path, isFollowRoads, seg;
	      if (isFirst) {
	        path = [newPoint, lastPoint];
	        isFollowRoads = isLastSegFollowRoads;
	        seg = lastSeg;
	      }
	      if (isMiddle || isLast) {
	        path = [firstPoint, newPoint];
	        isFollowRoads = isFirstSegFollowRoads;
	        seg = firstSeg;
	      }
	
	      if (!isFollowRoads) {
	        points = rwgps.Segment.fillTheCracks(path);
	        coursePoints = [];
	      } else {
	        if (!finalTps) {
	          // should put all this in some sort of "ensure" block
	          trace("Aborting drag/drop, expected results and there are none");
	          if (firstSeg) firstSeg.addToMap(this.map);
	          if (lastSeg) lastSeg.addToMap(this.map);
	          this.map.loadElevationProfile();
	          this.map.relabel();
	          this.map.activeRoute.calculateMetrics();
	          this.map.activeRoute.rebuildBounds();
	          // draw distance markers
	          this.map.drawRouteDistanceMarkers(this.map.activeRoute);
	          this.map.drawCoursePointIcons(this.map.activeRoute.coursePoints());
	          this.map.populateCuesheet(this.map.activeRoute.coursePoints());
	          this.map.snapshot();
	          // restore default mousemove listener
	          google.maps.event.addListener(this.map.gmap, 'mousemove', $.proxy(this.map.onMouseMove, this.map));
	          return;
	        }
	        points = finalTps;
	        coursePoints = finalCps;
	      }
	
	      // make sure route stays contiguous
	      var firstSegPrevCp, firstSegNextCp;
	      if (!isFirst && firstSeg.prevSegment) {
	        var priorSeg = firstSeg.prevSegment,
	            priorSegCp = priorSeg.nextControlPoint;
	        if (points[0].pointEquals(priorSegCp.point)) {
	          // first point is a dupe of the prev cp so get rid of it
	          points.shift();
	        }
	        firstSegPrevCp = priorSegCp;
	      } else {
	        firstSegPrevCp = points.shift();
	      }
	      // if we are editing the end of the route (isLast or isMiddle but next seg is the last) still need to provide our own cp
	      if (lastSeg && lastSeg.nextSegment) {
	        if (points.length > 0 && points[points.length - 1].pointEquals(lastSeg.nextControlPoint.point)) {
	          points.pop();
	        }
	        if (isMiddle && (!isLastSegFollowRoads || !isFirstSegFollowRoads)) {
	          firstSegNextCp = points.pop();
	        } else {
	          firstSegNextCp = lastSeg.nextControlPoint;
	        }
	      } else {
	        firstSegNextCp = points.pop();
	      }
	      newFirstSeg = new rwgps.Segment(this.map.activeRoute, firstSegPrevCp, firstSegNextCp, points, coursePoints, seg.color);
	      newFirstSeg.clickOptions.setOptions(seg.clickOptions.getOptions());
	
	      // give startmarker its new point if necessary
	      if (startMarker) {
	        startMarker.trackPoint = newFirstSeg.prevControlPoint;
	        startMarker.gmarker.setPosition(newFirstSeg.prevControlPoint.googleLatLng());
	      }
	
	      var lastPtOnFirstSeg = newFirstSeg.nextControlPoint;
	
	      // construct second segment if necessary
	      if (isMiddle) {
	        var lastSegNextCp;
	        if (!isLastSegFollowRoads) {
	          points = rwgps.Segment.fillTheCracks([newPoint, lastPoint]);
	          // dropping dupes
	          if (points[0].pointEquals(lastPtOnFirstSeg.point)) {
	            points.shift();
	          }
	          if (lastSeg.nextSegment) {
	            lastSegNextCp = lastSeg.nextControlPoint;
	            if (points.length > 0 && points[points.length - 1].pointEquals(lastSegNextCp.point)) {
	              points.pop();
	            }
	          } else {
	            lastSegNextCp = points.pop();
	          }
	          coursePoints = [];
	          newLastSeg = new rwgps.Segment(this.map.activeRoute, lastPtOnFirstSeg, lastSegNextCp, points, coursePoints, lastSeg.color);
	          newLastSeg.clickOptions.setOptions(lastSeg.clickOptions.getOptions());
	        } else if (isFirstSegFollowRoads) {
	          this.trackPoint = new rwgps.TrackPoint({ point: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	          var closestIdx = 0;
	          var closestDist = 99999;
	          for (var i = 0; i < newFirstSeg.trackPoints.length; i++) {
	            var tp = newFirstSeg.trackPoints[i];
	            var dist = tp.distanceFromPoint(this.trackPoint);
	            if (dist < closestDist) {
	              closestDist = dist;
	              closestIdx = i;
	            }
	          }
	          if (closestDist < 99999) {
	            //actually found something, so let's split
	            newLastSeg = newFirstSeg.splitAfter(closestIdx - 1);
	          }
	        } else {
	          // first seg is draw lines, second seg is follow roads...
	          points = finalTps;
	          if (points[0].pointEquals(lastPtOnFirstSeg.point)) {
	            points.shift();
	          }
	          if (lastSeg.nextSegment) {
	            lastSegNextCp = lastSeg.nextControlPoint;
	          } else {
	            lastSegNextCp = points.pop();
	          }
	          coursePoints = finalCps;
	          newLastSeg = new rwgps.Segment(this.map.activeRoute, lastPtOnFirstSeg, lastSegNextCp, points, coursePoints, lastSeg.color);
	          newLastSeg.clickOptions.setOptions(lastSeg.clickOptions.getOptions());
	        }
	      }
	
	      newLastSeg = newLastSeg || newFirstSeg;
	      if (!newLastSeg.nextSegment) {
	        // have to re-assign prevClick since we moved last segment in route
	        this.map.prevClick = newLastSeg.nextControlPoint.point;
	      }
	
	      // final cleanup and draws
	      var updatePlanner = $.proxy(function () {
	        this.loadElevationProfile();
	        this.relabel();
	        this.activeRoute.calculateMetrics();
	        this.activeRoute.rebuildBounds();
	        this.activeRoute.redrawPolylines();
	        this.activeRoute.flattenBridgesAndTunnels();
	        this.drawRouteDistanceMarkers(this.activeRoute);
	        this.drawCoursePointIcons(this.activeRoute.coursePoints());
	        this.populateCuesheet(this.activeRoute.coursePoints());
	        this.snapshot();
	        // see if we introduced a spur and fix if so
	        if (isMiddle) {
	          rwgps.checkSpur(newFirstSeg);
	        }
	      }, this.map);
	
	      // fetch elevations for all points missing eles
	      var trackPoints = newFirstSeg.route.trackPoints();
	      var ptsToFetch = [];
	      for (var j = 0; j < trackPoints.length; j++) {
	        if (trackPoints[j].ele == undefined || trackPoints[j].ele == null) {
	          ptsToFetch.push(trackPoints[j]);
	        }
	      }
	
	      if (ptsToFetch.length > 0) {
	        this.map.fetchElevations(ptsToFetch, updatePlanner, function (msg) {
	          trace(msg);
	        });
	      } else {
	        updatePlanner();
	      }
	
	      // fetch surface types for the new segments if we're dragging in gmaps
	      var router = Routes.activeMap.activeRoutingService;
	      if (router.opts.id === 'google') {
	        this.map.injectSurfaces(ptsToFetch, function () {});
	      }
	
	      // restore the normal listener
	      google.maps.event.addListener(this.map.gmap, 'mousemove', $.proxy(this.map.onMouseMove, this.map));
	    }, this);
	
	    google.maps.event.addListener(this.gmarker, 'dragstart', $.proxy(function () {
	      if (this.map.opts.tripId) {
	        rwgps.Events.trigger("trip:modification_prevented");
	        return;
	      }
	      if (this.map.draggingMarker) return;
	      rwgps.unhighlightPoints(true);
	      this.map.clearSegment();
	
	      // remove all distance markers
	      this.map.removeRouteDistanceMarkers(this.map.activeRoute);
	
	      // reset everything
	      isControlPoint = !(this instanceof rwgps.NearestPointIcon);
	      controlPoint = startMarker = isFirst = isLast = isMiddle = useMapClickOpts = isFirstSegFollowRoads = isLastSegFollowRoads = lastSeg = firstPoint = lastPoint = service = directionsRequestFn = finalTps = finalCps = lastDragEvent = afterDirectionsFn = undefined;
	      mouseSpeedometer = new rwgps.MouseSpeedometer();
	      awaitingDirections = 0;
	
	      // google doesnt always throw drag end!
	      lastDragEvent = {};
	      var self = this;
	      function emergencyDragEnd() {
	        $(window).unbind('mouseup', emergencyDragEnd);
	        if (self instanceof rwgps.StartIcon && self.map.activeRoute.segments.length === 0) {
	          // no route, we were dragging the start marker! let's reset the prevClick so pos sticks
	          var gll = self.gmarker.getPosition();
	          self.map.prevClick = { lat: gll.lat(), lng: gll.lng() };
	        }
	        if (!self.map.draggingMarker) return;
	        google.maps.event.clearInstanceListeners(self);
	        if (awaitingDirections) afterDirectionsFn = function afterDirectionsFn() {
	          dragEndFn(lastDragEvent);
	        };else dragEndFn(lastDragEvent);
	      }
	      $(window).mouseup(emergencyDragEnd);
	
	      //set up our boolean state vars
	      if (!isControlPoint) {
	        // we're only modifying 1 existing seg, so use map click opts
	        useMapClickOpts = true;
	        // if were on the nearestpointmarker, split the segment up and pretend like we are dragging on the new control point
	        firstSeg = this.map.nearestMousePointBehind.segment || this.map.nearestMousePointBehind.nextSegment;
	
	        var pointBehindI = _.indexOf(firstSeg.trackPoints, this.map.nearestMousePointBehind),
	            p = this.map.nearestInterpolatedMousePoint,
	            distance = this.map.nearestMousePointBehind.distance + this.map.nearestMousePointBehind.distanceFromLatLng(p),
	            tp = new rwgps.TrackPoint({ point: p });
	        tp.distance = distance;
	
	        firstSeg.insertTrackPointAfter(tp, pointBehindI);
	        lastSeg = firstSeg.splitAfter(pointBehindI < 0 ? -1 : pointBehindI + 1);
	        this.trackPoint = tp;
	
	        controlPoint = firstSeg.controlPointIcon;
	        controlPoint.gmarker.setVisible(false);
	        isControlPoint = true;
	      } else {
	        // we could be sitting between two segs, so since its ambiguous dont use map clickopts (if isFirst or isLast, we'll set this back to true below)
	        useMapClickOpts = false;
	
	        controlPoint = this;
	        if (!this.trackPoint) {
	          if (this.map.activeRoute.segments.length == 0) return; // get out of here! there isnt a route yet
	          this.trackPoint = this.map.activeRoute.firstSegment.prevControlPoint;
	        }
	        firstSeg = this.trackPoint.segment || this.trackPoint.prevSegment || this.trackPoint.nextSegment;
	        lastSeg = firstSeg.nextSegment;
	        if (this instanceof rwgps.StartIcon) {
	          startMarker = this;
	          lastSeg = firstSeg;firstSeg = null;
	        }
	      }
	      // if dragging next to start marker, we'll need to reassign its trackpt and position afterward
	      if (firstSeg && !firstSeg.prevSegment && firstSeg.route.startMarker) {
	        startMarker = firstSeg.route.startMarker;
	      }
	
	      isFirst = !firstSeg;
	      isLast = !lastSeg;
	      if (isFirst || isLast || firstSeg.clickOptions.getOptions() == lastSeg.clickOptions.getOptions()) {
	        // only 1 seg affected by the drag operation, or both segs have matching click options,
	        // so use map click opts
	        useMapClickOpts = true;
	      }
	      isMiddle = !isFirst && !isLast;
	      // if we should use map click opts, set them now
	      if (useMapClickOpts) {
	        var mapClickOpts = this.map.clickOptions.getOptions();
	        if (firstSeg) firstSeg.clickOptions.setOptions(mapClickOpts);
	        if (lastSeg) lastSeg.clickOptions.setOptions(mapClickOpts);
	      }
	      if (firstSeg) isFirstSegFollowRoads = !!firstSeg.clickOptions.followRoads();
	      if (lastSeg) isLastSegFollowRoads = !!lastSeg.clickOptions.followRoads();
	
	      if (lastSeg) lastPoint = lastSeg.nextControlPoint;else lastPoint = firstSeg.nextControlPoint;
	
	      if (firstSeg) firstPoint = firstSeg.prevControlPoint;else firstPoint = lastSeg.prevControlPoint;
	
	      this.map.draggingMarker = true;
	      google.maps.event.clearListeners(this.map.gmap, "mousemove");
	
	      // this.map.unhighlightNearestPoint();
	
	      // hide the segments
	      if (firstSeg) {
	        firstSeg.clearCoursePointMarkers();
	        firstSeg.gPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	        if (firstSeg.backgroundPolyline) firstSeg.backgroundPolyline.setMap(null);
	      }
	      if (lastSeg) {
	        lastSeg.clearCoursePointMarkers();
	        lastSeg.gPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	        if (lastSeg.backgroundPolyline) lastSeg.backgroundPolyline.setMap(null);
	      }
	
	      // build a function to request directions if necessary
	      if (isFirstSegFollowRoads || isLastSegFollowRoads) {
	        service = this.map.activeRoutingService;
	
	        var unlimitedDirectionsRequestFn = $.proxy(function (path, opts, color, whichpl) {
	          var self = this,
	              pl = "dragPolyline" + (whichpl || 1);
	
	          awaitingDirections += 1;
	
	          service.getDirections(path, opts, color, function (tps, cps) {
	            if (tps == null || tps.length == 0) return;
	            if (!self.map.opts.generateCues) cps = null;
	            var latlngs = _.map(tps, function (pt) {
	              return pt.point;
	            });
	
	            // make sure path stays contiguous
	            if (!tps[0].pointEquals(path[0])) latlngs.unshift(path[0]);
	            if (!tps[tps.length - 1].pointEquals(path[path.length - 1])) latlngs.push(path[path.length - 1]);
	
	            var googleLatLngs = latlngs.map(function (x) {
	              return new google.maps.LatLng(x.lat, x.lng);
	            });
	            if (self[pl]) {
	              self[pl].setPath(googleLatLngs);
	            } else {
	              self[pl] = new google.maps.Polyline({ path: googleLatLngs, map: self.map.gmap });
	            }
	            finalTps = tps;finalCps = cps;
	            awaitingDirections -= 1;
	            if (awaitingDirections == 0 && afterDirectionsFn) afterDirectionsFn();
	          }, function (err) {
	            trace(["error while requesting directions on drag to edit", err]);
	            awaitingDirections -= 1;
	            if (awaitingDirections == 0 && afterDirectionsFn) {
	              afterDirectionsFn();
	            }
	          });
	          if (!window.dragCount) window.dragCount = 1;else window.dragCount += 1;
	
	          var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B';
	          trackEvent('Google Maps', "Direction Request (Drag - " + group + ")", service.opts.type);
	          trackEvent('Google Maps', 'Direction Request (Drag)', service.opts.type);
	        }, this);
	
	        // combine a throttle and debounce - this ensures that as you drag, the throttled fn keeps executing, and once you settle the mouse, your last position will get a directions request due to the debounce!
	        var DIR_VERY_SLOW_THROTTLE = 2000,
	            DIR_SLOW_THROTTLE = 900,
	            DIR_SLOW_THRESHOLD = 0.09;
	        var debounceWaiting = void 0,
	            directionsDebounceTimer = void 0,
	            directionsThrottleTimer = void 0,
	            directionsThrottleTime = DIR_VERY_SLOW_THROTTLE,
	            directionsCanRun = true,
	            mouseIsSlow = false,
	            letDirectionsRun = function letDirectionsRun() {
	          directionsCanRun = true;
	        };
	
	        directionsRequestFn = function directionsRequestFn() {
	          var resetThrottleTo = 0;
	          // mouse entered slow state - grab directions now and throttle to slow
	          if (!mouseIsSlow && mouseSpeedometer.speed < DIR_SLOW_THRESHOLD) {
	            mouseIsSlow = true;
	            directionsCanRun = true;
	            resetThrottleTo = DIR_SLOW_THROTTLE;
	          }
	          // mouse entered fast state - throttle to very slow
	          if (mouseIsSlow && mouseSpeedometer.speed >= DIR_SLOW_THRESHOLD) {
	            mouseIsSlow = false;
	            resetThrottleTo = DIR_VERY_SLOW_THROTTLE;
	          }
	
	          // reset debounce state
	          if (debounceWaiting) {
	            debounceWaiting = false;
	            awaitingDirections--;
	            clearTimeout(directionsDebounceTimer);
	          }
	
	          // if throttle timer came up and we're allowed to grab directions, grab them & reset
	          if (directionsCanRun) {
	            unlimitedDirectionsRequestFn.apply(null, arguments);
	            if (!resetThrottleTo) resetThrottleTo = directionsThrottleTime;
	          } else {
	            awaitingDirections++;
	            debounceWaiting = true;
	            var args = arguments;
	            directionsDebounceTimer = setTimeout(function () {
	              debounceWaiting = false;
	              awaitingDirections--;
	              unlimitedDirectionsRequestFn.apply(null, args);
	            }, rwgps.MouseSpeedometer.ZERO_TIMEOUT + 100);
	          }
	
	          // restart throttling at corretct rate if requested
	          if (resetThrottleTo > 0) {
	            directionsCanRun = false;
	            if (directionsThrottleTimer) clearTimeout(directionsThrottleTimer);
	            directionsThrottleTimer = setTimeout(letDirectionsRun, resetThrottleTo);
	            directionsThrottleTime = resetThrottleTo;
	          }
	        };
	      }
	    }, this));
	
	    // dont bother attaching drag and dragend
	    if (this.map.opts.tripId) {
	      return;
	    }
	
	    // helper function we'll call during drag if we're in line mode
	    var dragPolylineFn = $.proxy(function (path, whichpl, forceConnect) {
	      var googlePath = path.map(function (x) {
	        return new google.maps.LatLng(x.lat, x.lng);
	      });
	      var pl = "dragPolyline" + (whichpl || 1);
	      if (forceConnect) {
	        var otherpl, opath;
	        if (whichpl == 1) {
	          if (otherpl = this['dragPolyline2']) {
	            opath = otherpl.getPath();
	            opath.insertAt(0, googlePath[googlePath.length - 1]);
	            otherpl.setPath(opath);
	          }
	        } else {
	          if (otherpl = this['dragPolyline1']) {
	            opath = otherpl.getPath();
	            opath.push(googlePath[0]);
	            otherpl.setPath(opath);
	          }
	        }
	      }
	      if (this[pl]) {
	        this[pl].setPath(googlePath);
	      } else {
	        this[pl] = new google.maps.Polyline({
	          path: googlePath,
	          map: this.map.gmap
	        });
	      }
	    }, this);
	
	    google.maps.event.addListener(this.gmarker, "drag", $.proxy(function (e) {
	      var mousePoint = { lat: e.latLng.lat(), lng: e.latLng.lng() };
	      mouseSpeedometer.update(e.pixel.x, e.pixel.y);
	      lastDragEvent = e;
	      if (!isMiddle || isFirstSegFollowRoads == isLastSegFollowRoads) {
	        // only do one thing
	        var path;
	        if (isFirst) path = [mousePoint, lastPoint.point];else if (isLast) path = [firstPoint.point, mousePoint];else if (firstPoint && lastPoint) path = [firstPoint.point, mousePoint, lastPoint.point];else path = [];
	
	        var isFollowRoads = isFirst && isLastSegFollowRoads || isLast && isFirstSegFollowRoads || isFirstSegFollowRoads && isLastSegFollowRoads;
	
	        if (isFollowRoads) {
	          var tempOpts = this.map.clickOptions.getProviderOptions() | this.map.clickOptions.getRestrictionOptions();
	          if (isFirst) {
	            lastSeg.clickOptions.setPartialOptions(tempOpts);
	            directionsRequestFn(path, lastSeg.clickOptions, lastSeg.color);
	          } else {
	            firstSeg.clickOptions.setPartialOptions(tempOpts);
	            directionsRequestFn(path, firstSeg.clickOptions, firstSeg.color);
	          }
	        } else dragPolylineFn(path);
	      } else {
	        // follow roads on one side, draw a line on the other
	        var firstSegPath = [firstPoint.point, mousePoint],
	            lastSegPath = [mousePoint, lastPoint.point];
	
	        if (isFirstSegFollowRoads) directionsRequestFn(firstSegPath, firstSeg.clickOptions, firstSeg.color);else dragPolylineFn(firstSegPath, 1, true);
	
	        if (isLastSegFollowRoads) directionsRequestFn(lastSegPath, lastSeg.clickOptions, lastSeg.color, 2);else dragPolylineFn(lastSegPath, 2, true);
	      }
	    }, this));
	
	    var self = this;
	    google.maps.event.addListener(this.gmarker, 'dragend', function (e) {
	      if (!self.map.draggingMarker) return;
	      google.maps.event.clearInstanceListeners(self);
	      if (awaitingDirections) {
	        afterDirectionsFn = function afterDirectionsFn() {
	          dragEndFn(e);
	        };
	      } else {
	        dragEndFn(e);
	      }
	    });
	  },
	
	  _dragEndDirectionsHandler: function _dragEndDirectionsHandler() {},
	  _dragEndPolylineHandler: function _dragEndPolylineHandler() {}
	};
	
	rwgps.CoursePointIcon = function (coursePoint, map) {
	  this.coursePoint = coursePoint;
	  this.icon = "/images/cue_icon.png";
	
	  if (coursePoint.deleted) {
	    this.icon = "/images/cue_deleted_icon.png";
	  }
	  if (coursePoint.selected) {
	    this.size = new google.maps.Size(36, 40);
	  } else {
	    this.size = new google.maps.Size(24, 27);
	  }
	
	  this.shadow = new google.maps.MarkerImage("/images/cp_icon_shadow.png", new google.maps.Size(32, 22), //dimensions
	  new google.maps.Point(0, 0), //origin to reference from
	  new google.maps.Point(3, 22) //anchor (offset a bit for this one)
	  );
	  this.init(coursePoint.point);
	  if (map) this.setMap(map);
	};
	rwgps.CoursePointIcon.prototype = new rwgps.Icon();
	rwgps.CoursePointIcon.prototype.setMap = function (map) {
	  var _this10 = this;
	
	  var self = this;
	  this.map = map;
	  this.gmarker.setMap(map.gmap);
	  google.maps.event.addListener(this.gmarker, 'click', function () {
	    if (!map.inCueReview) {
	      map.openCoursePointInfoWindow(self.coursePoint);
	    }
	  });
	  google.maps.event.addListener(this.gmarker, 'mouseover', function () {
	    map.coursePointPopup.setCoursePoint(self.coursePoint);
	    map.coursePointPopup.show();
	  });
	  google.maps.event.addListener(this.gmarker, 'mouseout', function () {
	    map.coursePointPopup.hide();
	  });
	  if (rwgps.onRightClick) {
	    google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	      return rwgps.onRightClick(e, 'coursePoint', _this10);
	    });
	  }
	};
	
	rwgps.PoiIcon = function (poi, map) {
	  var _this11 = this;
	
	  var icon;
	  this.poi = poi;
	  var poiObj = rwgps.PointOfInterest.poiTypesById[poi.poiType];
	  if (poiObj) {
	    icon = poiObj.icon;
	    if (poi.ghosted) icon = 'alt_' + icon;
	    icon = rwgps.poiIconsPath() + icon;
	  } else {
	    icon = 'poi_icons/generic.png';
	  }
	  this.size = new google.maps.Size(34, 40);
	  this.icon = "/images/" + icon;
	
	  this.init(poi.point, { draggable: map.inPlanningMode() });
	  if (map.inPlanningMode()) {
	    google.maps.event.addListener(this.gmarker, 'dragstart', function () {
	      map.closePreviewInfoWindow();
	      map.closeStickyInfoWindow();
	      _this11.disableMouseOverOut();
	    });
	    google.maps.event.addListener(this.gmarker, 'dragend', function () {
	      _this11.poi.point = { lat: _this11.gmarker.position.lat(), lng: _this11.gmarker.position.lng() };
	      _this11.enableMouseOverOut();
	    });
	    if (rwgps.onRightClick) {
	      google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	        return rwgps.onRightClick(e, 'pointOfInterest', _this11);
	      });
	    }
	  }
	  if (map) this.setMap(map);
	};
	rwgps.PoiIcon.prototype = new rwgps.Icon();
	rwgps.PoiIcon.prototype.clickHandler = function () {
	  this.mouseUpInAction = false;
	  this.map.openStickyInfoWindow(this.poi);
	  rwgps.Events.trigger("pois:click", this.poi);
	};
	rwgps.PoiIcon.prototype.disableMouseOverOut = function () {
	  google.maps.event.clearListeners(this.gmarker, 'mouseup');
	  google.maps.event.clearListeners(this.gmarker, 'mouseover');
	  google.maps.event.clearListeners(this.gmarker, 'mouseout');
	};
	rwgps.PoiIcon.prototype.enableMouseOverOut = function () {
	  google.maps.event.addListener(this.gmarker, 'mouseup', $.proxy(this.mouseUpHandler, this));
	  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(this.mouseOverHandler, this));
	  google.maps.event.addListener(this.gmarker, 'mouseout', $.proxy(this.mouseOutHandler, this));
	};
	rwgps.PoiIcon.prototype.mouseOverHandler = function () {
	  if (this.map.preventPoiMouseover) return;
	  this.mouseUpInAction = false;
	  this.map.openPreviewInfoWindow(this.poi, false); //false to disable auto-panning
	  rwgps.Events.trigger("pois:mouseover", this.poi);
	  this.map.preventPoiMouseover = false;
	};
	rwgps.PoiIcon.prototype.mouseOutHandler = function () {
	  if (this.map.preventPoiMouseover || this.mouseUpInAction) return;
	  this.map.closePreviewInfoWindow();
	  rwgps.Events.trigger("pois:mouseout", self.poi);
	};
	rwgps.PoiIcon.prototype.mouseUpHandler = function () {
	  this.mouseUpInAction = true;
	};
	rwgps.PoiIcon.prototype.setMap = function (map) {
	  var self = this;
	  this.map = map;
	  this.gmarker.setMap(map.gmap);
	  google.maps.event.addListener(this.gmarker, 'click', function () {
	    self.clickHandler.apply(self, arguments);
	  });
	  this.enableMouseOverOut();
	};
	rwgps.StartIcon = function (latlng, map) {
	  var _this12 = this;
	
	  this.map = map;
	  this.icon = {
	    url: "/images/start.svg",
	    size: new google.maps.Size(34, 47),
	    anchor: new google.maps.Point(21, 40)
	  };
	
	  var opts = { clickable: true, draggable: false };
	  if (map.inPlanningMode()) opts.draggable = true;
	
	  this.init(latlng, opts);
	  if (map.inPlanningMode()) {
	    this.enableDragEdit();
	    google.maps.event.addListener(this.gmarker, "click", function (e) {
	      map.onClickAddPoint(e);
	    });
	    if (rwgps.onRightClick) {
	      google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	        return rwgps.onRightClick(e, 'startIcon', _this12);
	      });
	    }
	  }
	  this.gmarker.setZIndex(0);
	};
	rwgps.StartIcon.prototype = new rwgps.Icon();
	rwgps.EndIcon = function (latlng, map) {
	  this.map = map;
	  this.icon = {
	    url: "/images/stop.svg",
	    size: new google.maps.Size(34, 47),
	    anchor: new google.maps.Point(21, 40)
	  };
	  this.init(latlng);
	};
	rwgps.EndIcon.prototype = new rwgps.Icon();
	rwgps.PointOfInterestIcon = function (latlng, map) {
	  this.map = map;
	  this.icon = "/images/poi.png";
	  this.init(latlng);
	};
	rwgps.PointOfInterestIcon.prototype = new rwgps.Icon();
	rwgps.NearestPointIcon = function (latlng, map) {
	  var _this13 = this;
	
	  this.map = map;
	  this.icon = new google.maps.MarkerImage("/images/nearest_point_icon.png", new google.maps.Size(14, 14), new google.maps.Point(0, 0), new google.maps.Point(7, 7));
	  var planning = window.Routes && Routes.activeMap && Routes.activeMap.inPlanningMode();
	  var allowClick = !!(window.Routes && Routes.activeMap && Routes.activeMap.opts.enableNearestPointMarkerClicks);
	  this.init(latlng, { clickable: planning || allowClick, draggable: planning && !this.map.inCueReview, raiseOnDrag: false, zIndex: 1 });
	  if (rwgps.onRightClick) {
	    google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	      return rwgps.onRightClick(e, 'nearestPoint', _this13);
	    });
	  }
	  if (planning) this.enableDragEdit();
	};
	rwgps.NearestPointIcon.prototype = new rwgps.Icon();
	rwgps.RacerIcon = function (latlng, map, icon) {
	  this.map = map;
	  this.icon = new google.maps.MarkerImage("/images/icons/racers/" + icon + ".png", new google.maps.Size(16, 16), new google.maps.Point(0, 0), new google.maps.Point(8, 8));
	  this.init(latlng, { clickable: false, draggable: false, raiseOnDrag: false, zIndex: 1 });
	};
	rwgps.RacerIcon.prototype = new rwgps.Icon();
	rwgps.ControlPointIcon = function (trackPoint, map) {
	  var _this14 = this;
	
	  this.map = map;
	  this.trackPoint = trackPoint;
	  this.icon = new google.maps.MarkerImage("/images/control_point_icon.png?1", new google.maps.Size(14, 14), new google.maps.Point(0, 0), new google.maps.Point(7, 7));
	  this.init(trackPoint.point, {
	    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
	    raiseOnDrag: false,
	    clickable: true,
	    draggable: true
	  });
	  this.enableDragEdit();
	  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(function () {
	    this.unhighlightNearestPoint();
	  }, this.map));
	  var cp = this;
	  google.maps.event.addListener(this.gmarker, 'click', $.proxy(function () {
	    rwgps.Events.trigger('map:control_point_clicked', cp);
	  }, this.map));
	  if (rwgps.onRightClick) {
	    google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	      return rwgps.onRightClick(e, 'controlPoint', _this14);
	    });
	  }
	};
	rwgps.ControlPointIcon.prototype = new rwgps.Icon();
	
	rwgps.ConnectionPointIcon = function (trackPoint, map) {
	  var _this15 = this;
	
	  this.map = map;
	  this.trackPoint = trackPoint;
	  this.overIcon = new google.maps.MarkerImage("/images/connection_point_icon.png?1", new google.maps.Size(18, 18), new google.maps.Point(0, 0), new google.maps.Point(9, 9));
	  this.outIcon = new google.maps.MarkerImage("/images/connection_point_icon_transparent.png?1", new google.maps.Size(18, 18), new google.maps.Point(0, 0), new google.maps.Point(9, 9));
	  this.icon = this.outIcon;
	  this.init(trackPoint.point, {
	    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
	    raiseOnDrag: false,
	    clickable: true,
	    draggable: false
	  });
	  var cp = this;
	  google.maps.event.addListener(this.gmarker, 'click', $.proxy(function () {
	    var afterConnected = _.once(function () {
	      rwgps.Events.unbind('maps:clicks_dispatched', afterConnected);
	      var inactiveRoute = trackPoint.nextSegment.route;
	      var activeRoute = map.activeRoute;
	      if (inactiveRoute.mysqlId && !activeRoute.mysqlId) {
	        activeRoute.mysqlId = inactiveRoute.mysqlId;
	        activeRoute.name = inactiveRoute.name;
	        activeRoute.routeData = { name: inactiveRoute.name, id: inactiveRoute.routeData.id, isTrip: inactiveRoute.routeData.isTrip };
	      }
	      map.snapshotsDisabled = true;
	      map.removeRoute(inactiveRoute);
	      map.snapshotsDisabled = false;
	      activeRoute.lastSegment.nextControlPoint.setNextSegment(inactiveRoute.firstSegment);
	      activeRoute.segmentsChanged();
	      activeRoute.rebuildBounds();
	      activeRoute.redraw();
	
	      activeRoute.pois = activeRoute.pois.concat(inactiveRoute.pois);
	      map.loadPois(activeRoute.pois);
	
	      var coursePoints = activeRoute.coursePoints();
	      map.drawCoursePointIcons(coursePoints);
	      map.populateCuesheet(coursePoints);
	
	      var tps = activeRoute.trackPoints();
	      map.prevClick = tps[tps.length - 1].point;
	
	      activeRoute.calculateMetrics();
	      map.drawRouteDistanceMarkers();
	      rwgps.Events.trigger('map:routes_changed');
	    });
	    rwgps.Events.bind('map:clicks_dispatched', afterConnected);
	    map.handleClick({
	      point: trackPoint.point,
	      opts: map.clickOptions,
	      color: map.lineColor,
	      fetchEles: true
	    });
	  }, this.map));
	  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(function () {
	    cp.gmarker.setIcon(cp.overIcon);
	  }, this.map));
	  google.maps.event.addListener(this.gmarker, 'mouseout', $.proxy(function () {
	    cp.gmarker.setIcon(cp.outIcon);
	  }, this.map));
	  if (rwgps.onRightClick) {
	    google.maps.event.addListener(this.gmarker, 'rightclick', function (e) {
	      return rwgps.onRightClick(e, 'connectionPoint', _this15);
	    });
	  }
	};
	rwgps.ConnectionPointIcon.prototype = new rwgps.Icon();
	
	// called by the standalone histogram. takes a start and end index from track points
	rwgps.highlightPoints = function (startI, endI, dontChangeView) {
	  if (!Routes.activeMap) return;
	  var map = Routes.activeMap,
	      tps = map.activeRoute.trackPoints().slice(startI, endI),
	      latlngs = [];
	  _.each(tps, function (pt) {
	    if (pt.point) latlngs.push(pt.googleLatLng());
	  });
	
	  if (map.highlightedPoints) {
	    rwgps.unhighlightPoints(true);
	  }
	
	  map.highlightedPoints = {
	    gPolyline: new google.maps.Polyline({
	      path: latlngs,
	      map: map.gmap,
	      strokeColor: '#0000FF',
	      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
	      clickable: false,
	      zIndex: 10000
	    }),
	    startI: startI,
	    endI: endI,
	    metrics: new rwgps.MetricsCalculator(_.map(tps, function (x) {
	      return _.clone(x);
	    })).calculate()
	  };
	  // zoom to highlighted section
	  if (dontChangeView == 'only_metrics') {
	    map.onMetricsChange();
	  } else if (!dontChangeView) {
	    var bounds = new google.maps.LatLngBounds();
	    _.each(latlngs, function (pt) {
	      bounds.extend(pt);
	    });
	    map.gmap.fitBounds(bounds);
	    // show highlighted section metrics
	    map.onMetricsChange();
	  }
	};
	
	rwgps.highlightDataSlice = function (dataSlice, dontChangeView, polylineOptions) {
	  //Called by some of the lap timers.
	  if (!Routes.activeMap) return;
	  var map = Routes.activeMap,
	      latlngs = [];
	  _.each(dataSlice.points(), function (pt) {
	    if (pt.point) latlngs.push(pt.googleLatLng());
	  });
	
	  if (map.highlightedPoints) {
	    rwgps.unhighlightPoints(true);
	  }
	
	  map.highlightedPoints = {
	    gPolyline: new google.maps.Polyline($.extend({
	      path: latlngs,
	      map: map.gmap,
	      strokeColor: '#0000FF',
	      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
	      clickable: false
	    }, polylineOptions)),
	    metrics: dataSlice.metrics()
	  };
	  // zoom to highlighted section
	  if (dontChangeView == 'only_metrics') {
	    map.onMetricsChange();
	  } else if (!dontChangeView) {
	    var bounds = new google.maps.LatLngBounds();
	    _.each(latlngs, function (pt) {
	      bounds.extend(pt);
	    });
	    map.gmap.fitBounds(bounds);
	    // show highlighted section metrics
	    map.onMetricsChange();
	  }
	};
	
	rwgps.zoomToPoint = function (i, zoomLevel) {
	  var map = Routes.activeMap,
	      pt = map.activeRoute.trackPoints()[i];
	  rwgps.zoomToLatLng(pt.point, zoomLevel);
	};
	rwgps.zoomToLatLng = function (latLng, zoomLevel) {
	  var map = Routes.activeMap;
	  if (!zoomLevel) zoomLevel = 14;
	  map.gmap.setCenter(new google.maps.LatLng(latLng.lat, latLng.lng));
	  map.gmap.setZoom(zoomLevel);
	};
	rwgps.zoomToPoints = function (startI, endI) {
	  var map = Routes.activeMap,
	      tps = map.activeRoute.trackPoints().slice(startI, endI);
	  // filter out points without points
	  tps = _.filter(tps, function (x) {
	    return x.point;
	  });
	
	  var bounds = new google.maps.LatLngBounds();
	  _.each(tps, function (pt) {
	    bounds.extend(pt.googleLatLng());
	  });
	  map.gmap.fitBounds(bounds);
	};
	rwgps.unhighlightPoints = function (dontChangeView) {
	  var map = Routes.activeMap;
	  if (!map || !map.highlightedPoints) {
	    return;
	  }
	  map.highlightedPoints.gPolyline.setMap(null);
	  delete map.highlightedPoints;
	  if (!dontChangeView) {
	    // zoom out
	    map.recenterMap();
	    // show active route metrics
	    map.onMetricsChange();
	  }
	};
	rwgps.recenterMap = function () {
	  Routes.activeMap.recenterMap();
	};
	// trackpoints (tps) is optional
	rwgps.highlightPoint = function (i, pct) {
	  var map = Routes.activeMap,
	      tps = map.activeRoute.trackPoints(),
	      pt = tps[i];
	  if (!pt) return;
	  var point = pt.point;
	  if (!point) return; // need a point to highlight... bail out if it doesn't exist.
	
	  if (map.keepPlayheadStopped) return;
	
	  var lastPt = tps[i - 1];
	  if (i > 0 && pct && lastPt.point) {
	    var lat1 = lastPt.point.lat,
	        lng1 = lastPt.point.lng,
	        lat2 = point.lat,
	        lng2 = point.lng,
	        newLat = (lat2 - lat1) * pct + lat1,
	        newLng = (lng2 - lng1) * pct + lng1;
	
	    point = { lat: newLat, lng: newLng };
	  }
	  if (map._playing) {
	    if ($('#playback_autoCenter').is(':checked')) {
	      map.gmap.setCenter(new google.maps.LatLng(newLat, newLng));
	    }
	  }
	  map.showNearestPointMarkerAt(point);
	
	  map.updatePlayhead(pt, tps);
	};
	
	rwgps.showMarker = function (lng, lat, id) {
	  var map = Routes.activeMap,
	      latLng = new google.maps.LatLng(lat, lng);
	
	  if (!rwgps.markerSet) rwgps.markerSet = {};
	  var set = rwgps.markerSet;
	
	  if (!set[id]) {
	    var icon = _.size(set) % 10 + 1;
	    set[id] = new rwgps.RacerIcon(latLng, map, icon);
	  }
	
	  if (set[id].gmarker.getMap() == null) set[id].gmarker.setMap(map.gmap);
	  if (set[id].gmarker.getVisible() == false) set[id].gmarker.setVisible(true);
	  set[id].gmarker.setPosition(latLng);
	  set[id].gmarker.setZIndex(0); //hack, setPosition seems to reset zindex to top :(
	};
	
	rwgps.removeMarker = function (id) {
	  if (rwgps.markerSet && rwgps.markerSet[id]) {
	    rwgps.markerSet[id].gmarker.setMap(null);
	    delete rwgps.markerSet[id];
	  }
	};
	
	// distance marker stuff
	rwgps.Map.prototype.updateDistanceMarkersDisplayed = function () {
	  var _this16 = this;
	
	  if (!this.gmap || !this.opts.distanceMarkersEnabled) return;
	
	  var i,
	      zoom = this.gmap.getZoom();
	  if (rwgps.LabelMaker.metric) {
	    if (zoom >= 14) i = 0;else if (zoom >= 13) i = 1;else if (zoom >= 12) i = 2;else if (zoom >= 10) i = 3;else i = 4;
	  } else {
	    if (zoom >= 13) i = 0;else if (zoom >= 12) i = 1;else if (zoom >= 11) i = 2;else if (zoom >= 9) i = 3;else i = 4;
	  }
	
	  if (i !== this._distanceMarkerLevel) {
	    // hide the previously shown set
	    if (this.distanceMarkers[this._distanceMarkerLevel]) {
	      this.distanceMarkers[this._distanceMarkerLevel].forEach(function (_ref4) {
	        var marker = _ref4.marker;
	        return marker.setMap(null);
	      });
	    }
	
	    this._distanceMarkerLevel = i;
	  }
	
	  // we don't show any distance markers when i === 4
	  var bounds = this.gmap.getBounds();
	  if (i < 4 && bounds) {
	    // display all markers currently visible in viewport, hide others
	    this.distanceMarkers[i].forEach(function (_ref5) {
	      var marker = _ref5.marker;
	
	      if (bounds.contains(marker.latLng)) {
	        if (!marker.getMap()) {
	          marker.setMap(_this16.gmap);
	        }
	      } else {
	        marker.setMap(null);
	      }
	    });
	  }
	};
	
	rwgps.Map.prototype.removeSegmentDistanceMarkers = function (segment) {
	  _.each(segment.distanceMarkers, function (marker) {
	    try {
	      marker.setMap(null);
	    } catch (e) {} // eslint-disable-line no-empty
	
	    _.each(this.distanceMarkers, function (arr) {
	      _.each(arr, function (o, i) {
	        try {
	          if (marker === o.marker) arr.splice(i, 1);
	        } catch (e) {} // eslint-disable-line no-empty
	      });
	    });
	  }, this);
	  segment.distanceMarkers = [];
	};
	
	rwgps.Map.prototype.removeRouteDistanceMarkers = function (route) {
	  if (this._updateDistanceMarkersListener) {
	    this._updateDistanceMarkersListener.remove();
	    this._updateDistanceMarkersListener = null;
	  }
	
	  this.distanceMarkers = [[], [], [], []];
	  _.each(route.segments, function (seg) {
	    seg.distanceMarkers.forEach(function (marker) {
	      return marker.setMap(null);
	    });
	    seg.distanceMarkers = [];
	  });
	  // will force a redraw on next updateDistanceMarkersDisplayed call
	  this._distanceMarkerLevel = null;
	};
	
	rwgps.Map.prototype.drawRouteDistanceMarkers = function (route) {
	  if (!route) route = this.activeRoute;
	  this.removeRouteDistanceMarkers(route);
	  _.each(route.segments, function (seg) {
	    this.drawSegmentDistanceMarkers(seg, true);
	  }, this);
	  this.updateDistanceMarkersDisplayed();
	  if (this.gmap) {
	    this._updateDistanceMarkersListener = this.gmap.addListener('bounds_changed', _.throttle(this.updateDistanceMarkersDisplayed.bind(this), 200));
	  }
	};
	
	function DistanceMarker(val, latLng) {
	  if (!DistanceMarker.prototype.setValues) {
	    // Use the hack described at https://github.com/googlemaps/js-map-label/issues/1
	    // to allow for async loading of google.maps
	    for (var prop in google.maps.OverlayView.prototype) {
	      DistanceMarker.prototype[prop] = google.maps.OverlayView.prototype[prop];
	    }
	  }
	  this.val = val;
	  this.latLng = latLng;
	}
	
	DistanceMarker.prototype.onAdd = function () {
	  var iconSrc = "/images/distance_marker_icon" + (this.val >= 1000 ? '_wide' : '') + ".png?1";
	  this.el = $("<div class=\"distanceMarkerLabel\"><img src=\"" + iconSrc + "\" /><span class=\"" + (this.val < 10 ? 'lt10' : this.val < 100 ? 'lt100' : this.val < 1000 ? 'lt1000' : 'gte1000') + "\">" + this.val + "</span></div>").get(0);
	  this.el.style.position = 'absolute';
	  this.getPanes().markerLayer.appendChild(this.el);
	};
	DistanceMarker.prototype.draw = function () {
	  var point = this.getProjection().fromLatLngToDivPixel(this.latLng);
	  if (point) {
	    this.el.style.left = point.x + 'px';
	    this.el.style.top = point.y + 'px';
	  }
	};
	DistanceMarker.prototype.onRemove = function () {
	  this.el && this.el.parentNode.removeChild(this.el);
	};
	
	rwgps.Map.prototype.drawSegmentDistanceMarkers = function (seg, dontRedisplay) {
	  if (!this.opts.distanceMarkersEnabled) return;
	  var prevPoint = seg.prevControlPoint;
	  var metersInUnit = rwgps.LabelMaker.metric ? 1000 : 1609.344;
	
	  for (var i = 0, len = seg.trackPoints.length; i < len; i++) {
	    var point = seg.trackPoints[i];
	    if (!point.point) continue;
	    var val = Math.floor(point.distanceWithoutExcludedPoints / metersInUnit),
	        prevVal = Math.floor(prevPoint.distanceWithoutExcludedPoints / metersInUnit);
	
	    if (val != prevVal && point.point && prevPoint.point) {
	      //we changed from a whole km or mi between these two points
	      //now linearly interpolate to find lat/lng of place to put marker
	      var latDiff = point.point.lat - prevPoint.point.lat;
	      var lngDiff = point.point.lng - prevPoint.point.lng;
	      var distDiff = point.distanceWithoutExcludedPoints - prevPoint.distanceWithoutExcludedPoints;
	      var percent = (val * metersInUnit - prevPoint.distanceWithoutExcludedPoints) / distDiff;
	
	      //now we have percent saying how much along the line to interpolate
	      var newLat = prevPoint.point.lat + latDiff * percent;
	      var newLng = prevPoint.point.lng + lngDiff * percent;
	
	      var marker = new DistanceMarker(val, new google.maps.LatLng(newLat, newLng));
	
	      var marker_obj = { lat: newLat, lng: newLng, marker: marker };
	      if (val % 25 == 0) this.distanceMarkers[3].push(marker_obj);
	      if (val % 5 == 0) this.distanceMarkers[2].push(marker_obj);
	      if (val % 2 == 0) this.distanceMarkers[1].push(marker_obj);
	
	      this.distanceMarkers[0].push(marker_obj);
	
	      seg.distanceMarkers.push(marker_obj.marker);
	    }
	
	    prevPoint = point;
	  }
	  if (!dontRedisplay) this.updateDistanceMarkersDisplayed();
	};
	
	rwgps.Map.prototype.distanceMarkersEnabled = function (b) {
	  this.opts.distanceMarkersEnabled = b;
	  this.drawRouteDistanceMarkers(this.activeRoute);
	};
	
	rwgps.Map.prototype.generateCues = function (b) {
	  this.opts.generateCues = b;
	};
	
	rwgps.Map.prototype.drawImageMarkers = function (photos) {
	  this.imageMarkers = {};
	  _.each(photos, function (photo) {
	    if (photo.lat && photo.lng) {
	      var marker = new google.maps.Marker({
	        map: this.gmap,
	        icon: '/images/image_marker.png?1',
	        position: new google.maps.LatLng(photo.lat, photo.lng),
	        clickable: true
	      });
	      google.maps.event.addListener(marker, 'click', function () {
	        if (marker.selected) {
	          $('.mini_slideshow .item.active a.popup_photo_modal').click();
	        } else {
	          var idx = $('.mini_slideshow .item').index($('.mini_slideshow img.ss_img[data-photo-id=' + photo.id + ']').closest('.item'));
	          $('.mini_slideshow').carousel(idx);
	        }
	      });
	      this.imageMarkers[photo.id] = marker;
	    }
	  }, this);
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	rwgps = window.rwgps || {};
	
	rwgps.Overlay = function (opts) {
	  if (opts) {
	    this.opts = opts;
	    switch (opts.type) {
	      case "osm":
	        return new rwgps.Overlay.OSM(opts);
	      case "arcgis":
	        return new rwgps.Overlay.ArcGIS(opts);
	      case "wms":
	        return new rwgps.Overlay.WMS(opts);
	    }
	  }
	};
	rwgps.Overlay.prototype = {
	  init: function init(opts) {
	    this.opts = opts;
	    this.url = opts.url;
	    this.provider = opts.provider || "google";
	    this.map = opts.map;
	    this.width = opts.width || 256;
	    this.height = opts.height || 256;
	  },
	  setProvider: function setProvider(provider, map) {
	    this.provider = provider;
	    this.map = map;
	  }
	};
	
	rwgps.Overlay.WMS = function (opts) {
	  this.init(opts);
	  this.requestOpts = opts.requestOpts || {
	    f: "image",
	    transparent: "true",
	    format: "png8",
	    bboxSR: "4326"
	  };
	};
	rwgps.Overlay.WMS.prototype = new rwgps.Overlay();
	rwgps.Overlay.WMS.prototype.getParamString = function () {
	  var str = [];
	  _.each(this.requestOpts, function (val, key) {
	    str.push(key + "=" + val);
	  });
	  return str.join("&");
	};
	rwgps.Overlay.WMS.prototype.getOverlayObj = function () {
	  if (this.provider == "google") {
	    var self = this;
	    return new google.maps.ImageMapType({
	      getTileUrl: function getTileUrl(coord, zoom) {
	        var proj = self.map.getProjection();
	        var zfactor = Math.pow(2, zoom);
	        var tpt = new google.maps.Point(coord.x * self.width / zfactor, coord.y * self.height / zfactor);
	        var bpt = new google.maps.Point((coord.x + 1) * self.width / zfactor, (coord.y + 1) * self.height / zfactor);
	        var top = proj.fromPointToLatLng(tpt);
	        var bot = proj.fromPointToLatLng(bpt);
	        return self.url + "?" + self.getParamString() + "&size=" + self.width + "," + self.height + "&bbox=" + top.lng() + "," + bot.lat() + "," + bot.lng() + "," + top.lat();
	      },
	      isPng: true,
	      name: self.opts.name,
	      tileSize: new google.maps.Size(self.width, self.height),
	      minZoom: self.opts.minZoom,
	      maxZoom: self.opts.maxZoom
	    });
	  } else {
	    return L.TileLayer.WMS(this.url, {
	      layers: this.opts.layers,
	      format: "image/png",
	      version: this.opts.version || "1.3",
	      transparent: true,
	      width: this.width,
	      height: this.height
	    });
	  }
	};
	
	rwgps.Overlay.OSM = function (opts) {
	  this.init(opts);
	};
	rwgps.Overlay.OSM.prototype = new rwgps.Overlay();
	rwgps.Overlay.OSM.prototype.getOverlayObj = function () {
	  if (this.provider == "google") {
	    var self = this;
	    return new google.maps.ImageMapType({
	      getTileUrl: function getTileUrl(coord, zoom) {
	        var str = self.url + zoom + "/" + coord.x + "/" + coord.y + ".png";
	        var sub = String.fromCharCode(Math.floor(Math.random() * 3) + 97);
	        if (self.opts.key && self.opts.key.length > 0) {
	          str += "?apikey=" + self.opts.key;
	        }
	        return str.replace("{s}", sub);
	      },
	      tileSize: new google.maps.Size(256, 256),
	      isPng: true,
	      alt: self.opts.alt,
	      name: self.opts.name,
	      maxZoom: self.opts.maxZoom
	    });
	  } else {
	    return L.TileLayer(this.url, { maxZoom: this.opts.maxZoom });
	  }
	};
	
	rwgps.Overlay.ArcGIS = function (opts) {
	  this.init(opts);
	};
	rwgps.Overlay.ArcGIS.prototype = new rwgps.Overlay();
	rwgps.Overlay.ArcGIS.prototype.getOverlayObj = function () {
	  if (this.provider == "google") {
	    var self = this;
	    return new google.maps.ImageMapType({
	      getTileUrl: function getTileUrl(coord, zoom) {
	        //var sub = String.fromCharCode(Math.floor(Math.random()*4+1) + 97);
	        var sub = Math.floor(Math.random() * 4 + 1);
	        var base = self.url.replace(/%{num}/, sub);
	        return base + '/tile/' + zoom + "/" + coord.y + "/" + coord.x + "?token=" + (self.opts.token || '');
	      },
	      tileSize: new google.maps.Size(256, 256),
	      isPng: true,
	      alt: this.opts.alt,
	      name: this.opts.name,
	      maxZoom: this.opts.maxZoom
	    });
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	rwgps = window.rwgps || {};
	rwgps.TrackPoint = function (opts) {
	  this.init(opts);
	};
	
	// SURFACE
	rwgps.TrackPoint.inferSurface = function (s, rc, lat, lng) {
	  if (s !== 95) {
	    // 95 is S_OTHER
	    return s;
	  }
	
	  var map = rwgps.surfaces.stInfer.find(function (map) {
	    var gllb = new google.maps.LatLngBounds({ lat: map[0], lng: map[1] }, { lat: map[2], lng: map[3] });
	    return gllb.contains({ lat: lat, lng: lng });
	  });
	  if (map) {
	    return rc !== undefined ? map[4][rc] : s;
	  } else {
	    // eslint-disable-next-line
	    console.warn('unable to resolve surface type inferrence rule for {lat: ' + lat + ', lng: ' + lng + '}');
	  }
	};
	
	// takes track_points array
	rwgps.TrackPoint.fromJSON = function (points, options) {
	  if (!options) options = {};
	  var clickIndexes = [];
	  var tps = [];
	  var prev = points[0];
	  for (var i = 0; i < points.length; i++) {
	    if (points[i] === null) continue;
	
	    //bad eles come back as -9999, just using < -1000 just in case
	    if (points[i].e < -1000) {
	      if (points[i - 1] && points[i - 1].e != null && points[i - 1].e >= -1000) {
	        points[i].e = points[i - 1].e;
	      } else if (points[i + 1] && points[i + 1].e != null && points[i + 1].e >= -1000) {
	        points[i].e = points[i + 1].e;
	      } else {
	        points[i].e = null;
	      }
	    }
	
	    var p = points[i];
	    var opts = { point: null, ele: p.e };
	    if (p.y != null && p.x != null) opts.point = { lat: p['y'], lng: p['x']
	      // if in the route planner, don't assign distances, let them get calculated dynamically by metrics calculator
	      // if we assign distances now they will be used to calculate deltas for the entire planning session, which will make
	      // preexisting distance errors stick around forever. ignoring the cached d values will have them set based on
	      // calculated distance between points throughout the planning session, which is less error prone.
	    };if (!options.planning && p['d'] != null && p['d'] !== '' && (!prev['d'] || prev['d'] <= p['d'])) {
	      opts.distance = p['d'];
	    }
	
	    var tp = new rwgps.TrackPoint(opts);
	    tp.hr = p['h'];
	    tp.cad = p['c'];
	    tp.watts = p['p'];
	    tp.time = p['t'];
	    tp.temp = p['T'];
	    tp.modified = p['m'];
	    // SURFACE
	    if (rwgps.surfaces && rwgps.surfaces.stInfer) {
	      tp.roadClass = p['R'];
	      tp.ghSurface = p['S'];
	      tp.surface = rwgps.TrackPoint.inferSurface(p['S'], p['R'], p['y'], p['x']);
	    }
	    if (p['RE'] !== undefined) {
	      tp.roadEnv = p['RE'];
	      if (p['flat'] !== undefined) {
	        tp.flattened = p['flat'];
	      }
	    }
	    if (p['k']) {
	      tp.excludeFromMetrics = true;
	      tp.exclude = true;
	    }
	    if (!isNaN(p['s']) && p['s'] !== undefined) tp.speed = p['s'] * 3.6; //from FIT we get m/sec, not km/hour
	    tps.push(tp);
	    if (p["options"] || p["color"]) {
	      clickIndexes.push(tps.length - 1);
	    } else if (prev && !prev["k"] && p["k"]) {
	      clickIndexes.push(tps.length - 1);
	    } else if (prev && prev["k"] && !p["k"] && !(prev.options || p.color)) {
	      // prevent duplicate clickIndexes
	      clickIndexes.push(tps.length - 2);
	    }
	
	    prev = p;
	  }
	  if (clickIndexes.length > 0 && clickIndexes[clickIndexes.length - 1] != points.length - 1) clickIndexes.push(points.length - 1);
	  return { clickIndexes: clickIndexes, trackPoints: tps };
	};
	
	rwgps.TrackPoint.prototype = {
	  point: null, // {lat, lng}
	  distance: null,
	  ele: null,
	  hr: null,
	  cad: null,
	  watts: null,
	  time: null,
	  grade: null,
	  speed: null,
	  temp: null,
	  excludeFromMetrics: null,
	  segment: null,
	  isControlPoint: false,
	  prevSegment: null,
	  nextSegment: null,
	  surface: null, // int
	  roadClass: null, // int
	  ghSurface: null, // int
	  roadEnv: null, // int
	  modified: null, // bool
	  flattened: null, // bool
	
	  init: function init(opts) {
	    if (opts) {
	      this.point = opts.point;
	      this.time = opts.time;
	      this.distance = opts.distance;
	      if (opts.distance !== undefined) this.providedDistance = opts.distance;
	      this.ele = opts.ele;
	      this.segment = opts.segment;
	      this.surface = opts.surface;
	      this.roadClass = opts.roadClass;
	      this.ghSurface = opts.ghSurface;
	      this.roadEnv = opts.roadEnv;
	      this.excludeFromMetrics = opts.excludeFromMetrics;
	    }
	  },
	  googleLatLng: function googleLatLng() {
	    if (!window.google || !window.google.maps) console.error("Google Maps not loaded, attempt to instantiate google.maps.LatLng"); // eslint-disable-line
	    if (this._googleLatLng === undefined) {
	      this._googleLatLng = this.point ? new google.maps.LatLng(this.point.lat, this.point.lng) : null;
	    }
	    return this._googleLatLng;
	  },
	  pointEquals: function pointEquals(pt) {
	    return this.point.lat == pt.lat && this.point.lng == pt.lng;
	  },
	  // if two segment are connected, there can only be one control point connecting them so
	  // one of the cps will be demoted with this fn
	  ensureNotControlPoint: function ensureNotControlPoint() {
	    this.isControlPoint = false;
	    this.prevSegment = null;
	    this.nextSegment = null;
	  },
	  setNextSegment: function setNextSegment(seg) {
	    this.segment = null;
	    this.isControlPoint = true;
	    this.nextSegment = seg;
	    if (seg) {
	      seg.prevControlPoint = this;
	      seg.prevSegment = this.prevSegment;
	    }
	    if (this.prevSegment) {
	      this.prevSegment.nextSegment = seg;
	    }
	  },
	  setPrevSegment: function setPrevSegment(seg) {
	    this.segment = null;
	    this.isControlPoint = true;
	    this.prevSegment = seg;
	    if (seg) {
	      seg.nextControlPoint = this;
	      seg.nextSegment = this.nextSegment;
	    }
	    if (this.nextSegment) {
	      this.nextSegment.prevSegment = seg;
	    }
	  },
	  toMiniObj: function toMiniObj() {
	    var pt = {};
	    if (this.point) {
	      pt.x = this.point.lng;
	      pt.y = this.point.lat;
	    }
	    //gmaps doesn't have precision > 6 digits, get rid of 0's
	    if (_.isNumber(pt.x)) pt.x = Math.round(pt.x * 1000000) / 1000000;
	    if (_.isNumber(pt.y)) pt.y = Math.round(pt.y * 1000000) / 1000000;
	    if (_.isNumber(this.ele)) pt['e'] = this.ele;
	    if (_.isNumber(this.cad)) pt['c'] = this.cad;
	    if (_.isNumber(this.hr)) pt['h'] = this.hr;
	    if (_.isNumber(this.watts)) pt['p'] = this.watts;
	    if (_.isNumber(this.time)) pt['t'] = this.time;
	    if (_.isNumber(this.speed)) pt['s'] = this.speed_orig / 3.6; // convert back to m/s
	    if (_.isNumber(this.temp)) pt['T'] = this.temp;
	    if (_.isNumber(this.distance)) pt['d'] = Math.round(this.distance * 1000) / 1000;
	    if (this.excludeFromMetrics) pt['k'] = true;
	    pt['S'] = this.ghSurface;
	    pt['R'] = this.roadClass;
	    pt['m'] = this.modified;
	    if (this.roadEnv !== undefined) {
	      pt['RE'] = this.roadEnv;
	      if (this.flattened) {
	        pt['flat'] = this.flattened;
	      }
	    }
	
	    return pt;
	  },
	  shallowClone: function shallowClone() {
	    return new rwgps.TrackPoint({
	      point: this.point ? { lat: this.point.lat, lng: this.point.lng } : null,
	      ele: this.ele,
	      surface: this.surface,
	      ghSurface: this.ghSurface,
	      roadClass: this.roadClass
	    });
	  },
	  distanceFromPoint: function distanceFromPoint(pt) {
	    return this.distanceFromLatLng(pt.point);
	  },
	  distanceFromLatLng: function distanceFromLatLng(latlng) {
	    var lat1 = latlng.lat * Math.PI / 180;
	    var lng1 = latlng.lng * Math.PI / 180;
	    var lat2 = this.point.lat * Math.PI / 180;
	    var lng2 = this.point.lng * Math.PI / 180;
	    return rwgps.TrackPoint.haversine(lat1, lng1, lat2, lng2);
	  },
	  headingFromPoint: function headingFromPoint(pt) {
	    //http://mathforum.org/library/drmath/view/55417.html
	    var lat1 = this.point.lat * Math.PI / 180;
	    var lon1 = this.point.lng * Math.PI / 180;
	    var lat2 = pt.point.lat * Math.PI / 180;
	    var lon2 = pt.point.lng * Math.PI / 180;
	    var rads = Math.atan2(Math.sin(lon2 - lon1) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));
	    var degs = rads * (180 / Math.PI);
	    return (degs + 360) % 360;
	  }
	};
	rwgps.TrackPoint.haversine = function (lat1, lng1, lat2, lng2) {
	  var lat_diff = lat1 - lat2;
	  var lng_diff = lng1 - lng2;
	  var radius = 6378100;
	  var lat_tmp = Math.sin(lat_diff / 2);
	  var lng_tmp = Math.sin(lng_diff / 2);
	  var a = lat_tmp * lat_tmp + Math.cos(lat1) * Math.cos(lat2) * lng_tmp * lng_tmp;
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  // Quantize to 1mm: trig differs ~1 ULP across JS/WASM libm, which flips 100m filter decisions.
	  return Math.round(radius * c * 1000) / 1000;
	};
	// options: {seconds: x}, or {meters: x}
	rwgps.TrackPoint.calculateSplits = function (options) {
	  var trackPoints = Routes.sampleGraph._data.points();
	  if (trackPoints.length < 2) return;
	  var attr = options.method;
	  var offset = trackPoints[0][attr];
	  var splitStartI = 0;
	  var splits = [];
	  var pct1 = 0;
	  var pct2 = 0,
	      pt,
	      lastPt,
	      lastI,
	      metrics;
	  for (var i = 0, len = trackPoints.length; i < len; i++) {
	    if (trackPoints[i][attr] - offset >= options.value) {
	      pt = trackPoints[i];
	      lastPt = trackPoints[i - 1];
	      pct2 = 1 - (pt[attr] - offset - options.value) / (pt[attr] - lastPt[attr]);
	      if (pct2 == 1) {
	        lastI = i;
	        pct2 = 0;
	      } else {
	        lastI = i - 1;
	      }
	      metrics = rwgps.TrackPoint.buildSplitObject(splitStartI, lastI, pct1, pct2);
	      splits.push(metrics);
	      splitStartI = lastI;
	      pct1 = pct2;
	      offset += options.value;
	    } else if (i == len - 1) {
	      metrics = rwgps.TrackPoint.buildSplitObject(splitStartI, i, pct1);
	      splits.push(metrics);
	    }
	  }
	  return splits;
	};
	
	rwgps.TrackPoint.buildSplitObject = function (splitStartI, lastI, pct1, pct2) {
	  var data = Routes.sampleGraph ? Routes.sampleGraph._data : Routes.data;
	  var slice = data.slice(splitStartI, lastI - splitStartI + 1, pct1, pct2);
	  var metrics = slice.metrics();
	  metrics.first_i = splitStartI;
	  metrics.last_i = lastI;
	  metrics.slice = slice;
	  // add some fields so it matches up with what we get from the
	  // server for lapSummaries
	  metrics.moving_time = metrics.movingTime;
	  metrics.elevation_gain = metrics.ele_gain;
	  metrics.elevation_loss = metrics.ele_loss;
	  metrics.pace = Math.round(metrics.moving_time / rwgps.LabelMaker.longLabel(metrics.distance, false, 5));
	  return metrics;
	};
	
	rwgps.CoursePoint = function (opts) {
	  this.notes = opts["notes"] || '';
	  this.type = opts["type"] || "";
	  //this.relativeDistance = opts["relativeDistance"] || 0;
	  this.trackPointIndex = opts["trackPointIndex"] || -1;
	  this.trackPoint = opts["trackPoint"] || null;
	  this.marker = opts["marker"] || null;
	  this.description = opts["description"] || '';
	  this.photoIds = opts["photoIds"] || [];
	  this.edited = opts["edited"];
	  this.confirmed = opts["confirmed"] || false;
	
	  this.init(opts);
	};
	rwgps.CoursePoint.prototype = new rwgps.TrackPoint();
	rwgps.CoursePoint.prototype.toMiniObj = function () {
	  var pt = { x: this.point.lng, y: this.point.lat };
	  if (this.edited) pt['_e'] = 1;
	  if (this.type) pt['t'] = this.type;
	  if (this.notes) pt['n'] = this.notes;
	  if (_.isNumber(this.distance)) pt['d'] = this.distance;
	  if (_.isNumber(this.trackPointIndex)) pt['i'] = this.trackPointIndex;
	  if (this.description) pt['description'] = this.description;
	  if (this.photoIds && this.photoIds.length > 0) pt['photo_ids'] = this.photoIds;
	  if (this.confirmed === true) pt['c'] = this.confirmed;
	
	  return pt;
	};
	rwgps.CoursePoint.prototype.buildCoursePointTypeSelect = function () {
	  var types = T.t('cuesheet_types');
	  var self = this;
	  var str = "<select class='coursePointType form-control' style='width:75%;display:inline;'>";
	  _.each(types, function (val, key) {
	    str += "<option value='" + key + "'" + (key == self.type ? " selected" : "") + ">" + val + "</option>";
	  });
	  return str += "</select>";
	};
	rwgps.CoursePoint.prototype.editHtml = function () {
	  return "<div id='coursePointInfoWindowContent'>" + ('<label class=\'inline\'>' + T.t('type') + '</label>') + this.buildCoursePointTypeSelect() + ('<label>' + T.t('notes') + '</label>') + "<textarea class='coursePointDescription'>" + _.escape(this.notes || "") + "</textarea>" + ('<label>' + T.t('description') + '</label>') + "<textarea class='coursePointLongDescription'>" + _.escape(this.description || "") + "</textarea>" + "<div class='photos_view'></div>" + ('<button type=\'submit\' class=\'saveButton btn btn-primary\'>' + T.t('save') + '</button>') + "<div class='bottom-buttons'>" + ('<button type=\'submit\' class=\'deleteButton btn btn-link\'>' + T.t('delete') + '</button>') + ('<button type=\'submit\' class=\'cancelButton btn btn-link\'>' + T.t('cancel') + '</button>') + "</div>" + "</div>";
	};
	rwgps.CoursePoint.prototype.previewHtml = function () {
	  var desc = "<div id='poiInfoWindowContent' class='show'>" + "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + this.type + "</p>" + "<p><span style='font-weight:bold;'>" + T.t('notes') + ": </span> " + _.escape(this.notes) + "</p>";
	  if (this.photoIds.length > 0) {
	    //desc += "<p><span style='font-weight:bold;'>" + this.photoIds.length + " photos</span></p>";
	    desc += "<p>" + T.t('show_photos', { count: this.photoIds ? this.photoIds.length : 0 }) + "</span></p>";
	  }
	  desc += "</div>";
	  return desc;
	};
	rwgps.CoursePoint.prototype.showHtml = function () {
	  var desc = "<div id='poiInfoWindowContent' class='show'>" + "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + this.type + "</p>" + "<p><span style='font-weight:bold;'>" + T.t('notes') + ": </span> " + _.escape(this.notes) + "</p>";
	  if (this.description && this.description.length > 0) {
	    desc += "<p><span style='font-weight:bold;margin-right:5px;'>" + T.t('description') + ":</span>" + (this.description ? _.escape(this.description).replace(/\n|\r/gi, '<br>') : '');
	  }
	
	  if (this.photoIds.length > 0) {
	    desc += "</p><br/><br/>" + _.map(this.photoIds, function (photoId) {
	      return "<div style='float:left;border:1px solid #CCC;padding:2px;width:64;height:64px;'>" + "<a class='thickbox' href='/photos/medium/" + photoId + ".jpg'>" + "<img src='/photos/milli/" + photoId + ".jpg'></a></div>";
	    }).join('');
	  }
	  desc += "</div>";
	  return desc;
	};
	rwgps.PointOfInterest = function (opts) {
	  this.id = opts["id"] || null;
	  this.name = opts["name"] || '';
	  this.url = opts["url"] || null;
	  this.poiType = opts["poiType"];
	  this.description = opts["description"] || '';
	  this.photoIds = opts["photoIds"] || [];
	  this.marker = null;
	  this.readOnly = opts.hasOwnProperty("readOnly") ? opts["readOnly"] : false;
	  this.route = null;
	  this.visibility = opts['visibility'];
	  this.userId = opts['userId'];
	  this.library = opts.library;
	  this.addToPoiLibrary = opts.library;
	  this.saveOrUpdate = opts.library ? 'update' : undefined;
	
	  this.init(opts);
	};
	rwgps.PointOfInterest.fromJSON = function (raw, ro) {
	  if (raw === undefined) return;
	  if (ro === undefined) ro = true;
	  var pois = typeof raw == "string" ? $.evalJSON(raw) : raw;
	  var pts = [];
	  if (pois) {
	    for (var i = 0; i < pois.length; i++) {
	      var pt = pois[i];
	      // ro can be an array of ids that should be readonly, or it can be
	      // a boolean that applies to all pois we're populating
	      var poi = new rwgps.PointOfInterest({
	        id: pt["id"],
	        point: { lat: pt["lat"] || pt.y, lng: pt["lng"] || pt.x },
	        name: pt["name"] || pt.name,
	        poiType: pt["poi_type"] || pt.poi_type,
	        description: pt["description"] || pt.description,
	        url: pt["url"],
	        readOnly: ro,
	        library: pt.parent_type === 'Club',
	        photoIds: pt["photo_ids"] || pt.photo_ids || [],
	        visibility: pt['visibility'],
	        userId: pt['user_id'],
	        addToPoiLibrary: pt.parent_type === 'Club'
	      });
	      pts.push(poi);
	    }
	  }
	  return pts;
	};
	rwgps.PointOfInterest.prototype = new rwgps.TrackPoint();
	rwgps.PointOfInterest.prototype.copy = function () {
	  var newPoi = this.toSaveObj();
	  delete newPoi.id;
	  return rwgps.PointOfInterest.fromJSON([newPoi], false)[0];
	};
	rwgps.PointOfInterest.prototype.isEditable = function () {
	  if (this.id == null) return true; //new POI
	
	  var ns = rwgps.ns('config');
	  if (ns.currentUser && ns.currentUser.id == this.userId) return true;else return false;
	};
	
	rwgps.PointOfInterest.prototype.addToRoute = function () {
	  var map = this.marker.map;
	  this.ghosted = false;
	
	  // make sure its in the pointsofinterest array
	
	  if (!_.detect(map.pointsOfInterest, function (x) {
	    return x.id == this.id;
	  }, this)) {
	    map.pointsOfInterest.push(this);
	  }
	
	  // unghost the icon
	  this.marker.gmarker.setMap(null);
	  this.marker = new rwgps.PoiIcon(this, map);
	  map.closeStickyInfoWindow();
	
	  // tell everyone its added
	  rwgps.Events.trigger('pois:added', this);
	};
	rwgps.PointOfInterest.prototype.removeFromRoute = function () {
	  var map = this.marker.map;
	  this.ghosted = true;
	
	  //make sure its no longer in the pointsofinterest array
	  map.pointsOfInterest = _.without(map.pointsOfInterest, this);
	
	  //ghost the icon
	  this.marker.gmarker.setMap(null);
	  this.marker = new rwgps.PoiIcon(this, map);
	  map.closeStickyInfoWindow();
	
	  // tell everyone its removed
	  rwgps.Events.trigger('pois:removed', [this]);
	};
	
	rwgps.PointOfInterest.prototype.toSaveObj = function () {
	  var pt = { lat: this.point.lat, lng: this.point.lng, poi_type: this.poiType || 17 };
	  pt['id'] = this.id;
	  pt['name'] = this.name;
	  pt['description'] = this.description;
	  if (this.photoIds && this.photoIds.length > 0) pt['photo_ids'] = this.photoIds;
	  pt['url'] = this.url;
	  pt['user_id'] = this.userId;
	  pt['addToPoiLibrary'] = this.addToPoiLibrary;
	  if (this.addToPoiLibrary) {
	    pt['saveOrUpdate'] = this.saveOrUpdate;
	  }
	  return pt;
	};
	// change this to be poi categories or something
	// it is expected that rwgps.PointOfInterest.poiTypes and rwgps.PointOfInterest.poiTypesById are populated already (done in the view by the app)
	rwgps.PointOfInterest.prototype.buildTypeSelect = function () {
	  var types = rwgps.PointOfInterest.poiTypes;
	  var str = "<select class='poiType' style='width: 100%'>";
	  var selectedType = this.poiType ? this.poiType : 17;
	  for (var i = 0; i < types.length; i++) {
	    if (!types[i].disabled || types[i]._id == selectedType) {
	      str += "<option title='/images/" + rwgps.poiIconsPath() + types[i].icon + "?2' value='" + types[i]._id + "'" + (types[i]._id == selectedType ? " selected" : "") + ">" + types[i].name + "</option>";
	    }
	  }
	  return str += "</select>";
	};
	
	var hasPoiLibrary = function hasPoiLibrary() {
	  return rwgps.activeNs.hasPoiLibrary;
	};
	
	rwgps.PointOfInterest.prototype.editHtml = function () {
	  var html = "<div id='poiInfoWindowContent'>";
	  if (this.library || hasPoiLibrary()) {
	    var checked;
	    if (this.addToPoiLibrary === undefined) {
	      checked = this.library || !this.id; // first load
	    } else {
	      checked = this.addToPoiLibrary !== false; // subsequent loads
	    }
	    html += '\n      <input type=\'checkbox\' ' + (checked && 'checked') + ' class=\'addToPoiLibrary\' data-poi_id=\'' + (this.id || '') + '\' />\n      <label class=\'inline\'>' + T.t('add_to_library') + '</label>\n      ';
	    if (this.library && this.addToPoiLibrary !== false) {
	      html += '<span id=\'saveOrUpdate\'>\n        <div style=\'padding-left:15px\'>\n          <input name=\'saveOrUpdate\' type=\'radio\' value=\'update\' ' + (this.saveOrUpdate !== 'save' && 'checked') + ' {/>\n          <label class=\'inline\'>' + T.t('update_in_library') + '</label>\n        </div>\n        <div style=\'padding-left:15px\'>\n          <input name=\'saveOrUpdate\' type=\'radio\' value=\'save\' ' + (this.saveOrUpdate === 'save' && 'checked') + '/>\n          <label class=\'inline\'>' + T.t('save_as_new_poi') + '</label>\n        </div>\n      </span>';
	    }
	  }
	  html += '<div style=\'margin-bottom:5px;height:60px\'>\n            ' + this.buildTypeSelect() + '\n          </div>\n          <label>' + T.t('name') + '</label>\n          <input type=\'text\' class=\'poiName\' value=\'' + _.escape(this.name || "") + '\' />\n          <label>' + T.t('url') + '</label>\n          <input type=\'text\' class=\'poiUrl\' value=\'' + _.escape(this.url || "") + '\' />\n          <label>' + T.t('description') + '</label>\n          <textarea class=\'poiDescription\'>' + _.escape(this.description || "") + '</textarea>\n          <div class=\'photos_view\'></div>\n          <button type=\'submit\' class=\'saveButton btn btn-primary\' data-poi_id=\'' + (this.id || '') + '\'>' + T.t('save') + '</button>\n          <div class=\'bottom-buttons\'>\n            <button type=\'submit\' class=\'deleteButton btn btn-link\' style=\'padding-bottom:0px\' data-poi_id=\'' + (this.id || '') + '\'>' + T.t('delete') + '</button>\n            <button type=\'submit\' class=\'cancelButton btn btn-link\' style=\'padding-bottom:0px\' data-poi_id=\'' + (this.id || '') + '\'>' + T.t('cancel') + '</button>\n            <button type=\'submit\' class=\'poi_route_to btn btn-link\' style=\'padding-bottom:0px\' data-poi_id=\'' + (this.id || '') + '\'>' + T.t('route_to_poi') + '</button>\n          </div>\n        </div>';
	  return html;
	};
	rwgps.PointOfInterest.prototype.previewHtml = function () {
	  var poiType = rwgps.PointOfInterest.poiTypesById[this.poiType];
	  var desc = "<div id='poiInfoWindowContent' class='show'>" + (poiType && poiType.name != 'Generic' ? "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + poiType.name + "</p>" : "") + "<p><span style='font-weight:bold;'>" + T.t('name') + ": </span> " + _.escape(this.name) + "</p>";
	  if (this.url) desc += "<p><span style='font-weight:bold;'>" + T.t('url') + ": </span> " + rwgps.Utils.truncate(this.url, 25) + "</p>";
	  if (this.photoIds.length > 0) {
	    //desc += "<p><span style='font-weight:bold;'>" + this.photoIds.length + " photos</span></p>";
	    desc += "<p>" + T.t('show_photos', { count: this.photoIds ? this.photoIds.length : 0 }) + "</span></p>";
	  } else {
	    desc += "<p style='font-style: italic'>" + T.t("click_for_details") + "</p>";
	  }
	  desc += "</div>";
	  return desc;
	};
	rwgps.PointOfInterest.prototype.showHtml = function () {
	  var map;
	  var poiType = rwgps.PointOfInterest.poiTypesById[this.poiType];
	  var desc = "<div id='poiInfoWindowContent' class='show'>" + (poiType && poiType.name != 'Generic' ? "<p><span style='font-weight:bold;'>" + T.t('type') + ": </span> " + poiType.name + "</p>" : "") + "<p><span style='font-weight:bold;'>" + T.t('name') + ": </span> " + _.escape(this.name) + "</p>" + (this.url ? "<p><span style='font-weight:bold;'>" + T.t('url') + ": </span> <a href='" + this.url + "' target='_blank'>" + rwgps.Utils.truncate(_.escape(this.url), 25) + "</a></p>" : '');
	  if (this.description && this.description.length > 0) {
	    desc += "<p><span style='font-weight:bold;margin-right:5px;'>" + T.t('description') + ":</span>" + _.escape(this.description).replace(/\r|\n/gi, '<br>');
	  }
	  map = this.marker.map;
	
	  if (this.photoIds.length > 0) {
	    desc += "</p><br/><br/>" + _.map(this.photoIds, function (photoId) {
	      return "<div style='float:left;border:1px solid #CCC;padding:2px;width:64;height:64px;'>" + "<a class='thickbox' href='/photos/medium/" + photoId + ".jpg'>" + "<img src='/photos/milli/" + photoId + ".jpg'></a></div>";
	    }).join('');
	  }
	  map = this.marker.map;
	  if (map && map.inPlanningMode()) {
	    // keep an easily accessible reference to this poi around so when these links are clicked we can get the poi
	    map.poisById[this.id] = this;
	    desc += '<div class="clear"></div><div class="spacer"></div><p>Editable in POI Library (<a href="javascript:;" class="poi_make_unique" data-poi_id="' + (this.id || '') + '">Make unique</a>)</p>';
	    desc += '<div class="clear"></div><div class="spacer"></div><p><a href="javascript:;" class="poi_remove_from_route" data-poi_id="' + (this.id || '') + '">Remove from route</a></p>';
	    desc += '<p><a href="javascript:;" class="poi_route_to" data-poi_id="' + (this.id || '') + '">' + T.t('route_to_poi') + '</a></p>';
	  }
	  desc += "</div>";
	  return desc;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	rwgps = window.rwgps || {};
	
	rwgps.Route = function (data, map, options) {
	  this.segments = [];
	  this.distance = 0;
	  this.startMarker = null;
	  this.endMarker = null;
	  this.gBounds = new google.maps.LatLngBounds();
	  this.locality = null;
	  this.postalCode = null;
	  this.administrativeArea = null;
	  this.countryCode = null;
	  this.map = map;
	  this.metricsChangeCallbacks = [];
	  this.mysqlId = null;
	  this.mongoidId = null;
	  this.photoIds = [];
	  this.userId = null;
	  this.drawInactive = true;
	  this.pois = [];
	
	  var setShowSurface = function setShowSurface(data) {
	    if (!rwgps.config.labs.surface_types) {
	      return false;
	    }
	    if (data) {
	      return data.showSurface || !_.some(data.track_points, function (p) {
	        return p['S'] === undefined;
	      });
	    } else {
	      return true;
	    }
	  };
	
	  this.showSurface = setShowSurface(data);
	
	  if (data) {
	    this.initFromDataJSON(data, options);
	  }
	};
	
	rwgps.Route.DEFAULT_LINE_WIDTH = 4;
	// the default line color gets overridden and is actively used --
	// original is just to figure out if the user built the route on rwgps
	// and changed colors or not
	rwgps.Route.ORIGINAL_DEFAULT_LINE_COLOR = 0xFF0000;
	rwgps.Route.DEFAULT_LINE_COLOR = 0xFF0000;
	
	rwgps.Route.prototype = {
	  setModified: function setModified() {
	    this._dirty = true;
	    rwgps.Events.trigger('route:modified', this);
	  },
	  isModified: function isModified() {
	    return this._dirty;
	  },
	  setMap: function setMap(map) {
	    this.map = map;
	    _.each(this.segments, function (seg) {
	      seg.map = map;
	    });
	  },
	  deleteCoursePoints: function deleteCoursePoints() {
	    _.each(this.segments, function (seg) {
	      _.each(seg.coursePoints, function (cp) {
	        if (cp.row) cp.row.remove();
	        if (cp.marker && cp.marker.gmarker) cp.marker.gmarker.setMap(null);
	      });
	      seg.coursePoints = [];
	    });
	  },
	  segments: function segments(i) {
	    if (i) {
	      var seg = this.firstSegment;
	      while (i--) {
	        seg = seg.nextSegment;
	      }return seg;
	    }
	  },
	  segmentsChanged: function segmentsChanged(newSegment) {
	    this.segments = [];
	    var seg = this.firstSegment,
	        count = 0;
	    var seen = {};
	    if (seg) {
	      count = 1;
	      do {
	        if (seen[seg._segId]) {
	          break;
	        }
	        seen[seg._segId] = true;
	        seg.route = this;
	        this.segments.push(seg);
	        count++;
	        seg = seg.nextSegment;
	      } while (seg);
	      this.lastSegment = this.segments[this.segments.length - 1];
	    }
	
	    // clear trackpoints cache
	    delete this._trackPoints;
	    if (this.map && this.map.activeRoute === this) delete this.map.routePoints;
	
	    // update connection point trackPoint if it exists
	    if (this.connectionPointIcon && this.firstSegment) {
	      this.connectionPointIcon.trackPoint = this.firstSegment.prevControlPoint;
	    }
	
	    if (newSegment) {
	      //since segments assign distances to trackPoints on creation, we have to
	      //add in the route's current distance to the segs trackpoints when appending
	      //also collect LatLng's for assigning to polyline, as well as bounds
	      if (newSegment.prevControlPoint && newSegment.prevControlPoint.point) this.gBounds.extend(newSegment.prevControlPoint.googleLatLng());
	      if (newSegment.nextControlPoint && newSegment.nextControlPoint.point) this.gBounds.extend(newSegment.nextControlPoint.googleLatLng());
	      for (var i = 0; i < newSegment.trackPoints.length; i++) {
	        var tp = newSegment.trackPoints[i];
	        if (tp.point) this.gBounds.extend(tp.googleLatLng()); //add to our bounds set
	      }
	      if (newSegment.coursePoints) {
	        for (i = 0; i < newSegment.coursePoints.length; i++) {
	          var cp = newSegment.coursePoints[i];
	          cp.distance = cp.trackPoint.distance;
	          cp.route = this;
	        }
	      }
	    }
	  },
	  createSegmentBoundariesForSlice: function createSegmentBoundariesForSlice(dataSlice) {
	    var tps = this.trackPoints(),
	        firstPt = tps[dataSlice.i],
	        lastPt = tps[dataSlice.i + dataSlice.count - 1];
	    // split segs on crop boundaries
	    if (!firstPt.isControlPoint) {
	      var firstPtSegmentI = _.indexOf(firstPt.segment.trackPoints, firstPt);
	      firstPt.segment.splitAfter(firstPtSegmentI - 1);
	    }
	    if (!lastPt.isControlPoint) {
	      var lastPtSegmentI = _.indexOf(lastPt.segment.trackPoints, lastPt);
	      lastPt.segment.splitAfter(lastPtSegmentI - 1);
	    }
	  },
	  removeSlice: function removeSlice(dataSlice) {
	    var tps = this.trackPoints(),
	        firstPt = tps[dataSlice.i],
	        lastPt = tps[dataSlice.i + dataSlice.count - 1],
	        newRoute,
	        segs;
	
	    this.createSegmentBoundariesForSlice(dataSlice);
	
	    if (dataSlice.i === 0) {
	      segs = [lastPt.prevSegment];
	      while (segs[0].prevSegment) {
	        segs.unshift(segs[0].prevSegment);
	      }
	      _.each(segs, function (seg) {
	        this.removeSegment(seg);
	      }, this);
	      this.firstSegment = lastPt.nextSegment;
	      this.segmentsChanged();
	      this.calculateMetrics();
	      this.startMarker.gmarker.setPosition(lastPt.googleLatLng());
	    } else {
	      if (lastPt.nextSegment) {
	        newRoute = new rwgps.Route(null, this.map);
	        this.map.routes.push(newRoute);
	        newRoute.firstSegment = lastPt.nextSegment;
	        lastPt.prevSegment.nextSegment = null;
	        lastPt.setPrevSegment(null);
	        newRoute.segmentsChanged();
	        newRoute.rebuildBounds();
	        newRoute.calculateMetrics();
	        newRoute.setInactive(true);
	      } else if (this.endMarker) {
	        this.endMarker.gmarker.setPosition(firstPt.googleLatLng());
	      }
	
	      segs = [firstPt.nextSegment];
	      while (segs[0].nextSegment) {
	        segs.unshift(segs[0].nextSegment);
	      }
	      _.each(segs, function (seg) {
	        this.removeSegment(seg);
	      }, this);
	
	      this.redrawPolylines();
	      this.map.prevClick = firstPt.point;
	    }
	
	    this.map.drawRouteDistanceMarkers();
	    this.map.loadElevationProfile();
	    this.map.populateCuesheet(this.coursePoints());
	    this.map.snapshot();
	    rwgps.Events.trigger('map:routes_changed');
	    return newRoute;
	  },
	  cropTo: function cropTo(dataSlice) {
	    var tps = this.trackPoints(),
	        firstPt = tps[dataSlice.i],
	        lastPt = tps[dataSlice.i + dataSlice.count - 1];
	    this.createSegmentBoundariesForSlice(dataSlice);
	    // remove segments from outside to inside
	    var segs = [];
	    if (firstPt.prevSegment) {
	      segs.unshift(firstPt.prevSegment);
	      while (segs[0].prevSegment) {
	        segs.unshift(segs[0].prevSegment);
	      }
	    }
	    if (lastPt.nextSegment) {
	      segs.unshift(lastPt.nextSegment);
	      while (segs[0].nextSegment) {
	        segs.unshift(segs[0].nextSegment);
	      }
	    }
	    _.each(segs, function (seg) {
	      this.removeSegment(seg);
	    }, this);
	    this.firstSegment = firstPt.nextSegment;
	    this.segmentsChanged();
	    this.calculateMetrics();
	    this.rebuildBounds();
	
	    // if there are coursepoints attached to the endpoints of our crop get rid of them
	    var firstCp = firstPt.nextSegment.coursePoints[0];
	    if (firstCp && firstCp.trackPoint === firstPt) firstPt.nextSegment.coursePoints.splice(0, 1);
	    var lastCps = lastPt.prevSegment.coursePoints,
	        lastCp = lastCps[lastCps.length - 1];
	    if (lastCp && lastCp.trackPoint === lastPt) lastCps.splice(lastCps.length - 1);
	
	    this.startMarker.gmarker.setPosition(firstPt.googleLatLng());
	    if (this.endMarker) this.endMarker.gmarker.setPosition(lastPt.googleLatLng());
	    this.map.prevClick = dataSlice.lastPoint().point;
	    this.map.drawRouteDistanceMarkers();
	    this.map.loadElevationProfile();
	    this.map.populateCuesheet(this.coursePoints());
	    this.map.snapshot();
	  },
	  removeTrack: function removeTrack() {
	    _.each(this.segments, function (seg) {
	      this.removeSegment(seg);
	    }, this);
	    if (this.active) {
	      this.map.prevClick = null;
	      this.clearStartMarker();
	      this.map.removeRouteDistanceMarkers(this);
	    }
	  },
	  customColorsUsed: function customColorsUsed() {
	    return this.customColors || false;
	  },
	  hasPower: function hasPower() {
	    var rand,
	        hasPower = false,
	        tps = this.trackPoints();
	    for (var i = 0; i < 10; i++) {
	      rand = Math.floor(Math.random() * tps.length);
	      hasPower = tps[rand].watts != null;
	    }
	    return hasPower;
	  },
	  storeRawPower: function storeRawPower() {
	    //avoid overwriting the original
	    if (this.storedPower && this.storedPower.length > 0) return;
	    var tp = this.trackPoints();
	    this.storedPower = new Array(tp.length);
	    for (var i = 0; i < tp.length; i++) {
	      this.storedPower[i] = tp[i].watts;
	    }
	  },
	  restoreRawPower: function restoreRawPower() {
	    if (this.storedPower == null || this.storedPower.length == 0) return;
	    var tp = this.trackPoints();
	    for (var i = 0; i < tp.length; i++) {
	      tp[i].watts = this.storedPower[i];
	    }
	  },
	  replacePowerWithAvg: function replacePowerWithAvg(windowsize) {
	    var tp = this.trackPoints();
	    if (tp.length == 0) return;
	    if (this.hasPower() == false) return;
	
	    //tuck away our original power data so we don't lose it
	    this.storePower();
	
	    var i = 0,
	        j = 0,
	        watts = [];
	    var side = Math.floor((windowsize || 3) / 2);
	    var start = side * -1,
	        end = side;
	
	    for (i = 0; i < tp.length; i++) {
	      var window = [];
	      for (j = start; j <= end; j++) {
	        if (i + j >= 0 && i + j < tp.length) window.push(tp[i + j].watts);
	      }
	      var sum = 0,
	          count = 0;
	      for (j = 0; j < window.length; j++) {
	        if (window[j] != null) {
	          sum += window[j];
	          count += 1;
	        }
	      }
	      //if(sum != undefined && count) watts.push(sum / count);
	      //watts.push(sum && count ? sum / count : tp[i].watts);
	      watts.push(sum / count);
	    }
	
	    for (i = 0; i < tp.length; i++) {
	      tp[i].watts = watts[i];
	    } //return watts;
	  },
	  // need to null out grade figures if we want metrics calculator to recalc grade for us.
	  resetGrade: function resetGrade() {
	    var tps = this._trackPoints;
	    if (!tps) return;
	    for (var i = 0; i < tps.length; i++) {
	      tps[i].grade = tps[i].grade_orig = null;
	    }
	  },
	  flattenBridgesAndTunnels: function flattenBridgesAndTunnels() {
	    var leftI = void 0,
	        rightI = void 0;
	    var flattening = false;
	    var trackPoints = this.trackPoints();
	    var tpLen = trackPoints.length;
	    // use this to smooth boundaries on the assumption that the grade
	    // of ways entering/exiting tunnels and bridges will be smooth
	    var buffer = 20; // meters.
	
	    _.forEach(trackPoints, function (pt, idx) {
	      if (pt.flattened) return; // already flattened this range
	      if (pt.roadEnv && !flattening) {
	        flattening = true;
	        leftI = idx;
	        // last non-bridge/tunnel pt, plus buffer
	        while (trackPoints[idx].distance - trackPoints[leftI].distance < buffer && leftI > 0) {
	          leftI = leftI - 1;
	        }
	      } else if (flattening && pt.roadEnv === 0) {
	        flattening = false;
	        rightI = idx;
	        // first non-bridge/tunnel pt, plus buffer
	        while (trackPoints[rightI].distance - trackPoints[idx].distance < buffer && rightI < tpLen) {
	          rightI = rightI + 1;
	        }
	
	        var firstPt = trackPoints[leftI],
	            lastPt = trackPoints[rightI],
	            domain = "distance",
	            domainOffset = firstPt[domain],
	            mult = (lastPt.ele - firstPt.ele) / (lastPt[domain] - firstPt[domain]);
	        _.forEach(trackPoints.slice(leftI, rightI), function (pt) {
	          pt.ele = (pt[domain] - domainOffset) * mult + firstPt.ele;
	          pt.flattened = true;
	        });
	      }
	    });
	  },
	  trackPoints: function trackPoints() {
	    if (!this._trackPoints) {
	      var pts = [],
	          seg = this.firstSegment;
	      while (seg) {
	        pts.push(seg.prevControlPoint);
	        for (var i = 0; i < seg.trackPoints.length; i++) {
	          pts.push(seg.trackPoints[i]);
	        }
	        if (!seg.nextSegment) pts.push(seg.nextControlPoint);
	        seg = seg.nextSegment;
	      }
	      this._trackPoints = pts;
	    }
	    return this._trackPoints;
	  },
	  coursePoints: function coursePoints() {
	    var pts = [];
	    for (var i = 0; i < this.segments.length; i++) {
	      pts = pts.concat(this.segments[i].coursePoints);
	    }
	    return pts;
	  },
	  elevationGain: function elevationGain() {
	    var total = 0;
	    for (var i = 0; i < this.segments.length; i++) {
	      total += this.segments[i].elevationGain;
	    }
	    return total;
	  },
	  elevationLoss: function elevationLoss() {
	    var total = 0;
	    for (var i = 0; i < this.segments.length; i++) {
	      total += this.segments[i].elevationLoss;
	    }
	    return total;
	  },
	
	  //TODO: maybe change to just 'if(this.map)' ?? make route
	  //and segments aware of their respective maps?
	  isOnMap: function isOnMap() {
	    if (this.startMarker && this.startMarker.gmarker.map || this.endMarker && this.endMarker.gmarker.map || this.segments.length > 0 && this.segments[0].gPolylines[0].map) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	
	  removeFromMap: function removeFromMap() {
	    if (this.startMarker && this.startMarker.gmarker) this.startMarker.gmarker.setMap(null);
	    if (this.endMarker && this.endMarker.gmarker) this.endMarker.gmarker.setMap(null);
	    for (var i = 0; i < this.segments.length; i++) {
	      this.segments[i].gPolylines.forEach(function (pl) {
	        return pl.setMap(null);
	      });
	      this.segments[i].sPolylines.forEach(function (pl) {
	        return pl.setMap(null);
	      });
	      if (this.segments[i].backgroundPolyline) this.segments[i].backgroundPolyline.setMap(null);
	    }
	    for (i = 0; i < this.map.routes.length; i++) {
	      if (this.map.routes[i] == this) {
	        this.map.routes.remove(i, i + 1);
	        break;
	      }
	    }
	  },
	
	  setActive: function setActive() {
	    if (this.active) return;
	    this.active = true;
	    // redraw route so it looks active and has control points
	    this.redraw();
	  },
	
	  setInactive: function setInactive(force) {
	    if (!this.active && !force) return;
	    this.active = false;
	    if (this.map) this.map.removeRouteDistanceMarkers(this);
	    // redraw route so it looks inactive
	    this.redraw();
	  },
	
	  clearConnectionPoint: function clearConnectionPoint() {
	    if (this.connectionPointIcon) this.connectionPointIcon.gmarker.setMap(null);
	  },
	
	  drawConnectionPoint: function drawConnectionPoint() {
	    if (this.connectionPointDisabled) return;
	    var pt = this.trackPoints()[0];
	    if (this.connectionPointIcon) {
	      this.connectionPointIcon.gmarker.setMap(this.map.gmap);
	      this.connectionPointIcon.gmarker.setPosition(pt.googleLatLng());
	      this.connectionPointIcon.trackPoint = pt;
	    } else {
	      var icon = new rwgps.ConnectionPointIcon(pt, this.map);
	      this.connectionPointIcon = icon;
	    }
	  },
	
	  initFromDataJSON: function initFromDataJSON(raw, options) {
	    var data = typeof raw == "string" ? $.evalJSON(raw) : raw;
	    var i = 0,
	        j = 0;
	    var coursePoints = data.course_points || [];
	    var trackPoints = data.track_points || [];
	    this.drawInactive = data.drawInactive === undefined ? true : data.drawInactive;
	    this.connectionPointDisabled = data.connectionPointDisabled;
	    var cps = [],
	        pts = [],
	        segs = [],
	        clickIndexes = [],
	        seg;
	    if (data.id) this.mysqlId = data.id;
	    if (data.mongoid_id) this.mongoidId = data.mongoid_id;
	    if (data.photo_ids && data.photo_ids.length > 0) this.photoIds = data.photo_ids;
	    if (data.user_id) this.userId = data.user_id;
	
	    // NOTE: if we're handed data without surface information, then never draw st on 
	    // 1. tracklines
	    // 2. samplegraph
	    // 3. left sidepanel
	    this.showSurface = rwgps.config.labs.surface_types && (!_.some(trackPoints, function (tp) {
	      return tp['S'] === undefined;
	    }) || trackPoints.length === 0);
	
	    this.name = raw.name;
	
	    this.routeData = {
	      name: raw.name,
	      id: raw.id,
	      description: raw.description,
	      isTrip: options && options.isTrip
	    };
	
	    this.pois = _.map(data.points_of_interest || [], function (poi) {
	      if (_.isFunction(poi.toSaveObj)) {
	        return poi;
	      } else {
	        return rwgps.PointOfInterest.fromJSON([poi], !(options || {}).planning)[0];
	      }
	    });
	
	    var tpsResult = rwgps.TrackPoint.fromJSON(trackPoints, options);
	    pts = tpsResult.trackPoints;
	    if (options && options.isTrip && !_.every(pts, function (tp) {
	      return tp.surface;
	    })) {
	      this.map.injectSurfaces(pts, function () {});
	    }
	    clickIndexes = tpsResult.clickIndexes;
	
	    var startIndex = 1;
	    var prevCp = pts[0];
	    for (i = 0; i < clickIndexes.length; i++) {
	      var endIndex = clickIndexes[i];
	      if (endIndex === 0) continue; // don't allow 0 length initial segment -- seen in wild
	
	      var points = pts.slice(startIndex, endIndex);
	
	      if (trackPoints[endIndex]["color"] != rwgps.Route.ORIGINAL_DEFAULT_LINE_COLOR) {
	        this.customColors = true;
	      }
	
	      seg = new rwgps.Segment(this, prevCp, pts[endIndex], points, null, trackPoints[endIndex]["color"]);
	      seg.clickOptions.setOptions(trackPoints[endIndex]["options"]);
	      segs.push(seg);
	      prevCp = pts[endIndex];
	
	      startIndex = endIndex + 1;
	    }
	
	    //stored trip, no clicks, colors or options
	    //must have trackpoints, else exception happens
	    if (clickIndexes.length == 0 && pts.length > 0) {
	      segs.push(new rwgps.Segment(this, pts[0], pts[pts.length - 1], pts.slice(1, -1)));
	    }
	
	    var cp;
	    for (i = 0; i < coursePoints.length; i++) {
	      cp = coursePoints[i];
	      cps.push(new rwgps.CoursePoint({
	        edited: cp._e,
	        point: { lat: cp.y, lng: cp.x },
	        notes: cp.n,
	        type: cp.t,
	        description: cp.description,
	        trackPointIndex: cp.i,
	        distance: cp.d,
	        photoIds: cp.photo_ids,
	        confirmed: cp.c
	      }));
	    }
	
	    //match coursepoints with trackpoints.
	    var nextStartIndex = 0;
	    for (i = 0; i < cps.length; i++) {
	      cp = cps[i];
	      if (pts[cp.trackPointIndex]) {
	        cp.trackPoint = pts[cp.trackPointIndex];
	      } else {
	        //older route, no trackpointindex, find closest
	        var eps = 0.0001;
	        //var matched = false;
	        for (j = nextStartIndex; j < pts.length; j++) {
	          var tp = pts[j];
	          if (tp.point && Math.abs(cp.point.lat - tp.point.lat) <= eps && Math.abs(cp.point.lng - tp.point.lng) <= eps) {
	            //matched = true;
	            nextStartIndex = j + 1;
	            cp.trackPointIndex = j;
	            cp.trackPoint = tp;
	            break;
	          }
	        }
	        //if(matched == false) trace("no match found");
	      }
	      if (cp.trackPoint) {
	        if (cp.trackPoint.segment) {
	          cp.segment = cp.trackPoint.segment;
	          cp.trackPoint.segment.coursePoints.push(cp);
	        } else {
	          //find a segment to stick the point onto...
	          //needed for semi-common case of coursepoints falling on segment
	          //start/end points, and thus not having an assigned segment
	          if (cp.trackPoint.prevSegment) {
	            cp.segment = cp.trackPoint.prevSegment;
	            cp.trackPoint.prevSegment.coursePoints.push(cp);
	          } else {
	            //if no prev segment, must be the first segment
	            cp.segment = segs[0];
	            segs[0].coursePoints.push(cp);
	          }
	        }
	      }
	    }
	
	    this.rebuildBounds();
	    this.calculateMetrics();
	  },
	  trackPointsForSave: function trackPointsForSave() {
	    var tps = [],
	        seg;
	    for (var j = 0; j < this.segments.length; j++) {
	      seg = this.segments[j];
	      // push first point
	      if (j === 0) tps.push(seg.prevControlPoint.toMiniObj());
	      for (var i = 0; i < seg.trackPoints.length; i++) {
	        var pt = seg.trackPoints[i];
	        tps.push(pt.toMiniObj());
	      }
	      tps.push(seg.nextControlPoint.toMiniObj());
	      tps[tps.length - 1]["options"] = seg.clickOptions.getOptions();
	      tps[tps.length - 1]["color"] = seg.color;
	    }
	    return tps;
	  },
	  coursePointsForSave: function coursePointsForSave() {
	    var trackPoints = this.trackPoints(); //true is for de-duping
	    var coursePoints = this.coursePoints();
	    var cps = [];
	    for (var i = 0; i < coursePoints.length; i++) {
	      var cp = coursePoints[i];
	      cp.trackPointIndex = _.indexOf(trackPoints, cp.trackPoint);
	      cps.push(cp.toMiniObj());
	    }
	    return cps;
	  },
	
	  toSaveObj: function toSaveObj() {
	    return {
	      id: this.mysqlId,
	      name: this.name,
	      active: this.active,
	      track_points: this.trackPointsForSave(),
	      course_points: this.coursePointsForSave(),
	      drawInactive: this.drawInactive,
	      connectionPointDisabled: this.connectionPointDisabled,
	      isTrip: this.routeData && this.routeData.isTrip,
	      showSurface: this.showSurface
	    };
	  },
	
	  metrics: {},
	  calculateMetrics: function calculateMetrics() {
	    // TODO: use this! return rwgps.MetricsCalculator.aggregate.apply(rwgps.MetricsCalculator, _.map(this.segments, function(seg) { return seg.metrics; }));
	    this.metricsCalculator = new rwgps.MetricsCalculator(this.trackPoints());
	    this.metrics = this.metricsCalculator.calculate();
	    _.each(this.coursePoints(), function (cp) {
	      cp.distance = cp.trackPoint.distance;
	    });
	    this.metricsChange();
	  },
	  metricsChangeCallbacks: [],
	  // listen for or trigger metricsChange
	  metricsChange: function metricsChange(fn) {
	    if (fn) {
	      //listen
	      this.metricsChangeCallbacks.push(fn);
	    } else {
	      //trigger
	      var that = this;
	      _.each(this.metricsChangeCallbacks, function (fn) {
	        fn(that);
	      });
	    }
	  },
	
	  removeSegment: function removeSegment(segment) {
	    segment.removeFromMap();
	    segment.prevControlPoint.setNextSegment(null);
	    segment.nextControlPoint.setPrevSegment(null);
	    if (this.firstSegment === segment) this.firstSegment = null;
	    this.segmentsChanged();
	    this.calculateMetrics();
	    this.rebuildBounds();
	  },
	
	  rebuildBounds: function rebuildBounds() {
	    this.gBounds = new google.maps.LatLngBounds();
	    var trackPoints = this.trackPoints();
	    for (var i = 0; i < trackPoints.length; i++) {
	      var tp = trackPoints[i];
	      if (tp.point) this.gBounds.extend(tp.googleLatLng()); //add to our bounds set
	    }
	  },
	
	  drawPreview: function drawPreview() {
	    if (this.previewPolyline) {
	      this.previewPolyline.setMap(this.map.gmap);
	      return;
	    }
	
	    var trackPoints = this.trackPoints();
	    var lls = [];
	    for (var i = 0; i < trackPoints.length; i++) {
	      var tp = trackPoints[i];
	      if (tp.point) lls.push(tp.googleLatLng());
	    }
	    if (lls.length > 0) {
	      var style = this.previewStyle || {
	        strokeColor: '#0000ff',
	        strokeOpacity: 0.4,
	        strokeWeight: 10
	      };
	      this.previewPolyline = new google.maps.Polyline(_.extend(style, {
	        map: this.map.gmap,
	        path: lls,
	        clickable: false
	      }));
	    }
	  },
	  clearPreview: function clearPreview() {
	    if (this.previewPolyline) {
	      this.previewPolyline.setMap(null);
	    }
	  },
	  redraw: function redraw() {
	    this.clearAllOverlays();
	    if (this.active || this.drawInactive) {
	      if (this.active) {
	        if (this.startMarker) this.startMarker.gmarker.setMap(this.map.gmap);else if (this.firstSegment) this.startMarker = new rwgps.StartIcon(this.firstSegment.prevControlPoint.point, this.map);
	        if (this.map.mode === 'view') {
	          if (this.endMarker) this.endMarker.gmarker.setMap(this.map.gmap);else if (this.lastSegment) this.endMarker = new rwgps.EndIcon(this.lastSegment.nextControlPoint.point, this.map);
	        }
	      } else if (this.map.inPlanningMode()) {
	        this.drawConnectionPoint();
	      }
	      this.redrawPolylines();
	    }
	  },
	
	  clearAllOverlays: function clearAllOverlays() {
	    this.clearPreview();
	    this.clearCoursePointMarkers();
	    this.clearStartMarker();
	    this.clearEndMarker();
	    this.clearPolylines();
	    this.clearControlPoints();
	    this.clearConnectionPoint();
	  },
	  clearCoursePointMarkers: function clearCoursePointMarkers() {
	    for (var i = 0; i < this.segments.length; i++) {
	      for (var j = 0; j < this.segments[i].coursePoints.length; j++) {
	        if (this.segments[i].coursePoints[j].marker) this.segments[i].coursePoints[j].marker.gmarker.setMap(null);
	        //TODO: should we null out marker?
	      }
	    }
	  },
	  clearStartMarker: function clearStartMarker() {
	    if (this.startMarker) this.startMarker.gmarker.setMap(null);
	  },
	  clearEndMarker: function clearEndMarker() {
	    if (this.endMarker) this.endMarker.gmarker.setMap(null);
	  },
	  drawPolylines: function drawPolylines(map) {
	    _.each(this.segments, function (seg) {
	      if (seg.gPolylines.length > 0) {
	        if (seg.backgroundPolyline) seg.backgroundPolyline.setMap(map.gmap);
	        seg.gPolylines.forEach(function (pl) {
	          return pl.setMap(map.gmap);
	        });
	        if (map.opts.showSurface) {
	          seg.sPolylines.forEach(function (pl) {
	            return pl.setMap(map.gmap);
	          });
	        }
	      } else {
	        seg.render();
	      }
	    });
	  },
	  clearPolylines: function clearPolylines() {
	    for (var i = 0; i < this.segments.length; i++) {
	      if (this.segments[i].backgroundPolyline) this.segments[i].backgroundPolyline.setMap(null);
	      if (this.segments[i].gPolylines.length > 0) {
	        this.segments[i].gPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	        this.segments[i].sPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	      }
	    }
	  },
	  redrawPolylines: function redrawPolylines() {
	    for (var i = 0; i < this.segments.length; i++) {
	      if (this.segments[i].backgroundPolyline) {
	        this.segments[i].backgroundPolyline.setMap(null);
	        this.segments[i].backgroundPolyline = null;
	      }
	      if (this.segments[i].gPolylines.length > 0) {
	        this.segments[i].gPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	        this.segments[i].gPolylines = [];
	        this.segments[i].sPolylines.forEach(function (pl) {
	          return pl.setMap(null);
	        });
	        this.segments[i].sPolylines = [];
	      }
	    }
	    this.drawPolylines(this.map);
	  },
	
	  recalculatePolylines: function recalculatePolylines() {
	    this.segments.forEach(function (s) {
	      return s.recalculateSurfaces();
	    });
	  },
	
	  //TODO: should segments should own their icon?
	  drawControlPoints: function drawControlPoints(map) {
	    _.each(this.segments, function (seg) {
	      seg.drawControlPoint(map);
	    });
	  },
	  clearControlPoints: function clearControlPoints() {
	    _.each(this.segments, function (seg) {
	      if (seg.controlPointIcon) seg.controlPointIcon.gmarker.setMap(null);
	    });
	  },
	
	  distanceToLatLng: function distanceToLatLng(googleLatLng, map) {
	    // A bunch of this code was copied over from findNearestPoint() in map.js
	    var tps = this.trackPoints();
	    var mousePoint = map.googleLatLngToPoint(googleLatLng);
	    var mouseX = mousePoint.x;
	    var mouseY = mousePoint.y;
	
	    var _routePoints = [];
	    for (var j = 0; j < tps.length; j++) {
	      if (tps[j].point) {
	        var pt = map.googleLatLngToPoint(tps[j].googleLatLng());
	        _routePoints.push(pt.x);
	        _routePoints.push(pt.y);
	        _routePoints.push(tps[j]);
	      } else {
	        _routePoints.push(null);
	        _routePoints.push(null);
	        _routePoints.push(null);
	      }
	    }
	
	    var minDist = Number.MAX_VALUE;
	    var minX = _routePoints[0];
	    var minY = _routePoints[1];
	    var x = minX;
	    var y = minY;
	    var i, lowI;
	    for (i = 0; i < _routePoints.length; i += 3) {
	      var x0 = x;
	      var y0 = y;
	      x = _routePoints[i];
	      y = _routePoints[i + 1];
	
	      if (x == null || y == null) continue;
	
	      var dx = x - x0;
	      var dy = y - y0;
	      var d = dx * dx + dy * dy;
	
	      var u = ((mouseX - x) * dx + (mouseY - y) * dy) / d;
	      var x2 = x + u * dx;
	      var y2 = y + u * dy;
	      var dist = (mouseX - x2) * (mouseX - x2) + (mouseY - y2) * (mouseY - y2);
	      if (dist < minDist) {
	        var d1 = (mouseX - x0) * (mouseX - x0) + (mouseY - y0) * (mouseY - y0);
	        var d2 = (mouseX - x) * (mouseX - x) + (mouseY - y) * (mouseY - y);
	        if (d1 - dist + (d2 - dist) > d) {
	          if (d1 < d2) {
	            dist = d1;
	            x2 = x0;
	            y2 = y0;
	          } else {
	            dist = d2;
	            x2 = x;
	            y2 = y;
	          }
	        }
	      }
	
	      if (dist < minDist) {
	        minDist = dist;
	        minX = x2;
	        minY = y2;
	        lowI = i - 1;
	      }
	    }
	    var lowTpsI = (lowI - 2) / 3,
	        low = tps[lowTpsI];
	
	    if (low && low.point) {
	      return low.distanceFromLatLng({ lat: googleLatLng.lat(), lng: googleLatLng.lng() });
	    }
	  },
	  hasHighlightedSegment: function hasHighlightedSegment() {
	    // return whether all the segments are not supposed to be drawnInactive
	    return !_.every(this.segments, function (segment) {
	      return segment.drawInactive !== true;
	    });
	  }
	};
	var segId = 0;
	rwgps.Segment = function (route, prevControlPoint, nextControlPoint, trackPoints, coursePoints, color) {
	  this._segId = segId++;
	  if (!trackPoints) trackPoints = [];
	  var i = 0;
	
	  // connectors
	  prevControlPoint.setNextSegment(this);
	  nextControlPoint.setPrevSegment(this);
	
	  this.map = route.map;
	  this.distance = 0;
	  this.elevationGain = 0;
	  this.elevationLoss = 0;
	  this.color = _.isNumber(color) && !isNaN(color) ? color : rwgps.Route.DEFAULT_LINE_COLOR;
	  this.clickOptions = new rwgps.ClickOptions();
	  this.gPolylines = [];
	  this.sPolylines = [];
	  this.backgroundPolyline = null;
	  this.trackPoints = trackPoints;
	  this.coursePoints = coursePoints || [];
	  this.controlPointIcon = null;
	  this.distanceMarkers = [];
	
	  //since segments assign distances to trackPoints on creation, we have to
	  //add in the route's current distance to the segs trackpoints when appending
	  //also collect LatLng's for assigning to polyline, as well as bounds
	  this.distance = nextControlPoint.distance - prevControlPoint.distance;
	
	  for (i = 0; i < trackPoints.length; i++) {
	    trackPoints[i].segment = this;
	  }
	
	  this.calculateSurfaceIndices();
	
	  // coursepoints need a ref to segment as well as distance
	  if (coursePoints) {
	    for (i = 0; i < coursePoints.length; i++) {
	      coursePoints[i].segment = this;
	    }
	  }
	  this.route = route;
	  if (!this.prevSegment) {
	    this.route.firstSegment = this;
	  }
	
	  this.detectAndSetExcludeFromMetrics();
	
	  this.route.segmentsChanged(this); // recalc # segments and cache
	  if (this.route.active) this.render();
	};
	
	rwgps.Segment.cssColor = function (color_int) {
	  var color = color_int < 0 ? "0" : color_int.toString(16);
	  while (color.length < 6) {
	    color = "0" + color;
	  }return "#" + color.toUpperCase();
	};
	
	rwgps.Segment.prototype = {
	  calculateSurfaceIndices: function calculateSurfaceIndices() {
	    if (!rwgps.surfaces) {
	      return;
	    }
	    this.surfaceIndices = [];
	    var trackPoints = this.trackPoints;
	    if (!this.prevControlPoint && trackPoints.length === 0 && !this.nextControlPoint) {
	      return;
	    }
	    var toCheck = [];
	    if (this.prevControlPoint.point) toCheck.push(this.prevControlPoint);
	    trackPoints.forEach(function (tp) {
	      tp.point && toCheck.push(tp);
	    });
	    if (this.nextControlPoint.point) toCheck.push(this.nextControlPoint);
	
	    var tp = void 0,
	        thisTpSurfaceGroup = void 0,
	        lastTpSurfaceGroup = rwgps.surfaces.surfaceGroups[toCheck[0].surface];
	    for (var i = 0; i < toCheck.length; i++) {
	      tp = toCheck[i];
	      // SURFACE: add to surfaceIndices when last tp is in a different group than this tp
	      if (rwgps.surfaces && i > 1) {
	        thisTpSurfaceGroup = rwgps.surfaces.surfaceGroups[tp.surface];
	        if (lastTpSurfaceGroup !== thisTpSurfaceGroup) {
	          lastTpSurfaceGroup = thisTpSurfaceGroup;
	          this.surfaceIndices.push(i);
	        }
	      }
	    }
	  },
	
	  detectAndSetExcludeFromMetrics: function detectAndSetExcludeFromMetrics() {
	    // set initial excludeFromMetrics state to enforce data integrity during planning, and properly render while viewing
	    if (this.prevControlPoint.excludeFromMetrics !== this.nextControlPoint.excludeFromMetrics) this.setExcludeFromMetrics(false);else if (this.prevControlPoint.excludeFromMetrics && this.nextControlPoint.excludeFromMetrics) {
	      this.setExcludeFromMetrics(this.trackPoints.length === 0 || this.trackPoints[0].excludeFromMetrics);
	    }
	  },
	
	  setExcludeFromMetrics: function setExcludeFromMetrics(exclude, updateTrackPoints) {
	    this.excludeFromMetrics = exclude;
	
	    // excludeFromMetrics needs to be inclusively set on all points in excluded range.
	    // during planning/editing this method does the property setting, during viewing this is superfluous (values already set properly)
	    //
	    // if a prev/next segment is to remain excluded (and we are un-excluding this segment) then
	    // we can't change the exclude status of our control points, since exclude is set inclusively
	    var controlPointsToChange = [];
	    if (!this.prevSegment || !this.prevSegment.excludeFromMetrics) controlPointsToChange.push(this.prevControlPoint);
	    if (!this.nextSegment || !this.nextSegment.excludeFromMetrics) controlPointsToChange.push(this.nextControlPoint);[controlPointsToChange, this.trackPoints].forEach(function (arr) {
	      arr.forEach(function (tp) {
	        if (updateTrackPoints) {
	          tp.excludeFromMetrics = exclude; // this gets persisted
	          // trackPoint.exclude is not persisted, but tells metrics calc the user was stopped/data was bad (prevents being used in aggregations)
	          if (exclude) {
	            if (tp._exclude === undefined) tp._exclude = !!tp.exclude;
	            tp.exclude = true;
	          } else {
	            if (tp._exclude !== undefined) tp.exclude = tp._exclude;
	          }
	        }
	      });
	    });
	  },
	
	  recalculateSurfaces: function recalculateSurfaces() {
	    this.gPolylines.forEach(function (pl) {
	      return pl.setMap(null);
	    });
	    this.gPolylines = [];
	    this.sPolylines.forEach(function (pl) {
	      return pl.setMap(null);
	    });
	    this.sPolylines = [];
	    this.calculateSurfaceIndices();
	    this.render();
	  },
	
	  showSurface: function showSurface() {
	    // don't draw surface unless we have surface info, regardless of pref
	    if (!this.route.showSurface || !(this.prevControlPoint.surface || this.nextControlPoint.surface || _.some(this.trackPoints, function (p) {
	      return p.surface;
	    }))) {
	      return false;
	    }
	    return this.route.map.opts.showSurface;
	  },
	
	  // draws the polyline, and control point (if required), and adds to map
	  render: function render() {
	    var _this = this;
	
	    if (!this.route.active && (!this.route.map || !this.route.drawInactive)) return;
	    if (this.gPolylines.length > 0) {
	      this.gPolylines.forEach(function (pl) {
	        return pl.setMap(null);
	      });
	    }
	    if (this.sPolylines.length > 0) {
	      this.sPolylines.forEach(function (pl) {
	        return pl.setMap(null);
	      });
	    }
	    if (this.backgroundPolyline) this.backgroundPolyline.setMap(null);
	    var route = this.route;
	    // get some 'local state'
	    var surfaceIndices = this.surfaceIndices && this.surfaceIndices.map(function (i) {
	      return i;
	    });
	    var trackPoints = [];
	    var lls = [];
	    if (this.prevControlPoint.point) {
	      lls.push(this.prevControlPoint.googleLatLng());
	      trackPoints.push(this.prevControlPoint);
	    }
	    for (var i = 0; i < this.trackPoints.length; i++) {
	      var tp = this.trackPoints[i];
	      if (tp.point) {
	        lls.push(tp.googleLatLng());
	        trackPoints.push(tp);
	      }
	    }
	    if (this.nextControlPoint.point) {
	      lls.push(this.nextControlPoint.googleLatLng());
	      trackPoints.push(this.nextControlPoint);
	    }
	    if (this.prevControlPoint.point) {
	      trackPoints.unshift(this.prevControlPoint);
	    }
	    // make sure there's something to render or gmaps will throw errors
	    var slices = [];
	    if (lls.length > 0 && lls[0]) {
	      // SURFACE: slice lls on surface change boundaries so we can render multiple polylines
	      if (this.showSurface() && route.active && surfaceIndices.length > 0) {
	        var lastSIdx = 0;
	        surfaceIndices.forEach(function (sIdx) {
	          // this is sIdx + 1 to avoid gaps
	          slices.push([lls.slice(lastSIdx, sIdx + 1), trackPoints[sIdx - 1].surface]);
	          lastSIdx = sIdx;
	        });
	        slices.push([lls.slice(lastSIdx), trackPoints[trackPoints.length - 1].surface]);
	      } else {
	        var surface = trackPoints.length > 0 ? trackPoints[trackPoints.length - 1].surface : this.nextControlPoint.surface;
	        slices.push([lls, surface]);
	      }
	
	      var style, backgroundStyle;
	      if (route.active && !this.excludeFromMetrics) {
	        slices.forEach(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	              llSlice = _ref2[0],
	              surface = _ref2[1];
	
	          var sliceSurface = rwgps.surfaces && rwgps.surfaces.surfaceGroups['' + surface];
	
	          style = {
	            strokeColor: _this.cssColor(),
	            strokeOpacity: Routes.heatmapEnabled ? 1 : 0.6,
	            strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
	            zIndex: 1
	          };
	
	          if (_this.map.inPlanningMode() && Routes.heatmapEnabled) {
	            // draw route lines with a white casing if the heatmap is on
	            backgroundStyle = {
	              strokeColor: rwgps.Segment.cssColor(0xffffff),
	              strokeOpacity: 1,
	              strokeWeight: 7,
	              zIndex: 0,
	              path: lls,
	              clickable: false
	            };
	            _this.backgroundPolyline = new google.maps.Polyline(backgroundStyle);
	          }
	
	          _this.gPolylines.push(new google.maps.Polyline(_.extend(style, {
	            path: llSlice,
	            clickable: false
	          })));
	
	          if (_this.showSurface() && sliceSurface !== 'paved') {
	            _this.surfacePolyline(llSlice, sliceSurface);
	          }
	        });
	      } else {
	        this.gPolylines.push(new google.maps.Polyline(_.extend(route.inactiveStyle || {
	          strokeColor: '#000000',
	          strokeOpacity: 0.2,
	          strokeWeight: 5
	        }, {
	          path: lls,
	          clickable: false
	        })));
	      }
	      this.addToMap();
	    }
	  },
	  //TODO: memoize for a performance improvement while drawing routes
	  cssColor: function cssColor() {
	    return rwgps.Segment.cssColor(this.color);
	  },
	
	  surfacePolyline: function surfacePolyline(lls, surface) {
	    if (surface === 'unpaved') {
	      var icon = {
	        path: "M 0.5,-1.5 0.5,1.5 -0.5,1.5 -0.5,-1.5",
	        strokeOpacity: 0.9,
	        strokeColor: '#FFFFFF',
	        scale: 1
	      };
	      this.sPolylines.push(new google.maps.Polyline({
	        strokeOpacity: 0,
	        zIndex: 2,
	        path: lls,
	        clickable: false,
	        icons: [{
	          icon: icon,
	          offset: "0",
	          repeat: "6px"
	        }]
	      }));
	    } else {
	      this.sPolylines.push(new google.maps.Polyline({
	        strokeOpacity: 0.9,
	        strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH / 2,
	        strokeColor: '#FFFFFF',
	        zIndex: 2,
	        path: lls,
	        clickable: false
	      }));
	    }
	  },
	
	  drawControlPoint: function drawControlPoint(map) {
	    if (map) this.map = map;else map = this.map;
	
	    if (this.drawInactive) return;
	
	    if (this.controlPointIcon) {
	      this.controlPointIcon.gmarker.setMap(map.gmap);
	      var pt = this.nextControlPoint;
	      this.controlPointIcon.gmarker.setPosition(pt.googleLatLng());
	      this.controlPointIcon.trackPoint = pt;
	    } else {
	      this.redrawControlPoint(map);
	    }
	  },
	
	  redrawControlPoint: function redrawControlPoint(map) {
	    if (this.controlPointIcon) this.controlPointIcon.gmarker.setMap(null);
	    var pt = this.nextControlPoint;
	    var icon = new rwgps.ControlPointIcon(pt, map);
	    this.controlPointIcon = icon;
	  },
	
	  //remove all map overlays from the map by setting to null
	  //TODO: should this also null out this.map or anything else destructive?
	  removeFromMap: function removeFromMap() {
	    if (this.map) {
	      this.map.removeSegmentDistanceMarkers(this);
	      this.map = null;
	    }
	    if (this.gPolylines.length > 0) this.gPolylines.forEach(function (pl) {
	      return pl.setMap(null);
	    });
	    if (this.sPolylines.length > 0) this.sPolylines.forEach(function (pl) {
	      return pl.setMap(null);
	    });
	    if (this.backgroundPolyline) this.backgroundPolyline.setMap(null);
	    if (this.controlPointIcon) this.controlPointIcon.gmarker.setMap(null);
	    for (var i = 0; i < this.coursePoints.length; i++) {
	      var cp = this.coursePoints[i];
	      if (cp.marker && cp.marker.gmarker) this.coursePoints[i].marker.gmarker.setMap(null);
	    }
	  },
	
	  addToMap: function addToMap(map) {
	    var _this2 = this;
	
	    if (map) this.map = map;
	    if (!this.map) return;
	    if (this.backgroundPolyline) this.backgroundPolyline.setMap(this.map.gmap);
	    if (this.gPolylines.length > 0) {
	      this.gPolylines.forEach(function (pl) {
	        pl.setMap(_this2.map.gmap);
	      });
	      if (this.map.opts.showSurface) {
	        this.sPolylines.forEach(function (pl) {
	          return pl.setMap(_this2.map.gmap);
	        });
	      }
	    }
	    if (this.map.showControlPointIcons && this.route.active) {
	      this.drawControlPoint(this.map);
	    }
	  },
	
	  /*
	   *creating a coursepoint manually, we have to insert the coursepoint
	   * in the appropriate place in the route's list
	   */
	  insertCoursePoint: function insertCoursePoint(cp) {
	    for (var i = this.coursePoints.length - 1; i >= 0; i--) {
	      var pt = this.coursePoints[i];
	      if (pt.distance <= cp.distance) {
	        //here is our spot
	        this.coursePoints.splice(i + 1, 0, cp);
	        cp.segment = this;
	        return; //IMPORTANT!  can't fall through, since we add by default
	      }
	    }
	    //fall through - either there are no coursepoints on this segment,
	    //or we tried to add a coursepoint to beginning of segment, before
	    //any other coursepoints.  So, add to beginning
	    this.coursePoints.unshift(cp);
	    cp.segment = this;
	  },
	  removeCoursePoint: function removeCoursePoint(cp) {
	    if (cp.row) cp.row.remove();
	    if (cp.marker && cp.marker.gmarker) cp.marker.gmarker.setMap(null); //remove from the map
	    var idx = _.indexOf(cp.segment.coursePoints, cp);
	    this.coursePoints.splice(idx, 1);
	  },
	  clearCoursePointMarkers: function clearCoursePointMarkers() {
	    for (var j = 0; j < this.coursePoints.length; j++) {
	      if (this.coursePoints[j].marker) this.coursePoints[j].marker.gmarker.setMap(null);
	    }
	  },
	
	  insertTrackPointAfter: function insertTrackPointAfter(point, index) {
	    this.trackPoints.splice(index + 1, 0, point);
	    this.calculateSurfaceIndices();
	    var prevPoint = index < 0 ? this.prevControlPoint : this.trackPoints[index];
	    point.distance = prevPoint.distance + point.distanceFromPoint(prevPoint);
	    point.segment = this;
	    this.route.segmentsChanged();
	  },
	
	  // Before: segment: <cp1,p2,p3,cp4>   this: <cp5,p6,p7,cp8>
	  // After:  <cp1,p2,p3,<cp4>,p5,p6,p7,cp8>
	  connectAfter: function connectAfter(segment) {
	    this.prevControlPoint.ensureNotControlPoint();
	    segment.nextControlPoint.setControlPoint(segment, this);
	  },
	
	  /*
	  * returns the newly created segment. if the segment being split
	  * is on a route, the new segment is automatically spliced into
	  * the route after the old, shortened segment.
	  */
	  splitAfter: function splitAfter(index) {
	    var spliceAt = index + 1;
	    if (spliceAt > this.trackPoints.length - 1) {
	      if (spliceAt > 0 && spliceAt === this.trackPoints.length) {
	        // trying to split after the last point, just back it up and it'll be ok
	        spliceAt--;
	      } else {
	        // either spliceAt is way too big or there are no trackpoints, either way it's no good let's bail
	        return;
	      }
	    }
	
	    var howMany = this.trackPoints.length - spliceAt;
	    var coursePoints = [];
	
	    // reassign any relevant coursepoints
	    for (var i = 0; i < this.coursePoints.length; i++) {
	      var cp = this.coursePoints[i];
	      var cpIdx = _.indexOf(this.trackPoints, cp.trackPoint);
	      if (cpIdx > spliceAt) {
	        coursePoints = this.coursePoints.splice(i);
	        break;
	      }
	    }
	
	    var trackPoints = this.trackPoints.splice(spliceAt, howMany);
	    this.calculateSurfaceIndices();
	    var nextControlPoint = this.nextControlPoint;
	    var prevControlPoint = trackPoints.shift();
	    prevControlPoint.setPrevSegment(this);
	
	    var newSegment = new rwgps.Segment(this.route, prevControlPoint, nextControlPoint, trackPoints, coursePoints, this.color);
	
	    newSegment.clickOptions.setOptions(this.clickOptions.getOptions());
	
	    // gotta make new polylines for the segments using their new points
	    this.render();
	    newSegment.render();
	
	    // if this segment is on a route, we'll auto-add the newsegment onto the route
	    // as well as draw the control point icons (total redraw, inefficient)
	    if (this.route) {
	      // finally, add the control point icon.
	      // TODO: small performance gain for doing this logically (insert and draw 1)
	      this.route.clearControlPoints();
	      if (this.map && this.map.mode != 'view') {
	        this.route.drawControlPoints(this.map);
	      }
	    }
	    return newSegment;
	  },
	
	  /*
	  * merge with subsequent segment in route
	  */
	  slurpNext: function slurpNext() {
	    // absorb the control point and next segment's trackpoints and coursepoints
	    var nextSegment = this.nextSegment;
	    if (!nextSegment) return; // end of the line
	    this.coursePoints = this.coursePoints.concat(nextSegment.coursePoints);
	    var absorbedControlPoint = this.nextControlPoint;
	    absorbedControlPoint.ensureNotControlPoint();
	    absorbedControlPoint.segment = this;
	    this.trackPoints.push(absorbedControlPoint);
	    this.trackPoints = this.trackPoints.concat(nextSegment.trackPoints);
	    // make sure the trackpoints and coursepoints reference this segment now
	    for (var i = 0, len = nextSegment.coursePoints.length; i < len; i++) {
	      nextSegment.coursePoints[i].segment = this;
	    }
	    for (i = 0, len = nextSegment.trackPoints.length; i < len; i++) {
	      nextSegment.trackPoints[i].segment = this;
	    }
	    // tell the next control point who owns it now
	    nextSegment.nextControlPoint.setPrevSegment(this);
	
	    //gotta make new polylines for the segments using their new points
	    nextSegment.removeFromMap();
	    this.render();
	
	    this.route.segmentsChanged(); // recalc # segments and cache
	  }
	};
	rwgps.Segment.fillTheCracks = function (rawPoints) {
	  var points = [];
	
	  for (var i = 1; i < rawPoints.length; i++) {
	    var first = rawPoints[i - 1];
	    var last = rawPoints[i];
	    var distance = last.distanceFromPoint(first);
	    var numPoints = Math.floor(distance / 1000 * 10.0);
	    var yDistance = last.point.lat - first.point.lat;
	    var xDistance = last.point.lng - first.point.lng;
	    var latTicksPerDiv = yDistance / numPoints;
	    var lngTicksPerDiv = xDistance / numPoints;
	    var lat = first.point.lat;
	    var lng = first.point.lng;
	    points.push(first);
	
	    // Ok, so now we know the x and y spacings between points, we can find
	    // points on the hypotenuse that is the line between our two real points
	    for (var j = 0; j < numPoints; j++) {
	      var tp = new rwgps.TrackPoint({ point: { lat: lat, lng: lng } });
	      if (rwgps.config.labs.surface_types && rwgps.config.labs.route_planner) {
	        // SURFACE: 99 is 'unknown'
	        tp.surface = 99;
	        tp.ghSurface = 99;
	      }
	      points.push(tp);
	      lat += latTicksPerDiv;
	      lng += lngTicksPerDiv;
	    }
	  }
	  points.push(rawPoints[rawPoints.length - 1]);
	  return points;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	var rwgpsG_md5;
	(function () {
	  var MD5 = function MD5() {
	    function md5cycle(x, k) {
	      var a = x[0],
	          b = x[1],
	          c = x[2],
	          d = x[3];
	
	      a = ff(a, b, c, d, k[0], 7, -680876936);
	      d = ff(d, a, b, c, k[1], 12, -389564586);
	      c = ff(c, d, a, b, k[2], 17, 606105819);
	      b = ff(b, c, d, a, k[3], 22, -1044525330);
	      a = ff(a, b, c, d, k[4], 7, -176418897);
	      d = ff(d, a, b, c, k[5], 12, 1200080426);
	      c = ff(c, d, a, b, k[6], 17, -1473231341);
	      b = ff(b, c, d, a, k[7], 22, -45705983);
	      a = ff(a, b, c, d, k[8], 7, 1770035416);
	      d = ff(d, a, b, c, k[9], 12, -1958414417);
	      c = ff(c, d, a, b, k[10], 17, -42063);
	      b = ff(b, c, d, a, k[11], 22, -1990404162);
	      a = ff(a, b, c, d, k[12], 7, 1804603682);
	      d = ff(d, a, b, c, k[13], 12, -40341101);
	      c = ff(c, d, a, b, k[14], 17, -1502002290);
	      b = ff(b, c, d, a, k[15], 22, 1236535329);
	
	      a = gg(a, b, c, d, k[1], 5, -165796510);
	      d = gg(d, a, b, c, k[6], 9, -1069501632);
	      c = gg(c, d, a, b, k[11], 14, 643717713);
	      b = gg(b, c, d, a, k[0], 20, -373897302);
	      a = gg(a, b, c, d, k[5], 5, -701558691);
	      d = gg(d, a, b, c, k[10], 9, 38016083);
	      c = gg(c, d, a, b, k[15], 14, -660478335);
	      b = gg(b, c, d, a, k[4], 20, -405537848);
	      a = gg(a, b, c, d, k[9], 5, 568446438);
	      d = gg(d, a, b, c, k[14], 9, -1019803690);
	      c = gg(c, d, a, b, k[3], 14, -187363961);
	      b = gg(b, c, d, a, k[8], 20, 1163531501);
	      a = gg(a, b, c, d, k[13], 5, -1444681467);
	      d = gg(d, a, b, c, k[2], 9, -51403784);
	      c = gg(c, d, a, b, k[7], 14, 1735328473);
	      b = gg(b, c, d, a, k[12], 20, -1926607734);
	
	      a = hh(a, b, c, d, k[5], 4, -378558);
	      d = hh(d, a, b, c, k[8], 11, -2022574463);
	      c = hh(c, d, a, b, k[11], 16, 1839030562);
	      b = hh(b, c, d, a, k[14], 23, -35309556);
	      a = hh(a, b, c, d, k[1], 4, -1530992060);
	      d = hh(d, a, b, c, k[4], 11, 1272893353);
	      c = hh(c, d, a, b, k[7], 16, -155497632);
	      b = hh(b, c, d, a, k[10], 23, -1094730640);
	      a = hh(a, b, c, d, k[13], 4, 681279174);
	      d = hh(d, a, b, c, k[0], 11, -358537222);
	      c = hh(c, d, a, b, k[3], 16, -722521979);
	      b = hh(b, c, d, a, k[6], 23, 76029189);
	      a = hh(a, b, c, d, k[9], 4, -640364487);
	      d = hh(d, a, b, c, k[12], 11, -421815835);
	      c = hh(c, d, a, b, k[15], 16, 530742520);
	      b = hh(b, c, d, a, k[2], 23, -995338651);
	
	      a = ii(a, b, c, d, k[0], 6, -198630844);
	      d = ii(d, a, b, c, k[7], 10, 1126891415);
	      c = ii(c, d, a, b, k[14], 15, -1416354905);
	      b = ii(b, c, d, a, k[5], 21, -57434055);
	      a = ii(a, b, c, d, k[12], 6, 1700485571);
	      d = ii(d, a, b, c, k[3], 10, -1894986606);
	      c = ii(c, d, a, b, k[10], 15, -1051523);
	      b = ii(b, c, d, a, k[1], 21, -2054922799);
	      a = ii(a, b, c, d, k[8], 6, 1873313359);
	      d = ii(d, a, b, c, k[15], 10, -30611744);
	      c = ii(c, d, a, b, k[6], 15, -1560198380);
	      b = ii(b, c, d, a, k[13], 21, 1309151649);
	      a = ii(a, b, c, d, k[4], 6, -145523070);
	      d = ii(d, a, b, c, k[11], 10, -1120210379);
	      c = ii(c, d, a, b, k[2], 15, 718787259);
	      b = ii(b, c, d, a, k[9], 21, -343485551);
	
	      x[0] = add32(a, x[0]);
	      x[1] = add32(b, x[1]);
	      x[2] = add32(c, x[2]);
	      x[3] = add32(d, x[3]);
	    }
	
	    function cmn(q, a, b, x, s, t) {
	      a = add32(add32(a, q), add32(x, t));
	      return add32(a << s | a >>> 32 - s, b);
	    }
	
	    function ff(a, b, c, d, x, s, t) {
	      return cmn(b & c | ~b & d, a, b, x, s, t);
	    }
	
	    function gg(a, b, c, d, x, s, t) {
	      return cmn(b & d | c & ~d, a, b, x, s, t);
	    }
	
	    function hh(a, b, c, d, x, s, t) {
	      return cmn(b ^ c ^ d, a, b, x, s, t);
	    }
	
	    function ii(a, b, c, d, x, s, t) {
	      return cmn(c ^ (b | ~d), a, b, x, s, t);
	    }
	
	    function md51(s) {
	      var n = s.length,
	          state = [1732584193, -271733879, -1732584194, 271733878],
	          i;
	      for (i = 64; i <= s.length; i += 64) {
	        md5cycle(state, md5blk(s.substring(i - 64, i)));
	      }
	      s = s.substring(i - 64);
	      var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	      for (i = 0; i < s.length; i++) {
	        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
	      }tail[i >> 2] |= 0x80 << (i % 4 << 3);
	      if (i > 55) {
	        md5cycle(state, tail);
	        for (i = 0; i < 16; i++) {
	          tail[i] = 0;
	        }
	      }
	      tail[14] = n * 8;
	      md5cycle(state, tail);
	      return state;
	    }
	
	    /* there needs to be support for Unicode here,
	    * unless we pretend that we can redefine the MD-5
	    * algorithm for multi-byte characters (perhaps
	    * by adding every four 16-bit characters and
	    * shortening the sum to 32 bits). Otherwise
	    * I suggest performing MD-5 as if every character
	    * was two bytes--e.g., 0040 0025 = @%--but then
	    * how will an ordinary MD-5 sum be matched?
	    * There is no way to standardize text to something
	    * like UTF-8 before transformation; speed cost is
	    * utterly prohibitive. The JavaScript standard
	    * itself needs to look at this: it should start
	    * providing access to strings as preformed UTF-8
	    * 8-bit unsigned value arrays.
	    */
	    function md5blk(s) {
	      /* I figured global was faster.   */
	      var md5blks = [],
	          i; /* Andy King said do it this way. */
	      for (i = 0; i < 64; i += 4) {
	        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
	      }
	      return md5blks;
	    }
	
	    var hex_chr = '0123456789abcdef'.split('');
	
	    function rhex(n) {
	      var s = '',
	          j = 0;
	      for (; j < 4; j++) {
	        s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
	      }return s;
	    }
	
	    function hex(x) {
	      for (var i = 0; i < x.length; i++) {
	        x[i] = rhex(x[i]);
	      }return x.join('');
	    }
	
	    function md5(s) {
	      return hex(md51(str2rstr_utf8(s)));
	    }
	
	    /* this function is much faster,
	    so if possible we use it. Some IEs
	    are the only ones I know of that
	    need the idiotic second function,
	    generated by an if clause.  */
	    function add32(a, b) {
	      return a + b & 0xFFFFFFFF;
	    }
	
	    if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
	      var _add = function _add(x, y) {
	        // eslint-disable-line 
	        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return msw << 16 | lsw & 0xFFFF;
	      };
	    }
	
	    this.hexdigest = md5;
	  };
	  /*
	   * Encode a string as utf-8.
	   * For efficiency, this assumes the input is valid utf-16.
	   */
	  function str2rstr_utf8(input) {
	    var output = "";
	    var i = -1;
	    var x, y;
	
	    while (++i < input.length) {
	      /* Decode utf-16 surrogate pairs */
	      x = input.charCodeAt(i);
	      y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
	      if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
	        x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
	        i++;
	      }
	
	      /* Encode output as utf-8 */
	      if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
	    }
	    return output;
	  }
	
	  rwgpsG_md5 = { MD5: new MD5() };
	})();
	
	_.extend(rwgps, rwgpsG_md5);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	/**
	 * @name InfoBox
	 * @version 1.1.5 [March 1, 2011]
	 * @author Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
	 * @copyright Copyright 2010 Gary Little [gary at luxcentral.com]
	 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
	 *  <p>
	 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
	 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
	 *  <p>
	 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
	 *  <p>
	 *  Browsers tested:
	 *  <p>
	 *  Mac -- Safari (4.0.4), Firefox (3.6), Opera (10.10), Chrome (4.0.249.43), OmniWeb (5.10.1)
	 *  <br>
	 *  Win -- Safari, Firefox, Opera, Chrome (3.0.195.38), Internet Explorer (8.0.6001.18702)
	 *  <br>
	 *  iPod Touch/iPhone -- Safari (3.1.2)
	 */
	
	/*!
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *       http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/*jslint browser:true */
	/*global google */
	
	/**
	 * @name InfoBoxOptions
	 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
	 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
	 * @property {boolean} disableAutoPan Disable auto-pan on <tt>open</tt> (default is <tt>false</tt>).
	 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
	 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
	 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
	 *  to the map pixel corresponding to <tt>position</tt>.
	 * @property {LatLng} position The geographic location at which to display the InfoBox.
	 * @property {number} zIndex The CSS z-index style value for the InfoBox.
	 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
	 * @property {string} boxClass The name of the CSS class defining the styles for the InfoBox container.
	 *  The default name is <code>infoBox</code>.
	 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
	 *  style values to be applied to the InfoBox. Style values defined here override those that may
	 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
	 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
	 *  are removed from the InfoBox before the new style values are applied.
	 * @property {string} closeBoxMargin The CSS margin style value for the close box.
	 *  The default is "2px" (a 2-pixel margin on all sides).
	 * @property {string} closeBoxURL The URL of the image representing the close box.
	 *  Note: The default is the URL for Google's standard close box.
	 *  Set this property to "" if no close box is required.
	 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
	 *  map edge after an auto-pan.
	 * @property {boolean} isHidden Hide the InfoBox on <tt>open</tt> (default is <tt>false</tt>).
	 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
	 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
	 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
	 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
	 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
	 * @property {boolean} enableEventPropagation Propagate mousedown, click, dblclick,
	 *  and contextmenu events in the InfoBox (default is <tt>false</tt> to mimic the behavior
	 *  of a <tt>google.maps.InfoWindow</tt>). Set this property to <tt>true</tt> if the InfoBox
	 *  is being used as a map label. iPhone note: This property setting has no effect; events are
	 *  always propagated.
	 */
	
	/**
	 * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
	 *  Call <tt>InfoBox.open</tt> to add the box to the map.
	 * @constructor
	 * @param {InfoBoxOptions} [opt_opts]
	 */
	function InfoBox(opt_opts) {
	  if (!InfoBox.prototype.setValues) {
	    // Use the hack described at https://github.com/googlemaps/js-map-label/issues/1
	    // to allow for async loading of google.maps
	    for (var prop in google.maps.OverlayView.prototype) {
	        InfoBox.prototype[prop] = google.maps.OverlayView.prototype[prop];
	    }
	  }
	
	  opt_opts = opt_opts || {};
	
	  google.maps.OverlayView.apply(this, arguments);
	
	  // Standard options (in common with google.maps.InfoWindow):
	  //
	  this.content_ = opt_opts.content || "";
	  this.disableAutoPan_ = opt_opts.disableAutoPan || false;
	  this.maxWidth_ = opt_opts.maxWidth || 0;
	  this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
	  this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
	  this.zIndex_ = opt_opts.zIndex || null;
	
	  // Additional options (unique to InfoBox):
	  //
	  this.boxClass_ = opt_opts.boxClass || "infoBox";
	  this.boxStyle_ = opt_opts.boxStyle || {};
	  this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
	  this.closeBoxURL_ = opt_opts.closeBoxURL || "https://www.google.com/intl/en_us/mapfiles/close.gif";
	  if (opt_opts.closeBoxURL === "") {
	    this.closeBoxURL_ = "";
	  }
	  this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);
	  this.isHidden_ = opt_opts.isHidden || false;
	  this.alignBottom_ = opt_opts.alignBottom || false;
	  this.pane_ = opt_opts.pane || "floatPane";
	  this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;
	
	  this.div_ = null;
	  this.closeListener_ = null;
	  this.eventListeners_ = [];
	  this.moveListener_ = null;
	  this.contextListener_ = null;
	  this.fixedWidthSet_ = null;
	}
	
	InfoBox.mouseFilter = function(e) {
	  trace("RAD")
	    e.returnValue = 'true';
	      e['handled'] = true;
	}
	
	/**
	 * Creates the DIV representing the InfoBox.
	 * @private
	 */
	InfoBox.prototype.createInfoBoxDiv_ = function () {
	  var bw;
	  var me = this;
	
	  // This handler prevents an event in the InfoBox from being passed on to the map.
	  var cancelHandler = function (e) {
	    e.cancelBubble = true;
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    }
	  };
	
	  // This handler ignores the current event in the InfoBox and conditionally prevents
	  // the event from being passed on to the map. It is used for the contextmenu event.
	  var ignoreHandler = function (e) {
	    e.returnValue = false;
	    if (e.preventDefault) {
	      e.preventDefault();
	    }
	
	    if (!me.enableEventPropagation_) {
	      cancelHandler(e);
	    }
	  };
	
	  var aroundHandler = function(e) {
	  }
	
	  var panes = this.getPanes();
	  var div = this.div_;
	
	  if (!this.div_) {
	    div = this.div_ = document.createElement("div");
	    var contentDiv = this.contentDiv_ = document.createElement('div');
	
	    this.setBoxStyle_();
	    div.style.overflow = 'auto';
	
	    if (typeof this.content_.nodeType === "undefined") {
	      this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
	    } else {
	      this.div_.innerHTML = this.getCloseBoxImg_();
	      this.div_.appendChild(contentDiv);
	    }
	
	    // Add the InfoBox DIV to the DOM
	    document.body.appendChild(div);
	    panes[this.pane_].appendChild(this.div_);
	
	    this.addClickHandler_();
	
	    if (this.div_.style.width) {
	      this.fixedWidthSet_ = true;
	    } else {
	      if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {
	        this.div_.style.width = this.maxWidth_;
	        this.div_.style.overflow = "auto";
	        this.fixedWidthSet_ = true;
	      } else { // The following code is needed to overcome problems with MSIE
	        bw = this.getBoxWidths_();
	
	        this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
	        this.fixedWidthSet_ = false;
	      }
	    }
	
	    this.panBox_(this.disableAutoPan_);
	
	    var events = ["mousedown", "mouseover", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove", 'wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll']
	    var handler = aroundHandler;
	    if (!this.enableEventPropagation_) {
	      handler = cancelHandler;
	    } else {
	    }
	    this.eventListeners_ = [];
	    for(var i = 0; i < events.length; i++) {
	      this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], handler));
	    }
	
	    //this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);
	
	    /**
	     * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
	     * @name InfoBox#domready
	     * @event
	     */
	    google.maps.event.trigger(this, "domready");
	  } else if(this.div_.parentNode != panes[this.pane_]) {
	    this.div_.parentNode.removeChild(this.div_);
	    panes[this.pane_].appendChild(this.div_);
	  }
	};
	
	/**
	 * Returns the HTML <IMG> tag for the close box.
	 * @private
	 */
	InfoBox.prototype.getCloseBoxImg_ = function () {
	  var img = "";
	
	  if (this.closeBoxURL_ !== "") {
	    img  = "<img";
	    img += " src='" + this.closeBoxURL_ + "'";
	    img += " align=right"; // Do this because Opera chokes on style='float: right;'
	    img += " style='";
	    img += " position: relative;"; // Required by MSIE
	    img += " cursor: pointer;";
	    img += " margin: " + this.closeBoxMargin_ + ";";
	    img += "'>";
	  }
	
	  return img;
	};
	
	/**
	 * Adds the click handler to the InfoBox close box.
	 * @private
	 */
	InfoBox.prototype.addClickHandler_ = function () {
	  var closeBox;
	
	  if (this.closeBoxURL_ !== "") {
	    closeBox = this.div_.firstChild;
	    this.closeListener_ = google.maps.event.addDomListener(closeBox, 'click', this.getCloseClickHandler_());
	
	  } else {
	
	    this.closeListener_ = null;
	  }
	};
	
	/**
	 * Returns the function to call when the user clicks the close box of an InfoBox.
	 * @private
	 */
	InfoBox.prototype.getCloseClickHandler_ = function () {
	  var me = this;
	
	  return function (e) {
	    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
	    e.cancelBubble = true;
	
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    }
	
	    me.close();
	
	    /**
	     * This event is fired when the InfoBox's close box is clicked.
	     * @name InfoBox#closeclick
	     * @event
	     */
	    google.maps.event.trigger(me, "closeclick");
	  };
	};
	
	/**
	 * Pans the map so that the InfoBox appears entirely within the map's visible area.
	 * @private
	 */
	InfoBox.prototype.panBox_ = function (disablePan) {
	  var map;
	  var bounds;
	  var xOffset = 0, yOffset = 0;
	
	  if (!disablePan) {
	    map = this.getMap();
	
	    if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama
	      if (!map.getBounds().contains(this.position_)) {
	      // Marker not in visible area of map, so set center
	      // of map to the marker position first.
	        map.setCenter(this.position_);
	      }
	
	      bounds = map.getBounds();
	
	      var mapDiv = map.getDiv();
	      var mapWidth = mapDiv.offsetWidth;
	      var mapHeight = mapDiv.offsetHeight;
	      var iwOffsetX = this.pixelOffset_.width;
	      var iwOffsetY = this.pixelOffset_.height;
	      var iwWidth = this.div_.offsetWidth;
	      var iwHeight = this.div_.offsetHeight;
	      var padX = this.infoBoxClearance_.width;
	      var padY = this.infoBoxClearance_.height;
	      var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);
	
	      if (pixPosition.x < (-iwOffsetX + padX)) {
	        xOffset = pixPosition.x + iwOffsetX - padX;
	      } else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
	        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
	      }
	      if (this.alignBottom_) {
	        if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
	          yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
	        } else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
	          yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
	        }
	      } else {
	        if (pixPosition.y < (-iwOffsetY + padY)) {
	          yOffset = pixPosition.y + iwOffsetY - padY;
	        } else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
	          yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
	        }
	      }
	
	      if (!(xOffset === 0 && yOffset === 0)) {
	        // Move the map to the shifted center.
	        var c = map.getCenter();
	        map.panBy(xOffset, yOffset);
	      }
	    }
	  }
	};
	
	/**
	 * Sets the style of the InfoBox by setting the style sheet and applying
	 * other specific styles requested.
	 * @private
	 */
	InfoBox.prototype.setBoxStyle_ = function () {
	  var i, boxStyle;
	
	  if (this.div_) {
	    // Apply style values from the style sheet defined in the boxClass parameter:
	    this.div_.className = this.boxClass_;
	
	    // Clear existing inline style values:
	    this.div_.style.cssText = "";
	
	    // Apply style values defined in the boxStyle parameter:
	    boxStyle = this.boxStyle_;
	    for (i in boxStyle) {
	      if (boxStyle.hasOwnProperty(i)) {
	        this.div_.style[i] = boxStyle[i];
	      }
	    }
	
	    // Fix up opacity style for benefit of MSIE:
	    //
	    if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
	      this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
	    }
	
	    // Apply required styles:
	    //
	    this.div_.style.position = "absolute";
	    //this.div_.style.visibility = 'hidden';
	    if (this.zIndex_ !== null) {
	      this.div_.style.zIndex = this.zIndex_;
	    }
	  }
	};
	
	/**
	 * Get the widths of the borders of the InfoBox.
	 * @private
	 * @return {Object} widths object (top, bottom left, right)
	 */
	InfoBox.prototype.getBoxWidths_ = function () {
	  var computedStyle;
	  var bw = {top: 0, bottom: 0, left: 0, right: 0};
	  var box = this.div_;
	
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");
	
	    if (computedStyle) {
	      // The computed styles are always in pixel units (good!)
	      bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
	      bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
	      bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
	      bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
	    }
	  } else if (document.documentElement.currentStyle) { // MSIE
	    if (box.currentStyle) {
	      // The current styles may not be in pixel units, but assume they are (bad!)
	      bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
	      bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
	      bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
	      bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
	    }
	  }
	
	  return bw;
	};
	
	/**
	 * Invoked when <tt>close</tt> is called. Do not call it directly.
	 */
	InfoBox.prototype.onRemove = function () {
	  if (this.div_) {
	    this.div_.parentNode.removeChild(this.div_);
	    this.div_ = null;
	  }
	};
	
	InfoBox.prototype.onAdd = function() {
	  this.createInfoBoxDiv_();
	}
	
	/**
	 * Draws the InfoBox based on the current map projection and zoom level.
	 */
	InfoBox.prototype.draw = function () {
	  var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);
	
	  this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";
	
	  if (this.alignBottom_) {
	    this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
	  } else {
	    this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
	  }
	
	  if (this.isHidden_) {
	    this.div_.style.visibility = 'hidden';
	  } else {
	    this.div_.style.visibility = "visible";
	  }
	};
	
	/**
	 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
	 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
	 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
	 *  is <tt>open</tt>ed.
	 * @param {InfoBoxOptions} opt_opts
	 */
	InfoBox.prototype.setOptions = function (opt_opts) {
	  if (typeof opt_opts.boxClass !== "undefined") { // Must be first
	    this.boxClass_ = opt_opts.boxClass;
	    this.setBoxStyle_();
	  }
	  if (typeof opt_opts.boxStyle !== "undefined") { // Must be second
	    this.boxStyle_ = opt_opts.boxStyle;
	    this.setBoxStyle_();
	  }
	  if (typeof opt_opts.content !== "undefined") {
	    this.setContent(opt_opts.content);
	  }
	  if (typeof opt_opts.disableAutoPan !== "undefined") {
	    this.disableAutoPan_ = opt_opts.disableAutoPan;
	  }
	  if (typeof opt_opts.maxWidth !== "undefined") {
	    this.maxWidth_ = opt_opts.maxWidth;
	  }
	  if (typeof opt_opts.pixelOffset !== "undefined") {
	    this.pixelOffset_ = opt_opts.pixelOffset;
	  }
	  if (typeof opt_opts.position !== "undefined") {
	    this.setPosition(opt_opts.position);
	  }
	  if (typeof opt_opts.zIndex !== "undefined") {
	    this.setZIndex(opt_opts.zIndex);
	  }
	  if (typeof opt_opts.closeBoxMargin !== "undefined") {
	    this.closeBoxMargin_ = opt_opts.closeBoxMargin;
	  }
	  if (typeof opt_opts.closeBoxURL !== "undefined") {
	    this.closeBoxURL_ = opt_opts.closeBoxURL;
	  }
	  if (typeof opt_opts.infoBoxClearance !== "undefined") {
	    this.infoBoxClearance_ = opt_opts.infoBoxClearance;
	  }
	  if (typeof opt_opts.isHidden !== "undefined") {
	    this.isHidden_ = opt_opts.isHidden;
	  }
	  if (typeof opt_opts.enableEventPropagation !== "undefined") {
	    this.enableEventPropagation_ = opt_opts.enableEventPropagation;
	  }
	
	  if (this.div_) {
	    this.draw();
	  }
	};
	
	/**
	 * Sets the content of the InfoBox.
	 *  The content can be plain text or an HTML DOM node.
	 * @param {string|Node} content
	 */
	InfoBox.prototype.setContent = function (content) {
	  this.content_ = content;
	
	  if (this.div_ && this.contentDiv_) {
	    if (this.closeListener_) {
	      google.maps.event.removeListener(this.closeListener_);
	      this.closeListener_ = null;
	    }
	
	    // Odd code required to make things work with MSIE.
	    if (!this.fixedWidthSet_) {
	      this.div_.style.width = "";
	    }
	
	    if (typeof content.nodeType === "undefined") {
	      this.contentDiv_.innerHTML = content;
	    } else {
	      this.contentDiv_.innerHTML = '';
	      this.contentDiv_.appendChild(content);
	    }
	
	    // Perverse code required to make things work with MSIE.
	    // (Ensures the close box does, in fact, float to the right.)
	    if (!this.fixedWidthSet_) {
	      this.div_.style.width = this.div_.offsetWidth + "px";
	      this.div_.innerHTML = this.contentDiv_;
	      //this.div_.innerHTML = this.getCloseBoxImg_() + content;
	    }
	
	    this.addClickHandler_();
	  } else {
	    this.createInfoBoxDiv_();
	  }
	
	  /**
	   * This event is fired when the content of the InfoBox changes.
	   * @name InfoBox#content_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "content_changed");
	};
	
	/**
	 * Sets the geographic location of the InfoBox.
	 * @param {LatLng} latlng
	 */
	InfoBox.prototype.setPosition = function (latlng) {
	  this.position_ = latlng;
	
	  if (this.div_) {
	    this.draw();
	  }
	
	  /**
	   * This event is fired when the position of the InfoBox changes.
	   * @name InfoBox#position_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "position_changed");
	};
	
	/**
	 * Sets the zIndex style for the InfoBox.
	 * @param {number} index
	 */
	InfoBox.prototype.setZIndex = function (index) {
	  this.zIndex_ = index;
	
	  if (this.div_) {
	    this.div_.style.zIndex = index;
	  }
	
	  /**
	   * This event is fired when the zIndex of the InfoBox changes.
	   * @name InfoBox#zindex_changed
	   * @event
	   */
	  google.maps.event.trigger(this, "zindex_changed");
	};
	
	/**
	 * Returns the content of the InfoBox.
	 * @returns {string}
	 */
	InfoBox.prototype.getContent = function () {
	  return this.content_;
	};
	
	/**
	 * Returns the geographic location of the InfoBox.
	 * @returns {LatLng}
	 */
	InfoBox.prototype.getPosition = function () {
	  return this.position_;
	};
	
	/**
	 * Returns the zIndex for the InfoBox.
	 * @returns {number}
	 */
	InfoBox.prototype.getZIndex = function () {
	  return this.zIndex_;
	};
	
	/**
	 * Shows the InfoBox.
	 */
	InfoBox.prototype.show = function () {
	  this.isHidden_ = false;
	  if (this.div_) {
	    this.div_.style.visibility = "visible";
	  }
	};
	
	/**
	 * Hides the InfoBox.
	 */
	InfoBox.prototype.hide = function () {
	  this.isHidden_ = true;
	  if (this.div_) {
	    this.div_.style.visibility = "hidden";
	  }
	};
	
	/**
	 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
	 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
	 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
	 *  anchor is dragged to a new location, the InfoBox moves as well.
	 * @param {Map|StreetViewPanorama} map
	 * @param {MVCObject} [anchor]
	 */
	InfoBox.prototype.open = function (map, anchor) {
	  var me = this;
	
	  if (anchor) {
	    this.position_ = anchor.getPosition();
	    this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
	      me.setPosition(this.getPosition());
	    });
	  }
	
	  this.setMap(map);
	
	  if (this.div_) {
	    this.panBox_();
	  }
	};
	
	/**
	 * Removes the InfoBox from the map.
	 */
	InfoBox.prototype.close = function () {
	  if (this.closeListener_) {
	    google.maps.event.removeListener(this.closeListener_);
	    this.closeListener_ = null;
	  }
	
	  if (this.eventListeners_ && this.eventListeners_.length > 0) {
	    for(var i = 0; i < this.eventListeners_.length; i++) {
	      google.maps.event.removeListener(this.eventListeners_[i]);
	    }
	    this.eventListeners_ = []
	  }
	
	  if (this.moveListener_) {
	    google.maps.event.removeListener(this.moveListener_);
	    this.moveListener_ = null;
	  }
	
	  if (this.contextListener_) {
	    google.maps.event.removeListener(this.contextListener_);
	    this.contextListener_ = null;
	  }
	
	  this.setMap(null);
	};
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = InfoBox;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["InfoBox"] = __webpack_require__(23);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["rwgpsG_js_maps_actions"] = __webpack_require__(5);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// map-bef7ae31875e9b4d44ec-bundle.js